import React, {useCallback, useEffect, useRef, useState} from 'react';
import '../../../css/web/AdminRegModal.css';
import {AiOutlineMinusSquare, AiOutlinePlusSquare} from "react-icons/ai";
import axios from '../../../services/axiosInstance';
import MsgSelectModal from "./MsgSelectModal";
import {useWebSocket} from "../../../services/WebsocketContext";
import CommonLoading from "./CommonLoading";
import maCateImg from "../../../assets/img/m-a-cate.png";
import orderIMG from "../../../assets/img/mypgPayinfo.png";
import {IoIosArrowDropdown} from "@react-icons/all-files/io/IoIosArrowDropdown";
import {IoIosArrowDropright} from "@react-icons/all-files/io/IoIosArrowDropright";
import {BiCaretDown} from "react-icons/bi";
import {FiMinus, FiPlus, FiX} from "react-icons/fi";
import fedexLogo from '../../../assets/img/FedexLogo.png';
import upsLogo from '../../../assets/img/UpsLogo.png';
import postOfficeLogo from '../../../assets/img/postOfficeLogo.png';
import MsgCheckModal from "./MsgCheckModal";

function AdminRegModal() {
    const storedOrderData = localStorage.getItem('orderData');
    const initialOrderData = storedOrderData ? JSON.parse(storedOrderData) : null;
    const [orderData, setOrderData] = useState(initialOrderData);
    // 배송알림옵션 체크박스
    const [deliveryAlarm, setDeliveryAlarm] = useState(
        orderData?.appReqDTO?.deliveryAlarm !== undefined
            ? orderData.appReqDTO.deliveryAlarm
            : true
    );

    const [inputType, setInputType] = useState(orderData.dataType === 'payinfo' ? 'shipInfoDTO' : 'box');
    const LCAT = localStorage.getItem('adminToken');
    const [shipcoData, setShipcoData] = useState([]);
    const [selectedShipCompany, setSelectedShipCompany] = useState(orderData.shipco);
    const [selectedDataType, setSelectedDataType] = useState(orderData.dataType);
    const [fedexExData, setFedexExData] = useState([]);
    const [fedexEcoExData, setFedexEcoExData] = useState([]);
    const [emsExData, setEmsExData] = useState([]);
    // [개선3] EMS / K-Packet / SEA 요금표가 '현재 수취국가 기준으로 실제 조회 완료'되었는지 여부.
    //         요금표 로딩 전(또는 조회 실패)에는 배송료 0원 판정을 하지 않아 체크박스가 잘못 해제되는 것을 원천 차단한다.
    const [exrLoaded, setExrLoaded] = useState({ems: false, kpack: false, sea: false});
    const [emsPreExData, setEmsPreExData] = useState([]);
    const [shipExData, setShipExData] = useState([]);
    const [upsExData, setUpsExData] = useState([]);
    const [upsEcoExData, setUpsEcoExData] = useState([]);
    const [kpExData, setKpExData] = useState([]);
    const [asExData, setAsExData] = useState([]);
    const [domeExData, setDomeExData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [assignError, setAssignError] = useState(false);
    const [assignErrorMsg, setAssignErrorMsg] = useState(false);

    // DOME : 국내배송 박스별 택배비 수기입력값(빈값이면 DB요금표 자동조회값 사용)
    const [manualPrices, setManualPrices] = useState({FedEx: {}, "FedEx-E": {}, UPS: {}, "UPS-E": {}, DOME: {}});

    const [tables, setTables] = useState([]);
    const [tableCount, setTableCount] = useState(1);
    const [showOrdInputs, setShowOrdInputs] = useState(true);
    const [showCostInputs, setShowCostInputs] = useState(false);
    const [showItemInputs, setShowItemInputs] = useState(true);
    const [showBoxInputs, setShowBoxInputs] = useState(true);
    const [showBoxDtPrice, setShowBoxDtPrice] = useState(Array(tableCount).fill(false));
    const handleToggle = (index) => {
        setShowBoxDtPrice(prevState => {
            const newState = [...prevState];
            newState[index] = !newState[index];
            return newState;
        });
    };
    const [buyValue, setBuyValue] = useState(""); //구매비
    const [codValue, setCodValue] = useState(""); //착불비
    const [domeValue, setDomeValue] = useState(""); //국내반송비
    const [fedexCusPrepay, setFedexCusPrepay] = useState(""); // FedEx 관부가세
    const [fedexEcoCusPrepay, setFedexEcoCusPrepay] = useState(""); // FedEx-E 관부가세
    const [upsCusPrepay, setUpsCusPrepay] = useState(""); // UPS 관부가세
    const [postOfficeCusPrepay, setPostOfficeCusPrepay] = useState(""); // 우체국 관부가세
    const numericFedexCusPrepay = parseFloat(fedexCusPrepay.replace(/,/g, '')) || 0; // FedEx 관부가세선납 실시간합산용 숫자형값
    const numericFedexEcoCusPrepay = parseFloat(fedexEcoCusPrepay.replace(/,/g, '')) || 0; // FedEx-E 관부가세선납 실시간합산용 숫자형값
    const numericUpsCusPrepay = parseFloat(upsCusPrepay.replace(/,/g, '')) || 0; // UPS 관부가세선납 실시간합산용 숫자형값
    const numericPostOfficeCusPrepay = parseFloat(postOfficeCusPrepay.replace(/,/g, '')) || 0; // 우체국 관부가세선납 실시간합산용 숫자형값

    const [upsQuoteId, setUpsQuoteId] = useState(""); //관세식별코드(QuoteId)

    const [deliveryFeeValue, setDeliveryFeeValue] = useState(""); //배송대행수수료
    const [repackValue, setRePackValue] = useState(""); //재포장수수료
    const [agenciesValue, setAgenciesValue] = useState(""); //대행수수료
    const [removeValue, setRemoveValue] = useState(""); //제거작업 수수료
    const [vacPackPrice, setVacPackPrice] = useState(""); //압축팩수수료
    const [etcValue, setEtcValue] = useState(""); //기타비용
    const [etcNmValue, setEtcNmValue] = useState(""); //기타비용 내용
    const [etcFeeValue, setEtcFeeValue] = useState(""); //기타수수료
    const [etcFeeNmValue, setEtcFeeNmValue] = useState(""); //기타수수료 내용
    const [fedexFuelValue, setFedexFuelValue] = useState(() => {
        if (orderData && orderData.dataType === 'orderdt') {
            return orderData.recinfoDTO?.countryDTO?.fedexFuelSurcharge || '';
        } else if (orderData && orderData.dataType === 'payinfo') {
            return orderData.orderdtDTO?.recinfoDTO?.countryDTO?.fedexFuelSurcharge || '';
        }
        return '';
    });
    const [upsFuelValue, setUpsFuelValue] = useState(() => {
        if (orderData && orderData.dataType === 'orderdt') {
            return orderData.recinfoDTO?.countryDTO?.upsFuelSurcharge || '';
        } else if (orderData && orderData.dataType === 'payinfo') {
            return orderData.orderdtDTO?.recinfoDTO?.countryDTO?.upsFuelSurcharge || '';
        }
        return '';
    });

    //fedex 유류할증료
    // const [ffeeetcValue, setFfeeEtcValue] = useState(orderData.payInfoDTO?.[0]?.outOfArea || ""); //fedex 서비스 외 지역 비용
    // const [payTypeValue, setPayTypeValue] = useState([]); // PT0, PT2

    const [packSize, setPackSize] = useState('선택');
    const [vacPackPopup, setVacPackPopup] = useState(false);
    // const [vacuumPack, setVacuumPack] = useState(!!orderData.payInfoDTO?.[0]?.comprFee);
    // const [buyCheckbox, setBuyCheckbox] = useState(false);
    // const [codCheckbox, setCodCheckbox] = useState(!!orderData.payInfoDTO?.[0]?.courierPay || false);
    // const [domeCheckbox, setDomeCheckbox] = useState(!!orderData.payInfoDTO?.[0]?.returnFee);
    // const [deliveryFeeCheckbox, setDeliveryFeeCheckbox] = useState(!!orderData.payInfoDTO?.[0]?.deliveryFee);
    // const [repackCheckbox, setRePackCheckbox] = useState(!!orderData.payInfoDTO?.[0]?.repackFee);
    // const [agenciesCheckbox, setAgenciesCheckbox] = useState(!!orderData.payInfoDTO?.[0]?.agencyFee);

    const [vacuumPack, setVacuumPack] = useState(false);
    const [buyCheckbox, setBuyCheckbox] = useState(false);
    const [codCheckbox, setCodCheckbox] = useState(false);
    const [domeCheckbox, setDomeCheckbox] = useState(false);
    const [fedexCusPrepayCheckBox, setFedexCusPrepayCheckBox] = useState(false);
    const [fedexEcoCusPrepayCheckBox, setFedexEcoCusPrepayCheckBox] = useState(false);
    const [upsCusPrepayCheckBox, setUpsCusPrepayCheckBox] = useState(false);
    const [postOfficeCusPrepayCheckBox, setPostOfficeCusPrepayCheckBox] = useState(false);
    const [deliveryFeeCheckbox, setDeliveryFeeCheckbox] = useState(false);
    useEffect(() => {
        setDeliveryFeeCheckbox(deliveryFeeValue !== "" && parseInt(deliveryFeeValue) !== 0);
    }, [deliveryFeeValue]);
    const [repackCheckbox, setRePackCheckbox] = useState(false);
    const [agenciesCheckbox, setAgenciesCheckbox] = useState(false);
    const [removeCheckbox, setRemoveCheckbox] = useState(false); //제거작업 수수료 입력여부
    const [etcCheckbox, setEtcCheckbox] = useState(false);
    const [etcFeeCheckbox, setEtcFeeCheckbox] = useState(false);
    const [ffeeCheckbox, setFfeeCheckbox] = useState(false);
    const [efeeCheckbox, setEfeeCheckbox] = useState(false);
    const [emsAmount, setEmsAmount] = useState(false);
    const [appliedWeights] = useState({E: "", F: "", S: "", A: ""});

    // const [boxData, setBoxData] = useState(
    //     Array.from({ length: tableCount }, () => ({
    //         width: "",
    //         height: "",
    //         length: "",
    //         netWeight: "",
    //         appliedWeights: { E: "", F: "", S: "", A: "" },
    //         products: [],
    //         fpackCheckbox: false,
    //     }))
    // );

    const [boxData, setBoxData] = useState(
        Array.from({ length: tableCount }, () => ({
            width: "",
            height: "",
            length: "",
            netWeight: "",
            appliedWeights: { E: "", F: "", S: "", A: "" },
            products: [],
            // 기존 fpackCheckbox: false 제거하고 아래로 대체
            fpackInfo: { F: false, E: false },
            checkedCouriers: []
        }))
    );


    const [appliedWeightsD] = useState({D: ""});
    const [boxDomeData, setBoxDomeData] = useState([{
        width: "",
        height: "",
        length: "",
        netWeight: "",
        appliedWeightsD: {D: ""}
    },]);

    const prodStPrint = (prodSt) => {
        const prodStStyles = {
            IS00: {color: "#98B0D4", label: "입고대기"},
            IS01: {color: "#98B0D4", label: "결제대기(상품)"},
            IS02: {color: "#98B0D4", label: "결제중(상품)"},
            IS03: {color: "#FFB378", label: "결제완료(상품)"},
            IS04: {color: "#EB939D", label: "구매완료"},
            IS05: {color: "#6EDA60", label: "센터도착"},
            IS06: {color: "#98B0D4", label: "패킹중"},
            IS07: {color: "#98B0D4", label: "결제대기(배송)"},
            IS08: {color: "#98B0D4", label: "결제중(배송)"},
            IS09: {color: "#FFB378", label: "결제완료(배송)"},
            IS10: {color: "#979696", label: "출고완료"},
            IS11: {color: "#E05E6D", label: "반송중"},
            IS12: {color: "#E05E6D", label: "신청취소"},
            IS13: {color: "#98B0D4", label: "구매중"},
            IS14: {color: "#98B0D4", label: "입고중"}
        };

        const style = prodStStyles[prodSt] || {color: "black", label: null};
        return <p style={{color: style.color, fontSize: "14px"}}>{style.label}</p>;
    };

    const [userNm, setUserNm] = useState(orderData.dataType === 'payinfo' ? orderData.orderdtDTO.memberDTO.userName : orderData.memberDTO.userName);
    const [adminInfo, setAdminInfo] = useState([]);
    const selectAdminInfo = (() => {
        axios({
            method: 'get',
            url: '/member/modiInfo',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response) => {
                setAdminInfo(response.data[0])
            })
            .catch(() => {
                console.log("멤버조회 실패")
            })
    })

    function roundToTen(value) {
        const remainder = value % 10;
        if (remainder <= 5) {
            return value - remainder;
        } else {
            return value + (10 - remainder);
        }
    }

    useEffect(() => {
        selectAdminInfo();
    }, [])

    // 웹소켓
    const isSubscribedRef = useRef(false);
    const {subscribe, unsubscribe, websocketConnect, isConnected, stompClient} = useWebSocket();

    useEffect(() => {
        setTimeout(() => {
            const initializeConnection = async () => {
                if (!adminInfo.mbNum || isSubscribedRef.current) return;

                if (!stompClient && !isConnected) {
                    await websocketConnect(adminInfo.mbNum);
                }
                if (isConnected && stompClient && !isSubscribedRef.current) {
                    isSubscribedRef.current = true;
                }
            }

            initializeConnection();

            return () => {
                if (isSubscribedRef.current) {
                    isSubscribedRef.current = false;
                }
            };
        }, 3000)

    }, [adminInfo.mbNum, isConnected, stompClient]);

    //region CheckBox

    const [checkedItems, setCheckedItems] = useState([]);
    const [isAllChecked, setIsAllChecked] = useState(false);

    useEffect(() => {
        const productsDTO =
            orderData.dataType === 'payinfo'
                ? (orderData.packListDTO?.productsDTO || [])
                : (orderData.productsDTO || []);

        //기본체크 해제
        setCheckedItems([]);
        setIsAllChecked(false);

        setBoxData((prev) =>
            prev.map((box) => ({
                ...box,
                products: []
            }))
        );
    }, [orderData, tableCount]);

    const handleAllCheck = (e) => {
        const { checked } = e.target;
        setIsAllChecked(checked);

        const productsDTO =
            orderData.dataType === 'payinfo'
                ? (orderData.packListDTO?.productsDTO || [])
                : (orderData.productsDTO || []);

        if (checked) {
            const allProductSeqnums = productsDTO
                .filter((item) => item.prodSt === "IS05" || item.prodSt === "IS06")
                .map((item) => item.seqnum);
            setCheckedItems(allProductSeqnums);

            setBoxData((prev) =>
                prev.map((box, index) => ({
                    ...box,
                    products: allProductSeqnums.filter((seqnum) => seqnum % tableCount === index)
                }))
            );
        } else {
            setCheckedItems([]);
            setBoxData((prev) => prev.map((box) => ({ ...box, products: [] })));
        }
    };

    const handleSingleCheck = (seqnum, isChecked, prodSt) => {
        if (prodSt === "IS05" || prodSt === "IS06") {
            setCheckedItems((prev) => {
                const newCheckedItems = isChecked
                    ? [...prev, seqnum]
                    : prev.filter((item) => item !== seqnum);

                setBoxData((prevBoxes) =>
                    prevBoxes.map((box, index) => ({
                        ...box,
                        products: newCheckedItems.filter((num) => num % tableCount === index)
                    }))
                );

                return newCheckedItems;
            });
        }
    };

    useEffect(() => {
        const productsDTO =
            orderData.dataType === 'payinfo'
                ? (orderData.packListDTO?.productsDTO || [])
                : (orderData.productsDTO || []);

        const allItems = productsDTO
            .filter((item) => item.prodSt === "IS05" || item.prodSt === "IS06")
            .map((item) => item.seqnum);

        setIsAllChecked(checkedItems.length === allItems.length);
    }, [checkedItems, orderData]);

    //endregion

    const handleFpackCheckboxChange = (index, type) => {
        const updatedBoxData = [...boxData];
        // 여기서 true/false로 설정하고 getPayInfoBoxData에서 boxData별로 페덱스팩 체크여부를 Y/N으로 재설정
        updatedBoxData[index].fpackInfo = {
            ...updatedBoxData[index].fpackInfo,
            [type]: !updatedBoxData[index].fpackInfo[type]
        };
        setBoxData(updatedBoxData);
    };

    const handleDomeBoxChange = (index, field, value) => {
        // 1. boxDomeData를 사용하도록 수정합니다.
        const updatedBoxData = [...boxDomeData];
        if (updatedBoxData[index]) {
            updatedBoxData[index][field] = value;
            // 2. setBoxDomeData를 호출하도록 수정합니다. (useState 변수명 확인 필요)
            setBoxDomeData(updatedBoxData);
        }
    };

    const handleBoxChange = (index, field, value) => {
        if (selectedShipCompany === "국내배송") {
            const updatedBoxData = [...boxDomeData];
            if (updatedBoxData[index]) {
                updatedBoxData[index][field] = value;
                setBoxDomeData(updatedBoxData);
            }
        } else {
            const updatedBoxData = [...boxData];
            if (!updatedBoxData[index]) return;

            // 값 업데이트
            updatedBoxData[index][field] = value;

            // 무게 입력 시 부피값이 없으면 FedEx 서비스만 Pak 자동체크
            if (['netWeight', 'width', 'height', 'length'].includes(field)) {
                const currentBox = updatedBoxData[index];

                const isNoDimension =
                    !currentBox.width || currentBox.width === "0" ||
                    !currentBox.height || currentBox.height === "0" ||
                    !currentBox.length || currentBox.length === "0";

                const hasWeight = currentBox.netWeight && parseFloat(currentBox.netWeight) > 0;

                if (hasWeight) {
                    if (isNoDimension) {
                        // 무게는 있는데 규격이 없으면 -> Pak 자동 체크
                        updatedBoxData[index].fpackInfo = { F: true, E: false };
                    } else {
                        // 무게도 있고 규격도 있으면 -> Pak 자동 해제 (박스로 간주)
                        updatedBoxData[index].fpackInfo = { F: false, E: false };
                    }
                }
            }

            // 1. 물리적 조건(규격/무게)에 따른 배송 가능 여부 조회
            let eligible = evaluateCourierEligibility(updatedBoxData[index]);

            // cusPrepayFl(관세선납) 필터링 로직 / 관세선납 요청옵션 활성화 시 아래 나열된 배송사만 체크박스 자동선택
            if (orderData?.reqmnDTO?.cusPrepayFl === true) {
                const filteredEligible = {};
                Object.keys(eligible).forEach(key => {
                    const delkey = key.toUpperCase()
                    if (delkey === 'FEDEX' || delkey === 'FEDEX-E' || delkey === 'UPS' || delkey === 'UPS-E' || delkey === 'EMS' || delkey === 'KPACK' || delkey === 'SEA') {
                        filteredEligible[key] = eligible[key];
                    } else {
                        filteredEligible[key] = false;
                    }
                });
                eligible = filteredEligible;
            }

            // 2. 체크박스 상태 업데이트 (✨ 요청하신 대로 자동 체크 로직 복구)
            const currentChecked = new Set(updatedBoxData[index].checkedCouriers || []);
            Object.entries(eligible).forEach(([courier, isEligible]) => {
                if (isEligible) {
                    // 조건이 맞으면 자동으로 체크 (사용자 편의성)
                    currentChecked.add(courier);
                } else {
                    // 조건이 안 맞으면(무게 초과 등) 체크 해제
                    currentChecked.delete(courier);
                }
            });

            updatedBoxData[index].checkedCouriers = Array.from(currentChecked);

            // 3. DTO 업데이트 (UI 표시용 DTO 동기화)
            updatedBoxData[index].shipInfoDTO = {
                fedexChecked: currentChecked.has("FedEx"),
                fedexEcoChecked: currentChecked.has("FedEx-E"),
                upsChecked: currentChecked.has("UPS"),
                upsEcoChecked: currentChecked.has("UPS-E"),
                emsChecked: currentChecked.has("EMS"),
                emspChecked: currentChecked.has("EMSP"),
                seaChecked: currentChecked.has("SEA"),
                kpackChecked: currentChecked.has("KPack"),
                spackChecked: currentChecked.has("SPack"),
            };

            setBoxData(updatedBoxData);
        }
    };

    const evaluateCourierEligibility = (box) => {
        const width = parseFloat(box.width);
        const height = parseFloat(box.height);
        const length = parseFloat(box.length);
        const netWeight = parseFloat(box.netWeight);

        const hasDims = width > 0 && height > 0 && length > 0;
        const hasWeight = netWeight > 0;
        const hasPakWeight = netWeight > 0 && netWeight <= 2

        const volumetricWeight = (width * height * length) / 6000;
        const sumOfDims = width + height + length;

        // [기존코드/미사용] Small-Packet 차단국가 목록 - 아래 '개선2'로 전 국가 차단되어 미사용(삭제하지 않고 보존)
        // const blockedSpackCountries = new Set([
        //     "US", "CA", "AU", "NZ", "JP", "FR", "ID", "GB", "IE", "SG",
        //     "ES", "CH", "SE", "BR", "RU", "MX", "TW", "NL", "NO"
        // ]);
        // const isSpackBlocked = blockedSpackCountries.has(selectedCountry?.value);

        // [개선2] Small-Packet(SPack)은 당분간 전 국가 서비스가 완전 중단됨.
        //         => 항상 '차단'으로 간주하여 체크해제를 기본값으로 하고, 관리자가 체크박스를 직접 눌렀을 때만 체크된다.
        const isSpackBlocked = true;

        const countryCode = selectedCountry?.value;

        // [개선1] 뉴질랜드(NZ)는 2018년 SEA(선편) 서비스가 중지됨 => 항상 체크해제
        const isSeaStoppedCountry = countryCode === "NZ";

        // [개선4] 국가별 선편(SEA) 제한부피 초과 시 체크해제
        //  - 둘레 = 가로(width) + 세로(height)*2 + 높이(length)*2
        //  - CA/JP  : 가로 > 150 또는 둘레 > 300
        //  - 그 외국 : 가로 > 105 또는 둘레 > 200
        //  ※ 부피중량(w*h*l/6000)은 보지 않는다. 그 기준은 항공 배송사(FedEx/UPS/EMS/EMS-P/K-Packet)에만 해당하고
        //    선편은 위의 가로/둘레 제한만 본다. (예전에는 들어 있어 규격 안의 화물까지 체크가 해제되었다)
        //  (실중량 20kg 초과 해제조건은 기존 "SEA" 조건인 netWeight <= 20 이 그대로 담당)
        const seaGirth = width + (height * 2) + (length * 2);
        const isSeaLargeSizeCountry = countryCode === "CA" || countryCode === "JP";
        const seaLimitWidth = isSeaLargeSizeCountry ? 150 : 105;
        const seaLimitGirth = isSeaLargeSizeCountry ? 300 : 200;
        const isSeaOverSize = hasDims && (width > seaLimitWidth || seaGirth > seaLimitGirth);

        // [개선3] EMS / K-Packet / SEA 3개 배송사만 '총배송비용'이 아닌 순수 '배송료'가 0 이거나 null 이면 체크해제
        //  - '자세히' 드랍다운에 출력되는 배송료와 완전히 동일한 계산식 사용
        //    (EMS: appliedWeights.E + emsExData / K-Packet: appliedWeights.K + kpExData / SEA: appliedWeights.S + shipExData)
        //  - box.appliedWeights 는 useEffect에서 비동기로 반영되어 이 시점엔 이전값이므로 동일한 apyWeightCalculation으로 즉시 재계산
        //  - 가로/세로/높이/실무게가 모두 입력된 경우에만 판정(미입력 상태에서 오판정 방지)
        const hasFullInput = hasDims && hasWeight;
        const isPositiveCost = (cost) => cost !== null && cost !== undefined && Number(cost) > 0;

        const emsShipCost = hasFullInput
            ? getAmountForWeight(apyWeightCalculation("D02", width, length, height, netWeight), emsExData) : null;
        const kpackShipCost = hasFullInput
            ? getAmountForWeight(apyWeightCalculation("D13", width, length, height, netWeight), kpExData) : null;
        const seaShipCost = hasFullInput
            ? getAmountForWeight(apyWeightCalculation("D03", width, length, height, netWeight), shipExData) : null;

        const hasEmsShipCost = !hasFullInput || !exrLoaded.ems || isPositiveCost(emsShipCost);
        const hasKpackShipCost = !hasFullInput || !exrLoaded.kpack || isPositiveCost(kpackShipCost);
        const hasSeaShipCost = !hasFullInput || !exrLoaded.sea || isPositiveCost(seaShipCost);

        return {
            "FedEx": hasPakWeight || (hasDims && hasWeight),
            "FedEx-E": hasDims && hasWeight,
            "UPS": hasDims && hasWeight,
            "UPS-E": hasDims && hasWeight,
            "EMS": hasDims && hasWeight && netWeight <= 30 && volumetricWeight <= 30 && hasEmsShipCost,
            "EMSP": hasDims && hasWeight && netWeight <= 70,
            "SEA": hasWeight && netWeight <= 20 && !isSeaStoppedCountry && !isSeaOverSize && hasSeaShipCost,
            "KPack": hasDims && hasWeight && netWeight <= 2 && volumetricWeight <= 2 && hasKpackShipCost,
            "SPack": !isSpackBlocked && hasDims && hasWeight && netWeight <= 2 && sumOfDims <= 90,
        };
    };

    const initializeBoxFromShipInfoDTO = () => {
        if (orderData?.dataType === 'payinfo' && orderData?.shipInfoDTO) {
            const {
                wid,
                ver,
                hei,
                weight,
                fedexApyWeight,
                emsApyWeight,
                emsPreApyWeight,
                seaApyWeight,
                dhlApyWeight,
                upsApyWeight,
                kpackApyWeight,
                airSApyWeight,
            } = orderData.shipInfoDTO;

            // 1. 체크박스 체크 여부: apyWeight 값이 0이 아닌 경우만 체크로 간주
            const couriers = [];
            if (fedexApyWeight && fedexApyWeight !== 0) couriers.push("FedEx");
            if (fedexApyWeight && fedexApyWeight !== 0) couriers.push("FedEx-E");
            if (upsApyWeight && upsApyWeight !== 0) couriers.push("UPS");
            if (upsApyWeight && upsApyWeight !== 0) couriers.push("UPS-E");
            if (emsApyWeight && emsApyWeight !== 0) couriers.push("EMS");
            if (emsPreApyWeight && emsPreApyWeight !== 0) couriers.push("EMSP");
            if (kpackApyWeight && kpackApyWeight !== 0) couriers.push("KPack");
            if (airSApyWeight && airSApyWeight !== 0) couriers.push("SPack");
            if (seaApyWeight && seaApyWeight !== 0) couriers.push("SEA");
            if (dhlApyWeight && dhlApyWeight !== 0) couriers.push("DHL");

            // 2. 기존 boxData[0]에 적용 (단일 박스인 경우)
            const updatedBoxData = [...boxData];
            updatedBoxData[0] = {
                ...updatedBoxData[0],
                width: wid || "0",
                height: ver || "0",
                length: hei || "0",
                netWeight: weight || "0",
                checkedCouriers: couriers,
                shipInfoDTO: orderData.shipInfoDTO,
            };

            setBoxData(updatedBoxData);
            setInputType('shipInfoDTO'); // 원래 타입 유지용
        }
    };

    useEffect(() => {
        initializeBoxFromShipInfoDTO();
    }, []);

    const handleVacPackSizeChange = (event) => {
        const selectedSize = event.target.value;
        setPackSize(selectedSize);

        if (selectedSize === '소형') {
            setVacuumPack(true);
            setVacPackPrice(10000);
        } else if (selectedSize === '대형') {
            setVacuumPack(true);
            setVacPackPrice(20000);
        } else {
            setVacuumPack(false);
            setVacPackPrice(0);
        }
    };

    const handleFedexValueChange = (index, value) => {
        setBoxData(prevBoxes => {
            const newBoxes = [...prevBoxes];
            newBoxes[index].fedexValue = value === "" ? "" : parseFloat(value);
            return newBoxes;
        });
    };

    const handlePlusClick = () => {
        // tables와 tableCount 상태 업데이트 (기존 로직)
        setTables([...tables, tableCount]);
        setTableCount(tableCount + 1);

        if (selectedShipCompany === '국내배송') {
            const newBoxDomeData = [...boxDomeData, {
                width: "",
                height: "",
                length: "",
                netWeight: "",
                appliedWeightsD: {D: ""}
            }];
            setBoxDomeData(newBoxDomeData);
        } else {
            // 해외배송의 경우, 새 박스 객체를 추가합니다.
            setBoxData(prevBoxData => [...prevBoxData, {
                width: "",
                height: "",
                length: "",
                netWeight: "",
                appliedWeights: {E: "", EP: "", F: "", S: "", D: "", P: "", K: "", A: ""},
                products: [],
                fpackInfo: { F: false, E: false }, // fpackInfo도 초기화
                // 👇 새로 추가되는 박스에도 checkboxStates를 반드시 포함시켜야 합니다.
                checkboxStates: {
                    FedEx: false,
                    UPS: false,
                    EMS: false,
                    EMSP: false,
                    SEA: false,
                    KPack: false,
                    SPack: false,
                }
            }]);
        }
    };

    const handleMinusClick = () => {
        if (tables.length > 0) {
            setTables(tables.slice(0, -1));
            setTableCount(tableCount - 1);
            if (selectedShipCompany === '국내배송') {
                const removedIndex = boxDomeData.length - 1;
                setBoxDomeData(boxDomeData.slice(0, -1));
                // 삭제된 박스의 국내배송 택배비 수기입력값도 함께 제거(재추가 시 이전값 잔존 방지)
                setManualPrices(prev => {
                    const nextDome = {...prev.DOME};
                    delete nextDome[removedIndex];
                    return {...prev, DOME: nextDome};
                });
            } else {
                // setBoxData(boxData.slice(0, -1));
                setBoxData(prevBoxData => prevBoxData.slice(0, -1));
            }
        }
    };

    // region Alert

    const [alertShow, setAlertShow] = useState(false);
    const [alertShow3, setAlertShow3] = useState(false);

    // [개선5] 실중량 또는 부피중량(5000기준)이 30kg 초과인 박스인데 4개 특송사 '직접입력' 배송료가 비어있을 때의 경고
    const [expressFeeInputError, setExpressFeeInputError] = useState(false);
    const closeExpressFeeInputError = () => setExpressFeeInputError(false);
    // [개선6] 관세선납 입력폼 금액 누락 경고 (수취국가가 US일 때만 검증)
    const [cusPrepayInputError, setCusPrepayInputError] = useState(false);
    // [개선6] 관세선납 경고문구 (관부가세선납 활성/비활성에 따라 달라진다)
    const [cusPrepayInputErrorMsg, setCusPrepayInputErrorMsg] = useState('');

    /**
     * [개선6] 관세선납 입력폼이 '유효하게' 채워졌는지 판정
     *  - 빈값 / 0원 / 숫자가 아닌 값("Loading..", "조회 실패", "오류" 등)은 모두 미입력으로 본다.
     *  - 입력했다가 지우거나 0으로 되돌린 경우에도 반드시 검증에 걸리도록 1원 이상만 통과시킨다.
     */
    const isCusPrepayFilled = (value) => {
        const text = String(value ?? "").replace(/,/g, '').trim();
        if (text === "") return false;
        if (!/^\d+$/.test(text)) return false; // 숫자 이외의 문자가 섞여있으면 미입력 처리
        return parseInt(text, 10) >= 1;         // 0원도 미입력으로 처리
    };

    /**
     * [개선6] 세관신고항목(자식아이템) 미작성 여부
     *  - 수취국가가 미국(US) 이면 관부가세선납(cusPrepayFl) 값과 무관하게 필수
     *  - 그 외 국가는 기존과 동일하게 관부가세선납이 활성화된 경우에만 필수
     *  - 실무게가 아직 입력되지 않은 단순저장 단계에서는 검증하지 않는다(기존 로직 유지)
     */
    const isCustomsDeclarationMissing = () => {
        const weight = boxData?.[0]?.netWeight;
        if (!weight) return false;
        if ((tariffItems?.length ?? 0) > 0) return false;
        return selectedCountry?.value === "US" || orderData?.reqmnDTO?.cusPrepayFl === true;
    };
    const closeCusPrepayInputError = () => setCusPrepayInputError(false);

    const msgConfirmData1 = "비용정보를 등록 하시겠습니까?";
    const msgConfirmData2 = "입력한 정보를 다시한번 확인해주세요.";
    const msgConfirmData5 = "입력된 정보를 저장 하시겠습니까?";
    const msgConfirmData6 = "수정된 정보를 다시한번 확인해주세요.";
    const handleAlert = () => {
        const productsDTO = orderData.dataType === 'payinfo'
            ? (orderData.packListDTO?.productsDTO || [])
            : (orderData.productsDTO || []);

        const validItems = productsDTO.filter(() => true);

        // const validItems = productsDTO.filter(
        //     (item) => item.prodSt === 'IS05' || item.prodSt === 'IS06'
        // );
        const hasValidItems = validItems.length > 0;

        const checkedValidItems = checkedItems.filter(seqnum =>
            validItems.some(item => item.seqnum === seqnum)
        );
        const hasCheckedValidItems = checkedValidItems.length > 0;

        const hasWeightInput = inputType === 'shipInfoDTO'
            ? !!orderData.shipInfoDTO.weight
            : boxData.some(box => box.netWeight && box.netWeight !== "");

        if (hasWeightInput && hasValidItems && !hasCheckedValidItems) {
            assignRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
            setAssignError(true);
            setAssignErrorMsg(true);
            setTimeout(() => {
                setAssignError(false);
                setAssignErrorMsg(false);
            }, 2500);
            return;
        }

        // ───────────────────────────────────────────────────────────────────────────────
        // [개선5][개선6] 등록완료 전 추가 검증
        //  - 해외배송이면서 실무게가 입력된(=배송료를 실제로 등록하는) 경우에만 검증한다.
        //    (국내배송이거나 무게 미입력 상태의 단순 저장은 기존 로직 그대로 통과)
        // ───────────────────────────────────────────────────────────────────────────────
        if (hasWeightInput && selectedShipCompany !== "국내배송") {

            // [개선5] 부피중량(w*h*l/5000) 또는 실중량이 30kg 초과인 박스는
            //         FedEx / FedEx-E / UPS / UPS-E 4개 특송사의 '직접입력' 폼에 1원 이상이 반드시 입력되어야 한다.
            const EXPRESS_MANUAL_KEYS = ["FedEx", "FedEx-E", "UPS", "UPS-E"];
            const isOverHeavyBox = (box) =>
                parseFloat(box.netWeight) > 30 || getVolumeWeightUps(box.width, box.height, box.length) > 30;

            const hasEmptyExpressManualFee = boxData.some((box, index) => {
                if (!isOverHeavyBox(box)) return false;
                return EXPRESS_MANUAL_KEYS.some((courierKey) => {
                    const rawValue = manualPrices?.[courierKey]?.[index];
                    const numericValue = parseInt(String(rawValue ?? "").replace(/,/g, ''), 10);
                    return !(numericValue >= 1);
                });
            });

            if (hasEmptyExpressManualFee) {
                setExpressFeeInputError(true);
                return;
            }

            // [개선6-1] 세관신고항목(자식아이템) 미작성 검증
            //  기존에는 [등록완료] -> Yes/No 팝업에서 Yes 를 누른 뒤(prepareCustomsData)에야 경고가 떴다.
            //  관세선납 경고와 동일하게 [등록완료] 를 누른 즉시 검증하도록 이 위치로 옮겼다.
            if (isCustomsDeclarationMissing()) {
                setAlertShow(false);
                setAlertShow3(false);
                setCusDataInputError(true);
                return;
            }

            // [개선6-2] 수취국가가 미국(US)일 경우에만 관세선납 입력폼 검증
            //  - 관부가세선납(cusPrepayFl) 활성화 : FedEx / FedEx-E / UPS / 우체국 관세선납 4개 폼 모두 필수
            //  - 관부가세선납(cusPrepayFl) 비활성화 : FedEx-E / 우체국 관세선납 2개 폼 필수
            if (selectedCountry?.value === "US") {
                const isCusPrepayFl = orderData?.reqmnDTO?.cusPrepayFl === true;
                const requiredCusPrepayList = isCusPrepayFl
                    ? [fedexCusPrepay, fedexEcoCusPrepay, upsCusPrepay, postOfficeCusPrepay]
                    : [fedexEcoCusPrepay, postOfficeCusPrepay];

                if (requiredCusPrepayList.some((value) => !isCusPrepayFilled(value))) {
                    // 관부가세선납 활성화 여부에 따라 안내문구를 다르게 노출한다
                    setCusPrepayInputErrorMsg(isCusPrepayFl
                        ? '모든 관세선납 입력폼에 금액을 입력해주세요'
                        : 'FedEx-E와 우체국 관세선납 금액을 입력해주세요');
                    setCusPrepayInputError(true);
                    return;
                }
            }
        }

        if ((hasWeightInput && hasValidItems && hasCheckedValidItems) || (!hasWeightInput && hasValidItems)) {
            setAlertShow(true);
        }
    };

    const alert3 = (() => {
        setAlertShow3(true)
    })
    const modalCancel1 = useCallback(() => {
        setAlertShow(false);
    })
    const modalCancel3 = useCallback(() => {
        setAlertShow3(false);
    })

    // endregion

    // region 여기서부터 국가 커스텀셀렉트

    const [countryList, setCountryList] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState({ value: '', label: '수취국가선택'});
    const [countryShow, setCountryShow] = useState(false);
    const [filteredCountryList, setFilteredCountryList] = useState([]);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const countryRef = useRef(null);

    useEffect(() => {
        let defaultCountry = null;
        if (orderData) {
            if (orderData.recinfoDTO && orderData.recinfoDTO.countryDTO) {
                defaultCountry = {
                    value: orderData.recinfoDTO.countryDTO.countryCode,
                    label: `${orderData.recinfoDTO.countryDTO.countryNm}[${orderData.recinfoDTO.countryDTO.countryCode}]`,
                };
            } else if (orderData.appRecDTO && orderData.appRecDTO.countryDTO) {
                defaultCountry = {
                    value: orderData.appRecDTO.countryDTO.countryCode,
                    label: `${orderData.appRecDTO.countryDTO.countryNm}[${orderData.appRecDTO.countryDTO.countryCode}]`,
                };
            }
        }
        if (defaultCountry) {
            setSelectedCountry(defaultCountry);
            setSearchKeyword(defaultCountry.label);
        }
    }, [orderData]);

    const toggleCountryShow = () => {
        setCountryShow(prev => !prev);
    };

    const handleCountryChange = (country, event) => {
        event.stopPropagation();
        setSelectedCountry(country);
        setSearchKeyword(country.label);
        setCountryShow(false);
        if (country.value === "KR") {
            setSelectedShipCompany("국내배송");
        } else {
            setSelectedShipCompany(orderData.shipco);
        }
    };

    useEffect(() => {
        if (selectedCountry) {
            if (selectedCountry.value === "KR") {
                setSelectedShipCompany("국내배송");
            } else {
                setSelectedShipCompany(orderData.shipco);
            }
        }
    }, [selectedCountry.value]);

    const countryNameMapping = {
        'USA': 'United States of America',
        '터키': '튀르키예',
    };

    const handleKeyDown = (event) => {
        if (event.key === "ArrowDown") {
            if (selectedIndex < filteredCountryList.length - 1) {
                setSelectedIndex(selectedIndex + 1);
            }
        } else if (event.key === "ArrowUp") {
            if (selectedIndex > 0) {
                setSelectedIndex(selectedIndex - 1);
            }
        } else if (event.key === "Enter") {
            if (selectedIndex >= 0) {
                handleCountryChange(filteredCountryList[selectedIndex], event);
            }
        }
    };

    const handleCountrySearch = (event) => {
        const keyword = event.target.value;
        setSearchKeyword(keyword);

        const mappedKeyword = countryNameMapping[keyword.toUpperCase()] || countryNameMapping[keyword] || keyword;

        const filteredCountries = countryList.filter((country) =>
            country.label.toLowerCase().includes(mappedKeyword.toLowerCase())
        );

        setFilteredCountryList(filteredCountries);

        if (!keyword) {
            setSelectedCountry({ value: '', label: '수취국가선택'});
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (countryRef.current && !countryRef.current.contains(event.target)) {
                setCountryShow(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (countryRef.current) {
            const itemElements = countryRef.current.querySelectorAll('.selectChildBt');
            const selectedItem = itemElements[selectedIndex];

            if (selectedItem) {
                const listContainer = countryRef.current.querySelector('.country-select-data');
                const containerHeight = listContainer.clientHeight;
                const itemTop = selectedItem.offsetTop;
                const itemHeight = selectedItem.clientHeight;

                if (itemTop < 0) {
                    listContainer.scrollTop = itemTop;
                } else if (itemTop + itemHeight > containerHeight) {
                    listContainer.scrollTop = itemTop + itemHeight - containerHeight;
                }
            }
        }
    }, [selectedIndex]);

    const selectAllCountry = () => {
        axios.get('/order/selectCountry')
            .then(response => {
                const countries = response.data.map(country => ({
                    value: country.countryCode,
                    label: `${country.countryNm}[${country.countryCode}]`
                })).sort((a, b) => a.label.localeCompare(b.label));

                setCountryList(countries);
                setFilteredCountryList(countries);
            })
            .catch(error => {
                console.error("Error fetching countries:", error);
            });
    };

    useEffect(() => {
        selectAllCountry();
    }, []);

    // endregion 여기까지 커스텀 셀렉트

    // region 부피중량 / 적용중량 계산

    const [boxEmsResultFees, setBoxEmsResultFees] = useState(Array(boxData.length).fill(0));
    const [boxEmsPreResultFees, setBoxEmsPreResultFees] = useState(Array(boxData.length).fill(0));
    const [boxFedexResultFees, setBoxFedexResultFees] = useState(Array(boxData.length).fill(0));
    const [boxFedexEcoResultFees, setBoxFedexEcoResultFees] = useState(Array(boxData.length).fill(0));
    const [boxSeaResultFees, setBoxSeaResultFees] = useState(Array(boxData.length).fill(0));
    // const [boxDhlResultFees, setBoxDhlResultFees] = useState(Array(boxData.length).fill(0));
    const [boxUpsResultFees, setBoxUpsResultFees] = useState(Array(boxData.length).fill(0));
    const [boxUpsEcoResultFees, setBoxUpsEcoResultFees] = useState(Array(boxData.length).fill(0));
    const [boxKpResultFees, setBoxKpResultFees] = useState(Array(boxData.length).fill(0));
    const [boxAsResultFees, setBoxAsResultFees] = useState(Array(boxData.length).fill(0));

    const [selectedCountryFee, setSelectedCountryFee] = useState(null);

    useEffect(() => {
        if (selectedCountry.value) {
            axios.get('/country/selectFixCountry', { params: { countryCode: selectedCountry.value } })
                .then((res) => {
                    setSelectedCountryFee(res.data);
                })
                .catch((error) => {
                    console.error("수수료에러: ", error);
                });
        }
    }, [selectedCountry.value]);

    const getShippingFees = () => {
        const countryDTO = selectedCountryFee
            ? selectedCountryFee
            : (orderData.recinfoDTO && orderData.recinfoDTO.countryDTO
                ? orderData.recinfoDTO.countryDTO
                : (orderData.appRecDTO && orderData.appRecDTO.countryDTO
                    ? orderData.appRecDTO.countryDTO
                    : null));

        return {
            emsFee: countryDTO ? parseFloat(countryDTO.emsFee || 0) : 0,
            emsPreFee: countryDTO ? parseFloat(countryDTO.emsPreFee || 0) : 0,
            fedexFee: countryDTO ? parseFloat(countryDTO.fedexFee || 0) : 0,
            fedexEcoFee: countryDTO ? parseFloat(countryDTO.fedexEcoFee || 0) : 0,
            seaFee: countryDTO ? parseFloat(countryDTO.seaFee || 0) : 0,
            upsFee: countryDTO ? parseFloat(countryDTO.upsFee || 0) : 0,
            upsEcoFee: countryDTO ? parseFloat(countryDTO.upsEcoFee || 0) : 0,
            kpFee: countryDTO ? parseFloat(countryDTO.kpackFee || 0) : 0,
            asFee: countryDTO ? parseFloat(countryDTO.airSFee || 0) : 0
        };
    };

    const {emsFee, emsPreFee, fedexFee, fedexEcoFee, seaFee, upsFee, upsEcoFee, kpFee, asFee} = getShippingFees();

    const [emsFeeState, setEmsFee] = useState(emsFee);
    const [emsPreFeeState, setEmsPreFee] = useState(emsPreFee);
    const [fedexFeeState, setFedexFee] = useState(fedexFee);
    const [fedexEcoFeeState, setFedexEcoFee] = useState(fedexEcoFee);
    const [seaFeeState, setSeaFee] = useState(seaFee);
    // const [dhlFeeState, setDhlFee] = useState(dhlFee);
    const [upsFeeState, setUpsFee] = useState(upsFee);
    const [upsEcoFeeState, setUpsEcoFee] = useState(upsEcoFee);
    const [kpFeeState, setKpFee] = useState(kpFee);
    const [asFeeState, setAsFee] = useState(asFee);

    const appliedWeightE = parseFloat(appliedWeights.E);
    const [emsResultFee, setEmsResultFee] = useState(emsFee * appliedWeightE * 10);

    const appliedWeightF = parseFloat(appliedWeights.F);
    const [fedexResultFee, setFedexResultFee] = useState(fedexFee * appliedWeightF * 10);

    const appliedWeightS = parseFloat(appliedWeights.S);
    const [seaResultFee, setSeaResultFee] = useState(seaFee * appliedWeightS * 10);

    // const appliedWeightD = parseFloat(appliedWeights.D);
    // const [dhlResultFee, setDhlResultFee] = useState(dhlFee * appliedWeightD * 10);

    const appliedWeightP = parseFloat(appliedWeights.P);
    const [upsResultFee, setUpsResultFee] = useState(upsFee * appliedWeightP * 10);

    const appliedWeightK = parseFloat(appliedWeights.K);
    const [kpResultFee, setKpResultFee] = useState(kpFee * appliedWeightK * 10);

    const appliedWeightA = parseFloat(appliedWeights.A);
    const [asResultFee, setAsResultFee] = useState(asFee * appliedWeightA * 10);

    const getVolumeWeightFedex = (width, height, length) => {
        return ((width * height * length) / 5000).toFixed(2);
    };

    const getVolumeWeightEms = (width, height, length) => {
        return ((width * height * length) / 6000).toFixed(2);
    };

    // const getVolumeWeightDhl = (width, height, length) => {
    //     return ((width * height * length) / 5000).toFixed(2);
    // };

    const getVolumeWeightUps = (width, height, length) => {
        return ((width * height * length) / 5000).toFixed(2);
    };

    const getVolumeWeightDome = (width, height, length) => {
        return ((width + height + length) / 5000).toFixed(1);
    };

    const fedexThresholds = [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 12.5, 13, 13.5, 14, 14.5, 15, 15.5,
        16, 16.5, 17, 17.5, 18, 18.5, 19, 19.5, 20, 20.5, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
        30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
        61, 62, 63, 64, 65, 66, 67, 68, 68, 70];

    const emsThresholds = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 12.5, 13, 13.5, 14,
        14.5, 15, 15.5, 16, 16.5, 17, 17.5, 18, 18.5, 19, 19.5, 20, 20.5, 21, 21.5, 22, 22.5, 23, 23.5, 24, 24.5, 25, 25.5, 26, 26.5, 27, 27.5,
        28, 28.5, 29, 29.5, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
        61, 62, 63, 64, 65, 66, 67, 68, 68, 70];

    const upsThresholds = [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 12.5, 13, 13.5, 14,
        14.5, 15, 15.5, 16, 16.5, 17, 17.5, 18, 18.5, 19, 19.5, 20, 21, 22, 23, 24, 25, 26, 27,
        28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
        61, 62, 63, 64, 65, 66, 67, 68, 68, 70];

    const seaThresholds = [1, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20];
    const kpAsThresholds = [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1, 1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 1.7, 1.8, 1.9, 2];

    const domeThresholds = [3, 5, 10, 20, 25];

    const applyWeightBands = (volumeWeight, thresholds) => {
        return thresholds.find(threshold => volumeWeight <= threshold) || thresholds[thresholds.length - 1];
    };

    const applyWeightDomeBands = (volumeWeight, thresholds) => {
        return thresholds.find(threshold => volumeWeight <= threshold) || thresholds[thresholds.length - 1];
    };

    const getAmountForWeight = (appliedWeight, data) => {
        const weightColumn = `w${Math.round(appliedWeight * 1000)}`;
        const dataObject = data.find(item => item[weightColumn] !== undefined);
        return dataObject ? dataObject[weightColumn] : 0;
    };

    const getAmountForDomeWeight = (appliedWeight, data) => {
        const weightColumn = `w${Math.round(appliedWeight * 1000)}`;
        const dataObject = data.find(item => item[weightColumn] !== undefined);
        return dataObject ? dataObject[weightColumn] : 0;
    };

    const roundUp = (value, unit) => {
        return Math.ceil(value / unit) * unit;
    };

    const apyWeightCalculation = (dvType, wid, len, hei, realWeight) => {
        const width = parseFloat(wid);
        const height = parseFloat(hei);
        const length = parseFloat(len);
        const netWeight = parseFloat(realWeight);

        if (isNaN(width) || isNaN(height) || isNaN(length) || isNaN(netWeight)) return 0;

        let volWeight, baseWeight, finalWeight;

        switch (dvType) {
            // FEDEX, FEDEX-ECO, UPS, UPS-ECO, DHL, 국내
            case "D01": case "D16": case "D11": case "D17": case "D04":
                volWeight = (width * length * height) / 5000;
                baseWeight = Math.max(netWeight, volWeight);
                finalWeight = baseWeight <= 21
                    ? roundUp(baseWeight, 0.5)
                    : roundUp(baseWeight, 1);
                break;
            case "D02": // EMS
                volWeight = (width * length * height) / 6000;
                baseWeight = Math.max(netWeight, volWeight);
                let gram = baseWeight * 1000;
                // ✅ 최소 500g 적용
                if (gram <= 500) {
                    finalWeight = 0.5;
                    break;
                }
                // ✅ 2kg 이하 → 250g 단위
                if (gram <= 2000) {
                    finalWeight = roundUp(gram, 250) / 1000;
                }
                // ✅ 2kg 초과 → 500g 단위
                else {
                    finalWeight = roundUp(gram, 500) / 1000;
                }
                break;
            case "D15": // EMS 프리미엄
                volWeight = (width * length * height) / 6000;
                baseWeight = Math.max(netWeight, volWeight);
                finalWeight = baseWeight <= 20
                    ? roundUp(baseWeight, 0.5)
                    : roundUp(baseWeight, 1);
                break;
            case "D13": // K-Packet
                volWeight = (width * length * height) / 6000;
                baseWeight = Math.max(netWeight, volWeight);
                finalWeight = roundUp(baseWeight * 1000, 100) / 1000;
                break;
            case "D14": // Small-Packet
                finalWeight = roundUp(netWeight, 0.1);
                break;
            case "D03": // SEA
                const weightGram = netWeight * 1000;
                finalWeight = weightGram <= 1000
                    ? roundUp(weightGram, 1000) / 1000
                    : roundUp(weightGram, 2000) / 1000;
                break;
            case "D00": // 국내배송
                volWeight = (width * length * height) / 5000;
                baseWeight = Math.max(netWeight, volWeight);
                if (baseWeight <= 3) {
                    finalWeight = 3;
                } else if (baseWeight <= 5) {
                    finalWeight = 5;
                } else if (baseWeight <= 10) {
                    finalWeight = 10;
                } else if (baseWeight <= 20) {
                    finalWeight = 20;
                } else {
                    finalWeight = 25;
                }
                break;
            default:
                finalWeight = 0;
        }

        return parseFloat(finalWeight.toFixed(2));
    };

    useEffect(() => {
        const { emsFee, emsPreFee, fedexFee, fedexEcoFee, seaFee, upsFee, upsEcoFee, kpFee, asFee } = getShippingFees();
        const updatedBoxData = [...boxData];
        let totalEmsFees = Array(updatedBoxData.length).fill(0);
        let totalEmsPreFees = Array(updatedBoxData.length).fill(0);
        let totalFedexFees = Array(updatedBoxData.length).fill(0);
        let totalFedexEcoFees = Array(updatedBoxData.length).fill(0);
        let totalSeaFees = Array(updatedBoxData.length).fill(0);
        // let totalDhlFees = Array(updatedBoxData.length).fill(0);
        let totalUpsFees = Array(updatedBoxData.length).fill(0);
        let totalUpsEcoFees = Array(updatedBoxData.length).fill(0);
        let totalKpFees = Array(updatedBoxData.length).fill(0);
        let totalAsFees = Array(updatedBoxData.length).fill(0);

        for (let i = 0; i < updatedBoxData.length; i++) {
            const width = parseFloat(updatedBoxData[i].width);
            const height = parseFloat(updatedBoxData[i].height);
            const length = parseFloat(updatedBoxData[i].length);
            const netWeight = parseFloat(updatedBoxData[i].netWeight);

            if (!isNaN(width) && !isNaN(height) && !isNaN(length)) {
                const apyWeightFedex = apyWeightCalculation("D01", width, length, height, netWeight);
                const apyWeightUps = apyWeightCalculation("D11", width, length, height, netWeight);
                const apyWeightEms = apyWeightCalculation("D02", width, length, height, netWeight);
                const apyWeightEmsP = apyWeightCalculation("D15", width, length, height, netWeight);
                const apyWeightKp = apyWeightCalculation("D13", width, length, height, netWeight);
                const apyWeightAs = apyWeightCalculation("D14", width, length, height, netWeight);
                const apyWeightSea = apyWeightCalculation("D03", width, length, height, netWeight);

                // console.log("apyWeightFedex : ", apyWeightFedex);
                // console.log("apyWeightEms : ", apyWeightEms);
                // console.log("apyWeightSea : ", apyWeightSea);

                updatedBoxData[i].appliedWeights = {
                    F: apyWeightFedex,
                    P: apyWeightUps,
                    E: apyWeightEms,
                    EP: apyWeightEmsP,
                    K: apyWeightKp,
                    A: apyWeightAs,
                    S: apyWeightSea
                };
                // 여기에 25kg 초과 시 추가운송수수료 35,600원 추가가능
                const fedexAddDeliveryFee = apyWeightFedex > 25 ? 35600 : 0;
                const upsAddDeliveryFee = apyWeightUps > 25 ? 21400 : 0;

                totalFedexFees[i] = (fedexFee * apyWeightFedex * 10) + fedexAddDeliveryFee;
                totalFedexEcoFees[i] = (fedexEcoFee * apyWeightFedex * 10) + fedexAddDeliveryFee;
                totalUpsFees[i] = (upsFee * apyWeightUps * 10) + upsAddDeliveryFee;
                totalUpsEcoFees[i] = (upsEcoFee * apyWeightUps * 10) + upsAddDeliveryFee;
                totalEmsFees[i] = emsFee * apyWeightEms * 10;
                totalEmsPreFees[i] = emsPreFee * apyWeightEmsP * 10;
                totalKpFees[i] = kpFee * apyWeightKp * 10;
                totalAsFees[i] = asFee * apyWeightAs * 10;
                totalSeaFees[i] = seaFee * apyWeightSea * 10;
            }
        }
        setBoxFedexResultFees(totalFedexFees);
        setBoxFedexEcoResultFees(totalFedexEcoFees);
        setBoxUpsResultFees(totalUpsFees);
        setBoxUpsEcoResultFees(totalUpsEcoFees);
        setBoxEmsResultFees(totalEmsFees);
        setBoxEmsPreResultFees(totalEmsPreFees);
        // setBoxDhlResultFees(totalDhlFees);
        setBoxKpResultFees(totalKpFees);
        setBoxAsResultFees(totalAsFees);
        setBoxSeaResultFees(totalSeaFees);

        if (JSON.stringify(updatedBoxData) !== JSON.stringify(boxData)) {
            setBoxData(updatedBoxData);
        }
    }, [boxData, selectedCountryFee]);

    // ───────────────────────────────────────────────────────────────────────────────
    // [개선5] 30kg 초과 시 4개 특송사(FedEx / FedEx-E / UPS / UPS-E) '직접입력' 배송료 자동 대입
    //  - 수취국가가 US(미국) / NZ(뉴질랜드) / SG(싱가폴) / JP(일본) 일 때만 동작
    //  - FedEx, FedEx-E 는 적용중량 F(box.appliedWeights.F), UPS, UPS-E 는 적용중량 P(box.appliedWeights.P) 사용
    //  - (적용중량 > 30kg) 인 배송사에 대해 [국가별 kg당 단가 × 적용중량] 을 최초 1회만 자동 대입한다.
    //    자동 대입 이후 관리자가 값을 수정/삭제해도 다시 덮어쓰지 않는다.
    //  - '중량화물' 별도 단가는 적용하지 않는다(관리자 확정사항). 30kg 초과 여부만 판정한다.
    // ───────────────────────────────────────────────────────────────────────────────
    const EXPRESS_OVER30KG_UNIT_PRICE = {
        "FedEx":   {US: 14400, NZ: 16400, SG: 7900, JP: 7900},
        "FedEx-E": {US: 15700, NZ: 17900, SG: 6900, JP: 10800},
        "UPS":     {US: 16200, NZ: 11900, SG: 4300, JP: 5800},
        "UPS-E":   {US: 15900, NZ: 11600, SG: 4000, JP: 5500},
    };

    /**
     * 자동입력 이력 : refKey('배송사-박스index') -> 우리가 마지막으로 넣어준 값(문자열)
     *  - 현재 인풋값이 이 값과 같으면 "아직 아무도 손대지 않은 자동입력값" 이므로 다시 계산해서 갱신한다.
     *  - 다르면 관리자가 직접 수정한 값이므로 절대 덮어쓰지 않는다.
     */
    const autoFilledExpressFeeRef = useRef({});

    useEffect(() => {
        const countryCode = selectedCountry?.value;
        if (selectedShipCompany === "국내배송") return;

        // 단가표에 있는 국가(US/NZ/SG/JP)일 때만 자동입력 대상이다.
        const supported = !!countryCode && ["US", "NZ", "SG", "JP"].includes(countryCode);

        setManualPrices(prev => {
            const next = {...prev};
            const nextAuto = {...autoFilledExpressFeeRef.current};
            let changed = false;

            boxData.forEach((box, index) => {
                const fApyWeight = parseFloat(box?.appliedWeights?.F) || 0;
                const pApyWeight = parseFloat(box?.appliedWeights?.P) || 0;

                [["FedEx", fApyWeight], ["FedEx-E", fApyWeight], ["UPS", pApyWeight], ["UPS-E", pApyWeight]]
                    .forEach(([courierKey, apyWeight]) => {
                        const refKey = `${courierKey}-${index}`;

                        const raw = next[courierKey]?.[index];
                        const currentStr = (raw === undefined || raw === null) ? "" : String(raw);
                        const lastAuto = nextAuto[refKey];

                        // 관리자가 직접 입력/수정한 값은 건드리지 않는다.
                        // (빈 값이거나, 값이 우리가 넣어준 자동입력값과 정확히 같을 때만 갱신대상)
                        const isAutoManaged = currentStr === "" || (lastAuto !== undefined && currentStr === lastAuto);
                        if (!isAutoManaged) return;

                        // 30kg 초과 + 지원국가일 때만 값을 채우고, 아니면 비운다(우리가 넣은 값에 한해).
                        const unitPrice = supported ? EXPRESS_OVER30KG_UNIT_PRICE[courierKey]?.[countryCode] : null;
                        const target = (apyWeight > 30 && unitPrice)
                            ? String(Math.round(unitPrice * apyWeight))
                            : "";

                        if (target === currentStr) return; // 변화 없음

                        // prev 를 훼손하지 않도록 배송사 버킷을 1회만 복제한다
                        if (next[courierKey] === undefined || next[courierKey] === prev[courierKey]) {
                            next[courierKey] = {...(prev[courierKey] || {})};
                        }
                        next[courierKey][index] = target;

                        if (target === "") delete nextAuto[refKey];
                        else nextAuto[refKey] = target;
                        changed = true;
                    });
            });

            if (!changed) return prev; // 동일하면 리렌더 유발하지 않는다
            autoFilledExpressFeeRef.current = nextAuto;
            return next;
        });
    }, [boxData, selectedCountry.value, selectedShipCompany]);

    useEffect(() => {
        const updatedBoxDomeData = [...boxDomeData];

        for (let i = 0; i < updatedBoxDomeData.length; i++) {
            const width = parseFloat(updatedBoxDomeData[i].width);
            const height = parseFloat(updatedBoxDomeData[i].height);
            const length = parseFloat(updatedBoxDomeData[i].length);
            const netWeight = parseFloat(updatedBoxDomeData[i].netWeight);


            if (!isNaN(width) && !isNaN(height) && !isNaN(length)) {
                const weightDom = apyWeightCalculation("D00", width, length, height, netWeight);

                updatedBoxDomeData[i].appliedWeightsD = {D: weightDom};
            }
        }
        if (JSON.stringify(updatedBoxDomeData) !== JSON.stringify(boxDomeData)) {
            setBoxDomeData(updatedBoxDomeData);
        }
    }, [boxDomeData]);

    // endregion

    const [isOutArea, setIsOutArea] = useState(false);

    useEffect(() => {
        if (
            orderData &&
            orderData.recinfoDTO &&
            orderData.recinfoDTO.countryDTO &&
            orderData.recinfoDTO.zipcode
        ) {
            const orderCountry = orderData.recinfoDTO.countryDTO.countryCode;
            const orderZip = orderData.recinfoDTO.zipcode;
            getOutAreaStatus(orderCountry, orderZip).then((exists) => {
                setIsOutArea(exists);
            });
        }}, [orderData]);

    const outAreaCharge = isOutArea ? 30000 : 0;

    const calculateTotalCostGeneric = (courierKey, dataKey, tariffData, resultFees, fuelRate = 0) => {
        let totalCost = 0;
        let totalFuelFees = 0;
        let totalAddFees = 0;
        let totalOutArea = 0;

        // 1. 배송사별 무게 제한 및 수기 입력 기준 설정
        let weightLimit = 9999; // 기본 제한 없음
        let manualThreshold = 9999; // 기본 수기입력 없음

        if (courierKey.includes("FedEx") || courierKey.includes("UPS")) {
            manualThreshold = 30; // FedEx, UPS는 30kg 초과 시 수기/별도계산
        } else if (courierKey === "EMS") {
            weightLimit = 30; // EMS는 30kg 초과 시 불가
        } else if (courierKey === "EMSP") {
            weightLimit = 70; // EMS 프리미엄은 70kg 초과 시 불가
        } else if (courierKey === "SEA") {
            weightLimit = 20; // 선편은 20kg 초과 시 불가
        } else if (courierKey === "KPack" || courierKey === "SPack") {
            weightLimit = 2; // 소형 포장물은 2kg 초과 시 불가
        }

        boxData.forEach((box, index) => {
            // 무게 정보 가져오기
            const weight = parseFloat(box.netWeight || 0); // 실무게
            const appliedWeight = box.appliedWeights?.[dataKey] || 0; // 적용무게(부피무게 포함됨)

            // 유효성 체크 1: 실무게가 없으면 0원 처리
            if (weight <= 0) return;

            // 유효성 체크 2: 배송사별 최대 무게 제한(Limit) 초과 시 계산 제외 (0원)
            // 주의: FedEx/UPS는 제한이 없으므로(9999) 패스, EMS/SEA 등은 제한 초과 시 0원
            if (weight > weightLimit || appliedWeight > weightLimit) {
                return;
            }

            // 수기 입력 대상 여부 판단 (FedEx/UPS의 경우 30kg 초과 시)
            // 실무게 또는 적용무게가 기준을 넘으면 수기 모드
            const isManual = weight > manualThreshold || appliedWeight > manualThreshold;

            // --- 1. 기본 운임 계산 ---
            let basePrice = 0;

            if (isManual) {
                // A. 수기 입력 모드 (FedEx/UPS 30kg 초과)
                const manualInput = manualPrices[courierKey]?.[index];

                if (manualInput) {
                    // 관리자가 직접 입력한 값이 있으면 우선 사용
                    basePrice = parseInt(manualInput.toString().replace(/,/g, ''), 10);
                } else {
                    // 입력값이 없으면 자동 계산 로직 참조 (FedEx 계열만 해당, UPS는 0원)
                    if (courierKey.includes("FedEx")) {
                        basePrice = getFedexCalculatedValue(box, tariffData);
                    } else {
                        basePrice = 0;
                    }
                }
            } else {
                // B. 요금표 모드 (30kg 이하 또는 EMSP/SEA 등 전체 구간)
                if (tariffData && tariffData.length > 0) {
                    basePrice = roundToTen(getAmountForWeight(appliedWeight, tariffData));
                }
            }

            // --- 2. 유류 할증료 ---
            // 수기 입력(30kg 초과)일 경우 보통 유류할증료가 포함된 단가이므로 0원 처리 (기존 로직 유지)
            // 요금표 모드일 때만 비율 적용
            let fuelFee = 0;
            if (!isManual && basePrice > 0) {
                fuelFee = roundToTen(basePrice * (fuelRate / 100));
            }

            // --- 3. 도서산간료 ---
            // FedEx 계열이고 수기 입력이 아닐 때만 적용
            let outAreaFee = 0;
            if ((courierKey === "FedEx" || courierKey === "FedEx-E") && !isManual) {
                outAreaFee = outAreaCharge;
            }

            // --- 4. 추가 수수료 ---
            // *중요*: 무게 제한을 초과한 박스는 위에서 return 처리되었으므로,
            // 여기까지 왔다는 것은 유효한 박스라는 뜻입니다. 따라서 수수료를 더해도 안전합니다.
            let addFee = 0;
            if (resultFees && resultFees[index]) {
                addFee = parseInt(resultFees[index], 10) || 0;
            }

            // 합산
            totalCost += basePrice;
            totalFuelFees += fuelFee;
            totalAddFees += addFee;
            totalOutArea += outAreaFee;
        });

        return (totalCost + totalFuelFees + totalAddFees + totalOutArea).toLocaleString();
    };

    const calculateTotalFEDEXCost = () => calculateTotalCostGeneric("FedEx", "F", fedexExData, boxFedexResultFees, fedexFuelValue);
    const calculateTotalFEDEXECost = () => calculateTotalCostGeneric("FedEx-E", "F", fedexEcoExData, boxFedexEcoResultFees, fedexFuelValue);

    const calculateTotalUPSCost = () => calculateTotalCostGeneric("UPS", "P", upsExData, boxUpsResultFees, upsFuelValue);
    const calculateTotalUPSECost = () => calculateTotalCostGeneric("UPS-E", "P", upsEcoExData, boxUpsEcoResultFees, upsFuelValue);

    const calculateTotalEMSCost = () => calculateTotalCostGeneric("EMS", "E", emsExData, boxEmsResultFees, 0);
    const calculateTotalEMSPCost = () => calculateTotalCostGeneric("EMSP", "EP", emsPreExData, boxEmsPreResultFees, 0);

    const calculateTotalSHIPCost = () => calculateTotalCostGeneric("SEA", "S", shipExData, boxSeaResultFees, 0);

    const calculateTotalKPACKCost = () => calculateTotalCostGeneric("KPack", "K", kpExData, boxKpResultFees, 0);
    const calculateTotalAIRSCost = () => calculateTotalCostGeneric("SPack", "A", asExData, boxAsResultFees, 0);

    //페덱스 30kg 초과시 ㄱ
    const calculateFedexPrice = (weight, groupCode) => {
        if (weight > 30) {
            if (groupCode === 'U') { //뉴질랜드, 호주
                if (groupCode === 'U' && orderData.recinfoDTO.countryDTO.countryCode === 'NZ') {
                    const roundedWeight = Math.ceil(weight);
                    return roundedWeight * 14900;
                } else if (groupCode === 'U' && orderData.recinfoDTO.countryDTO.countryCode === 'AU') {
                    return weight * 7900;
                }
            }
            if (groupCode === 'M') { //독일
                if (groupCode === 'M' && orderData.recinfoDTO.countryDTO.countryCode === 'DE') {
                    const roundedWeight = Math.ceil(weight);
                    return roundedWeight * 14200;
                }
            }
            if (groupCode === 'F') { //미국, 캐나다, 멕시코
                const roundedWeight = Math.ceil(weight);
                return roundedWeight * 11900;
            }
            if (groupCode === 'P') { //일본
                const roundedWeight = Math.ceil(weight);
                return roundedWeight * 8200;
            }
        }
        return 0;
    };

    const getFedexCalculatedValue = (box, fedexExData) => {
        const groupCode = fedexExData && fedexExData[0] ? fedexExData[0].appGroup : null;
        const weight = box.appliedWeights && box.appliedWeights.F ? box.appliedWeights.F : 0;
        return calculateFedexPrice(weight, groupCode);
    };

    /**
     * 국내배송 박스별 [자동조회 택배비]
     * - 기존과 동일하게 가로/세로/높이/실무게로 산출된 적용무게(appliedWeightsD.D)로 DB요금표(domeExData)를 조회
     * - 실무게 미입력이거나 30kg 초과인 경우는 요금표 대상이 아니므로 0
     */
    const getAutoDomePrice = (box) => {
        if (box.netWeight === "" || box.netWeight === null || box.netWeight === undefined) return 0;
        if (parseFloat(box.netWeight) > 30) return 0;
        return domeExData.length > 0 ? (getAmountForDomeWeight(box.appliedWeightsD.D, domeExData) || 0) : 0;
    };

    // 국내배송 박스별 택배비 수기입력 여부(빈문자열/undefined면 수기입력 아님)
    const isManualDomePrice = (index) => {
        const manual = manualPrices["DOME"]?.[index];
        return manual !== undefined && manual !== null && manual !== "";
    };

    /**
     * 국내배송 박스별 [최종 택배비]
     * - 관리자가 직접 입력한 값이 있으면 그 값을 우선 사용(30kg 초과 등 요금표에 없는 케이스 대응)
     * - 입력값이 없으면 기존과 동일하게 DB요금표 자동조회값 사용
     */
    const getFinalDomePrice = (box, index) => {
        if (isManualDomePrice(index)) {
            return parseInt(manualPrices["DOME"][index], 10) || 0;
        }
        return getAutoDomePrice(box);
    };

    const calculateTotalDOMECost = () => {
        let totalCost = 0;
        boxDomeData.forEach((box, index) => {
            totalCost += getFinalDomePrice(box, index);
        });
        return (totalCost).toLocaleString();
    };

    /** endregion */

    /** region Event */

    useEffect(() => {
        if (selectedCountry.value) {
            // [개선3] 수취국가가 바뀌면 이전 국가 요금표가 남아있으므로 조회완료 플래그를 초기화
            setExrLoaded({ems: false, kpack: false, sea: false});
            shipCompanySelect();
            fedexExrSelect();
            fedexEcoExrSelect();
            upsExrSelect();
            upsEcoExrSelect();
            emsExrSelect();
            emsPreExrSelect();
            shipExrSelect();
            kpackExrSelect();
            airSExrSelect();
        }
    }, [selectedCountry.value]);

    const selectPackSize = (price) => {
        if (price === 10000) {
            setPackSize('소형');
        } else if (price === 20000) {
            setPackSize('대형');
        } else {
            setPackSize('Select');
        }
    };

    useEffect(() => {
        if (vacPackPrice !== '') {
            selectPackSize(parseInt(vacPackPrice));
        }
    }, [vacPackPrice]);

    const shipCompanySelect = () => axios({
        method: 'get',
        url: '/shipcompany/bringToShipCo/' + '1',
    })
        .then((response) => {
            setShipcoData(response.data)
        })

    const fedexExrSelect = () => {
        axios.get('/shipinfo/fedexexrdata')
            .then((response) => {
                // const countryCode = orderData.type === 'orderdt'
                //     ? orderData.recinfoDTO.countryDTO.countryCode
                //     : orderData.type === 'payinfo'
                //         ? orderData.appRecDTO.countryDTO.countryCode
                //         : null;
                const countryCode = selectedCountry.value;
                if (!countryCode) return;

                const fCountryCode = response.data.filter(cData => {
                    return cData.appGroup === countryCode ||
                        (cData.appGroup === 'A' && countryCode === 'MO') ||
                        (cData.appGroup === 'D' && ['KH', 'LA', 'MN', 'BN', 'GU', 'RO', 'TI'].includes(countryCode)) ||
                        (cData.appGroup === 'F' && ['CA', 'US', 'MX', 'PR'].includes(countryCode)) ||
                        (cData.appGroup === 'G' && ['AT', 'CZ', 'DK', 'FI', 'GR', 'HU', 'IE', 'NO', 'PL', 'PT', 'SE', 'CH', 'CZ', 'FO', 'GL', 'LI', 'LU', 'MC', 'SK'].includes(countryCode)) ||
                        (cData.appGroup === 'H' && ['IL', 'TR', 'RU', 'UA', 'UZ', 'AL', 'AD', 'AM', 'AZ', 'BY', 'BA', 'BG', 'HR', 'CY', 'EE', 'GI', 'GE', 'IS', 'KG', 'KZ', 'LV', 'LT', 'MK', 'MT', 'MD', 'ME', 'RO', 'RS', 'SI'].includes(countryCode)) ||
                        (cData.appGroup === 'I' && ['AR', 'BR', 'CL', 'PE', 'AS', 'AI', 'AG', 'AW', 'BS', 'BB', 'BB', 'BZ', 'BM', 'BO', 'BQ', 'VG', 'KY', 'CO', 'CK', 'CR', 'CW', 'DM', 'BL', 'KN', 'SR', 'PF', 'TO', 'VG', 'TT', 'VC', 'VU', 'VE', 'MH', 'MQ', 'FM', 'MS', 'KN', 'NC', 'NI', 'VG', 'MP', 'PW', 'PG', 'PY', 'BQ', 'MP', 'WS', 'DO', 'TL', 'EC', 'SV', 'FJ', 'GD', 'GP', 'GY', 'HT', 'HN', 'JM'].includes(countryCode)) ||
                        (cData.appGroup === 'J' && ['BD', 'MA', 'QA', 'AE', 'JO', 'SA', 'AF', 'DZ', 'AO', 'BH', 'BJ', 'BT', 'BF', 'BI', 'CV', 'CM', 'BW', 'TD', 'CG', 'CD', 'DJ', 'ZW', 'ZM', 'YE', 'TZ', 'TN', 'UG', 'SZ', 'LK', 'ZA', 'SY', 'TG', 'SN', 'SC', 'RW', 'RE', 'QA', 'PS', 'PK', 'OM', 'NG', 'NE', 'NP', 'MZ', 'NA', 'MU', 'MR', 'ML', 'MV', 'MW', 'MG', 'EG', 'ER', 'ET', 'GA', 'GM', 'GH', 'GN', 'IQ', 'CI', 'KE', 'KW', 'LB', 'LS', 'LR', 'LY'].includes(countryCode)) ||
                        (cData.appGroup === 'M' && ['BE', 'DE', 'IT', 'NL', 'ES', 'GB', 'FR', 'IC', 'JE', 'VA', 'SM'].includes(countryCode)) ||
                        (cData.appGroup === 'N' && countryCode === 'VN') ||
                        (cData.appGroup === 'O' && countryCode === 'IN') ||
                        (cData.appGroup === 'P' && countryCode === 'JP') ||
                        (cData.appGroup === 'Q' && countryCode === 'MY') ||
                        (cData.appGroup === 'R' && countryCode === 'TH') ||
                        (cData.appGroup === 'S' && countryCode === 'PH') ||
                        (cData.appGroup === 'T' && countryCode === 'ID') ||
                        (cData.appGroup === 'U' && ['AU', 'NZ', 'NF'].includes(countryCode)) ||
                        (cData.appGroup === 'V' && countryCode === 'HK') ||
                        (cData.appGroup === 'W' && countryCode === 'CN') ||
                        (cData.appGroup === 'X' && countryCode === 'TW') ||
                        (cData.appGroup === 'Y' && countryCode === 'SG');
                });
                setFedexExData(fCountryCode);
            })
            .catch((error) => {
                console.error("err:", error);
            });
    }

    const fedexEcoExrSelect = () => {
        axios.get('/shipinfo/fedexEcoexrdata')
            .then((response) => {
                // const countryCode = orderData.type === 'orderdt'
                //     ? orderData.recinfoDTO.countryDTO.countryCode
                //     : orderData.type === 'payinfo'
                //         ? orderData.appRecDTO.countryDTO.countryCode
                //         : null;
                const countryCode = selectedCountry.value;
                if (!countryCode) return;

                const fCountryCode = response.data.filter(cData => {
                    return cData.appGroup === countryCode ||
                        (cData.appGroup === 'A' && countryCode === 'MO') ||
                        (cData.appGroup === 'D' && ['KH', 'LA', 'MN', 'BN', 'GU', 'RO', 'TI'].includes(countryCode)) ||
                        (cData.appGroup === 'F' && ['CA', 'US', 'MX', 'PR'].includes(countryCode)) ||
                        (cData.appGroup === 'G' && ['AT', 'CZ', 'DK', 'FI', 'GR', 'HU', 'IE', 'NO', 'PL', 'PT', 'SE', 'CH', 'CZ', 'FO', 'GL', 'LI', 'LU', 'MC', 'SK'].includes(countryCode)) ||
                        (cData.appGroup === 'H' && ['IL', 'TR', 'RU', 'UA', 'UZ', 'AL', 'AD', 'AM', 'AZ', 'BY', 'BA', 'BG', 'HR', 'CY', 'EE', 'GI', 'GE', 'IS', 'KG', 'KZ', 'LV', 'LT', 'MK', 'MT', 'MD', 'ME', 'RO', 'RS', 'SI'].includes(countryCode)) ||
                        (cData.appGroup === 'I' && ['AR', 'BR', 'CL', 'PE', 'AS', 'AI', 'AG', 'AW', 'BS', 'BB', 'BB', 'BZ', 'BM', 'BO', 'BQ', 'VG', 'KY', 'CO', 'CK', 'CR', 'CW', 'DM', 'BL', 'KN', 'SR', 'PF', 'TO', 'VG', 'TT', 'VC', 'VU', 'VE', 'MH', 'MQ', 'FM', 'MS', 'KN', 'NC', 'NI', 'VG', 'MP', 'PW', 'PG', 'PY', 'BQ', 'MP', 'WS', 'DO', 'TL', 'EC', 'SV', 'FJ', 'GD', 'GP', 'GY', 'HT', 'HN', 'JM'].includes(countryCode)) ||
                        (cData.appGroup === 'J' && ['BD', 'MA', 'QA', 'AE', 'JO', 'SA', 'AF', 'DZ', 'AO', 'BH', 'BJ', 'BT', 'BF', 'BI', 'CV', 'CM', 'BW', 'TD', 'CG', 'CD', 'DJ', 'ZW', 'ZM', 'YE', 'TZ', 'TN', 'UG', 'SZ', 'LK', 'ZA', 'SY', 'TG', 'SN', 'SC', 'RW', 'RE', 'QA', 'PS', 'PK', 'OM', 'NG', 'NE', 'NP', 'MZ', 'NA', 'MU', 'MR', 'ML', 'MV', 'MW', 'MG', 'EG', 'ER', 'ET', 'GA', 'GM', 'GH', 'GN', 'IQ', 'CI', 'KE', 'KW', 'LB', 'LS', 'LR', 'LY'].includes(countryCode)) ||
                        (cData.appGroup === 'M' && ['BE', 'DE', 'IT', 'NL', 'ES', 'GB', 'FR', 'IC', 'JE', 'VA', 'SM'].includes(countryCode)) ||
                        (cData.appGroup === 'N' && countryCode === 'VN') ||
                        (cData.appGroup === 'O' && countryCode === 'IN') ||
                        (cData.appGroup === 'P' && countryCode === 'JP') ||
                        (cData.appGroup === 'Q' && countryCode === 'MY') ||
                        (cData.appGroup === 'R' && countryCode === 'TH') ||
                        (cData.appGroup === 'S' && countryCode === 'PH') ||
                        (cData.appGroup === 'T' && countryCode === 'ID') ||
                        (cData.appGroup === 'U' && ['AU', 'NZ', 'NF'].includes(countryCode)) ||
                        (cData.appGroup === 'V' && countryCode === 'HK') ||
                        (cData.appGroup === 'W' && countryCode === 'CN') ||
                        (cData.appGroup === 'X' && countryCode === 'TW') ||
                        (cData.appGroup === 'Y' && countryCode === 'SG');
                });
                setFedexEcoExData(fCountryCode);
            })
            .catch((error) => {
                console.error("err:", error);
            });
    }

    const upsExrSelect = () => {
        axios.get('/shipinfo/upsexrdata')
            .then((response) => {
                // const countryCode = orderData.type === 'orderdt'
                //     ? orderData.recinfoDTO.countryDTO.countryCode
                //     : orderData.type === 'payinfo'
                //         ? orderData.appRecDTO.countryDTO.countryCode
                //         : null;
                const countryCode = selectedCountry.value;
                if (!countryCode) return;

                const countryGroups = {
                    Z1: ["SG", "TW", "MO"],
                    Z2: ["JP", "VN"],
                    Z3: ["ID", "TH", "MY", "PH"],
                    Z4: ["NZ", "AU", "NF", "IN"],
                    Z5: ["US", "CA", "MX"],
                    Z6: ["GB", "FR", "DE", "ES", "NL", "PL", "LU", "LI", "MC", "VA", "BE", "SM", "SE", "CH", "SK", "AD", "IT", "CZ"],
                    Z7: ["AT", "IE", "GR", "NO", "DK", "PT", "FI"],
                    Z8: ["TR", "RU", "LA", "CL", "AE", "KH", "BD", "SA", "PE", "GP", "GT", "GU", "GD", "GF", "ZA", "NC", "NI", "DO", "DM", "TL", "LV", "RO", "LT", "MQ", "MH", "MS", "MV", "MT", "MM", "FM", "VU", "BH", "BB", "BS", "VI", "VG", "VE", "BZ", "BW", "BO", "BT", "BG", "BR", "WS", "AS", "CY", "LC", "VC", "KN", "SB", "SR", "LK", "SI", "AW", "AR", "IS", "SV", "AZ", "AG", "AI", "ER", "EC", "OM", "HN", "WF", "UY", "UA", "EG", "JM", "GI", "QA", "CR", "CO", "KW", "HR", "TO", "PA", "PY", "PK", "PG", "PW", "FJ", "HU"],
                    Z9: ["IL", "MN", "GH", "GA", "GY", "GM", "GL", "GN", "GW", "NA", "NG", "NP", "NE", "LR", "LS", "RE", "RW", "MG", "YT", "MW", "ML", "MA", "MU", "MR", "MZ", "ME", "MD", "BM", "BJ", "BY", "BA", "BI", "BF", "MK", "BW", "MP", "SN", "RS", "SC", "SL", "AM", "AF", "AL", "DZ", "AO", "SZ", "EE", "ET", "JO", "UG", "UZ", "IQ", "ZM", "CF", "DJ", "ZW", "TD", "CM", "CV", "KZ", "KE", "CI", "CG", "TZ", "TG", "TN"],
                    Z0: ["CN", "HK"]
                };

                const sCountryCode = response.data.filter(cData => {
                    return cData.appUpsCode === countryCode ||
                        Object.entries(countryGroups).some(([upsCode, countries]) =>
                            countries.includes(countryCode) && cData.appUpsCode === upsCode
                        );
                });

                setUpsExData(sCountryCode);
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    const upsEcoExrSelect = () => {
        axios.get('/shipinfo/upsEcoexrdata')
            .then((response) => {
                // const countryCode = orderData.type === 'orderdt'
                //     ? orderData.recinfoDTO.countryDTO.countryCode
                //     : orderData.type === 'payinfo'
                //         ? orderData.appRecDTO.countryDTO.countryCode
                //         : null;
                const countryCode = selectedCountry.value;
                if (!countryCode) return;

                const countryGroups = {
                    Z1: ["SG", "TW", "MO"],
                    Z2: ["JP", "VN"],
                    Z3: ["ID", "TH", "MY", "PH"],
                    Z4: ["NZ", "AU", "NF", "IN"],
                    Z5: ["US", "CA", "MX"],
                    Z6: ["GB", "FR", "DE", "ES", "NL", "PL", "LU", "LI", "MC", "VA", "BE", "SM", "SE", "CH", "SK", "AD", "IT", "CZ"],
                    Z7: ["AT", "IE", "GR", "NO", "DK", "PT", "FI"],
                    Z8: ["TR", "RU", "LA", "CL", "AE", "KH", "BD", "SA", "PE", "GP", "GT", "GU", "GD", "GF", "ZA", "NC", "NI", "DO", "DM", "TL", "LV", "RO", "LT", "MQ", "MH", "MS", "MV", "MT", "MM", "FM", "VU", "BH", "BB", "BS", "VI", "VG", "VE", "BZ", "BW", "BO", "BT", "BG", "BR", "WS", "AS", "CY", "LC", "VC", "KN", "SB", "SR", "LK", "SI", "AW", "AR", "IS", "SV", "AZ", "AG", "AI", "ER", "EC", "OM", "HN", "WF", "UY", "UA", "EG", "JM", "GI", "QA", "CR", "CO", "KW", "HR", "TO", "PA", "PY", "PK", "PG", "PW", "FJ", "HU"],
                    Z9: ["IL", "MN", "GH", "GA", "GY", "GM", "GL", "GN", "GW", "NA", "NG", "NP", "NE", "LR", "LS", "RE", "RW", "MG", "YT", "MW", "ML", "MA", "MU", "MR", "MZ", "ME", "MD", "BM", "BJ", "BY", "BA", "BI", "BF", "MK", "BW", "MP", "SN", "RS", "SC", "SL", "AM", "AF", "AL", "DZ", "AO", "SZ", "EE", "ET", "JO", "UG", "UZ", "IQ", "ZM", "CF", "DJ", "ZW", "TD", "CM", "CV", "KZ", "KE", "CI", "CG", "TZ", "TG", "TN"],
                    Z0: ["CN", "HK"]
                };

                const sCountryCode = response.data.filter(cData => {
                    return cData.appUpsEcoCode === countryCode ||
                        Object.entries(countryGroups).some(([upsEcoCode, countries]) =>
                            countries.includes(countryCode) && cData.appUpsEcoCode === upsEcoCode
                        );
                });

                setUpsEcoExData(sCountryCode);
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    const emsExrSelect = () => {
        axios.get('/shipinfo/emsexrdata')
            .then((response) => {
                const countryCode = selectedCountry.value;
                if (!countryCode) return;

                // 1지역 (seqNum === 21)
                const region1 = [
                    'KH', // Cambodia
                    'LA', // Laos
                    'MO', // Macao
                    'MN', // Mongolia
                    'MM'  // Myanmar
                ];

                // 2지역 (seqNum === 22)
                const region2 = [
                    'BD', // Bangladesh
                    'BT', // Bhutan
                    'BN', // Brunei
                    'IN', // India
                    'MV', // Maldives
                    'NP', // Nepal
                    'LK'  // Sri Lanka
                ];

                // 3지역 (seqNum === 23)
                const region3 = [
                    'AL','AM','AT','AZ','BH','BY','BE','BG','BA','HR','CY','CZ',
                    'DK','EE','FI','GE','GR','HU','IR','IE','IL','JO','KZ','LV',
                    'LT','LU','MD','NL','MK','NO','OM','PK','PL','PT','QA','RO',
                    'SA','SK','SI','SE','CH','TR','UA','AE','UZ'
                ];

                // 4지역 (seqNum === 24)
                const region4 = [
                    'DZ','AR','BW','CV','CL','CR','CU','CW','DJ','DO','EC','EG',
                    'ET','FJ','KE','MU','MX','MA','MZ','NG','PA','PE','RW','TZ',
                    'TN','ZM'
                ];

                // 현재 선택된(countryCode) 배송사가 각 국가코드.includes에 해당하면 특정 식별값(cData.seqNum)의 요금표적용
                // Ex) 현재 countryCode값이 'BD'면 ems_exr_tb의 cData.seqNum === 22 요금데이터 적용
                const eCountryCode = response.data.filter(cData => {
                    return (
                        // 국가별 개별 코드가 DB에 직접 매칭되는 경우
                        cData.countryDTO.countryCode === countryCode ||

                        // 1지역
                        (region1.includes(countryCode) && cData.seqNum === 21) ||

                        // 2지역
                        (region2.includes(countryCode) && cData.seqNum === 22) ||

                        // 3지역
                        (region3.includes(countryCode) && cData.seqNum === 23) ||

                        // 4지역
                        (region4.includes(countryCode) && cData.seqNum === 24)
                    );
                });

                setEmsExData(eCountryCode);
                setExrLoaded(prev => ({...prev, ems: true})); // [개선3] EMS 요금표 조회완료
            })
            .catch((error) => {
                console.error("EMS 해당 수취국 요금데이터 적용실패: ", error);
            });
    };

    const emsPreExrSelect = () => {
        axios.get('/shipinfo/emsPreexrdata')
            .then((response) => {
                // const countryCode = orderData.type === 'orderdt'
                //     ? orderData.recinfoDTO.countryDTO.countryCode
                //     : orderData.type === 'payinfo'
                //         ? orderData.appRecDTO.countryDTO.countryCode
                //         : null;
                const countryCode = selectedCountry.value;
                if (!countryCode) return;

                const sCountryCode = response.data.filter(cData => {
                    return cData.appEmsPreCode === countryCode ||
                        (["CN", "HK", "MO", "TW"].includes(countryCode) && cData.appEmsPreCode === 'Z1') ||

                        (["BN", "KH", "JP", "LA", "MY", "SG", "TH", "VN"].includes(countryCode) && cData.appEmsPreCode === 'Z2') ||

                        (["AL", "AM", "AU", "AT", "AZ", "BH", "BE", "BG", "BA", "CA", "HR", "CZ", "DK", "GR",
                            "HU", "IS", "IN", "ID", "IE", "IT", "LV", "LU", "MV", "MD", "MN", "NL", "NZ", "MK", "NO",
                            "PG", "PH", "PL", "PT", "RO", "SK", "SI", "ES", "SE", "CH", "TR", "US", "AE", "GB", "BY", "BT"
                        ].includes(countryCode) && cData.appEmsPreCode === 'Z3') ||

                        (["DZ", "AO", "BS", "BB", "BJ", "BM", "BO", "BW", "BF", "CM", "CV", "TD", "CL", "CO",
                            "CR", "CI", "DJ", "EG", "ER", "ET", "FJ", "GT", "GY", "HT", "HN", "SV", "IL", "JM", "JO",
                            "KW", "LS", "LR", "ML", "MX", "MZ", "NI", "NE", "NG", "OM", "PK", "PA", "PY", "QA", "RW", "TZ", "TG", "ZM"
                        ].includes(countryCode) && cData.appEmsPreCode === 'Z4') ||

                        (["RU"].includes(countryCode) && cData.appEmsPreCode === 'ZR') ||

                        (["AF", "AD", "AG", "AR", "AW", "BD", "BZ", "BR", "BI", "CF", "CG", "DM", "DO", "TL", "GA",
                            "GM", "GH", "GI", "GL", "GD", "GP", "GU", "GF", "GN", "GW", "IQ", "KZ", "KE", "SZ", "KG",
                            "LB", "LI", "LT", "MG", "MW", "MT", "MP", "MQ", "MR", "MU", "YT", "FM", "MC", "MS", "MA",
                            "NA", "NP", "NC", "NF", "PW", "PE", "ZA", "RE", "ME", "KN", "LC", "VC", "AS", "SM", "SA",
                            "SN", "SC", "SL", "LK", "SR", "RS", "TO", "TN", "UG", "UA", "UY", "UZ", "VU", "VE", "VI", "VG", "WF", "WS", "ZW"
                        ].includes(countryCode) && cData.appEmsPreCode === 'Z5');
                });
                setEmsPreExData(sCountryCode);
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    const shipExrSelect = () => {
        axios.get('/shipinfo/shipexrdata')
            .then((response) => {
                // const countryCode = orderData.type === 'orderdt'
                //     ? orderData.recinfoDTO.countryDTO.countryCode
                //     : orderData.type === 'payinfo'
                //         ? orderData.appRecDTO.countryDTO.countryCode
                //         : null;
                const countryCode = selectedCountry.value;
                if (!countryCode) return;

                const sCountryCode = response.data.filter(cData => {
                    return cData.appShipCode === countryCode ||
                        (['CN', 'HK', 'JP', 'TW'].includes(countryCode) && cData.appShipCode === 'Z1') ||
                        (['BD', 'ID', 'MY', 'PH', 'SG', 'TH', 'VN'].includes(countryCode) && cData.appShipCode === 'Z2') ||
                        (['AU', 'CA', 'FL', 'FR', 'DE', 'IN', 'IE', 'NL', 'NO', 'PL', 'RU', 'ES', 'SE', 'US', 'GB', 'IE', 'NZ'].includes(countryCode) && cData.appShipCode === 'Z3') ||
                        (['BZ', 'PE', 'CL', 'MX'].includes(countryCode) && cData.appShipCode === 'Z4');
                });
                setShipExData(sCountryCode);
                setExrLoaded(prev => ({...prev, sea: true})); // [개선3] SEA(선편) 요금표 조회완료
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    const kpackExrSelect = () => {
        axios.get('/shipinfo/kpexrdata')
            .then((response) => {
                // const countryCode = orderData.type === 'orderdt'
                //     ? orderData.recinfoDTO.countryDTO.countryCode
                //     : orderData.type === 'payinfo'
                //         ? orderData.appRecDTO.countryDTO.countryCode
                //         : null;
                const countryCode = selectedCountry.value;
                if (!countryCode) return;

                const kCountryCode = response.data.filter(cData => {
                    return cData.countryDTO.countryCode === countryCode;
                });

                setKpExData(kCountryCode);
                setExrLoaded(prev => ({...prev, kpack: true})); // [개선3] K-Packet 요금표 조회완료
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    const airSExrSelect = () => {
        axios.get('/shipinfo/airsexrdata')
            .then((response) => {
                // const countryCode = orderData.type === 'orderdt'
                //     ? orderData.recinfoDTO.countryDTO.countryCode
                //     : orderData.type === 'payinfo'
                //         ? orderData.appRecDTO.countryDTO.countryCode
                //         : null;
                const countryCode = selectedCountry.value;
                if (!countryCode) return;

                const aCountryCode = response.data.filter(cData => {
                    return cData.appAsCode === countryCode ||
                        (["CN", "HK", "JP", "MO", "TW"].includes(countryCode) && cData.appAsCode === 'Z1') ||
                        (["BD", "BN", "KH", "TL", "ID", "LA", "MY", "MN", "MM", "PH", "SG", "TW", "VN", "TH"].includes(countryCode) && cData.appAsCode === 'Z2') ||
                        (["AF", "AL", "AD", "AM", "AU", "AT", "AZ", "BH", "BY", "BE", "BT", "BG", "BA",
                            "CA", "CX", "CC", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "GE", "DE", "GI", "GR",
                            "GL", "GU", "HU", "IS", "IL", "IT", "JO", "KZ", "KW", "KG", "LV", "LB", "LI", "LT",
                            "LU", "MV", "MT", "MP", "MD", "MC", "NP", "NL", "NZ", "NU", "NF", "MK", "NO", "OM",
                            "PK", "PG", "PL", "PT", "QA", "RO", "RU", "ME", "SM", "SA", "SK", "SI", "ES", "LK",
                            "SE", "CH", "RS", "TR", "UA", "AE", "GB", "UZ", "VA"
                        ].includes(countryCode) && cData.appAsCode === 'Z3') ||
                        (["DZ", "AO", "AG", "AR", "AW", "BS", "BB", "BZ", "BJ", "BM", "BW", "BR", "BF", "BI",
                            "CM", "CV", "CF", "TD", "CL", "CO", "CG", "CR", "CI", "CU", "DJ", "DM", "DO", "CG", "EG",
                            "GQ", "ER", "ET", "FJ", "FR", "GA", "GM", "GH", "GD", "GP", "GT", "GF", "GN", "GW", "GY",
                            "HN", "JM", "KE", "SZ", "LS", "LR", "MG", "MW", "ML", "MQ", "MR", "MU", "YT", "MX", "FM",
                            "MS", "MA", "MZ", "NA", "NR", "NC", "NI", "NE", "NG", "PW", "PE", "ZA", "RE", "RW", "KN",
                            "AS", "ST", "SN", "SC", "SB", "SO", "SD", "SR", "TZ", "TG", "TO", "TN", "UG", "UY", "VU",
                            "VE", "VI", "VG", "WF", "WS", "ZM", "ZW",
                        ].includes(countryCode) && cData.appAsCode === 'Z4') ||
                        (["US"].includes(countryCode) && cData.appAsCode === 'Z5');
                });
                setAsExData(aCountryCode);
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    useEffect(() => {
        const fetchDomeExData = async () => {
            try {
                const response = await axios.get("/shipinfo/domeexrdata");
                const volumeRanges = {
                    "V08": {min: 1, max: 80},
                    "V10": {min: 81, max: 100},
                    "V12": {min: 101, max: 120},
                    "V14": {min: 121, max: 140},
                    "V16": {min: 141, max: 160},
                    "V20": {min: 161, max: 200},
                };
                const totalVolume = parseFloat(boxDomeData[0].width) + parseFloat(boxDomeData[0].height) + parseFloat(boxDomeData[0].length);

                const filteredData = response.data.filter(item => {
                    const range = volumeRanges[item.volumes];
                    return totalVolume >= range.min && totalVolume <= range.max;
                });

                setDomeExData(filteredData);
            } catch (error) {
                console.error("Error: ", error);
            }
        };
        fetchDomeExData();
    }, [boxDomeData]);

    const boxesData = boxData.map((box, index) => {
        const checked = new Set(box.checkedCouriers || []);

        const getCheckedValue = (courierKey, value) => checked.has(courierKey) ? parseFloat(value || 0) : 0;

        return {
            wid: parseFloat(box.width || 0),
            ver: parseFloat(box.height || 0),
            hei: parseFloat(box.length || 0),
            weight: parseFloat(box.netWeight || 0),

            // FedEx
            fVweight: getCheckedValue("FedEx", getVolumeWeightFedex(box.width, box.height, box.length || 0)),
            fApyWeight: getCheckedValue("FedEx", box.appliedWeights.F),
            fpackInfo: box.fpackInfo || { F: false, E: false },

            // EMS
            eVweight: getCheckedValue("EMS", getVolumeWeightEms(box.width, box.height, box.length || 0)),
            eApyWeight: getCheckedValue("EMS", box.appliedWeights.E),

            // EMSP
            ePVweight: getCheckedValue("EMSP", getVolumeWeightEms(box.width, box.height, box.length || 0)),
            ePApyWeight: getCheckedValue("EMSP", box.appliedWeights.EP),

            // SEA
            sApyWeight: getCheckedValue("SEA", box.netWeight),

            // UPS
            pVweight: getCheckedValue("UPS", getVolumeWeightEms(box.width, box.height, box.length || 0)),
            pApyWeight: getCheckedValue("UPS", box.appliedWeights.P),

            // K-Packet
            kVweight: getCheckedValue("KPack", getVolumeWeightEms(box.width, box.height, box.length || 0)),
            kApyWeight: getCheckedValue("KPack", box.netWeight),

            // 항공소형
            aApyWeight: getCheckedValue("SPack", box.netWeight),

            // DHL (무조건 0)
            dVweight: 0,
            dApyWeight: 0,
        };
    });

    const boxesDomeData = boxDomeData.map((box, index) => ({
        wid: parseFloat(box.width || 0),
        ver: parseFloat(box.height || 0),
        hei: parseFloat(box.length || 0),
        weight: parseFloat(box.netWeight || 0),
        fVweight: 0,
        fApyWeight: 0,
        fedexPack: false,
        eVweight: 0,
        eApyWeight: 0,
        ePVweight: 0,
        ePApyWeight: 0,
        sApyWeight: 0,
        dhVweight: 0,
        dhApyWeight: 0,
        pVweight: 0,
        pApyWeight: 0,
        kVweight: 0,
        kApyWeight: 0,
        aApyWeight: 0,
        dVweight: (!isNaN(parseFloat(box.width)) ? parseFloat(box.width) : 0) + (!isNaN(parseFloat(box.height)) ? parseFloat(box.height) : 0) + (!isNaN(parseFloat(box.length)) ? parseFloat(box.length) : 0),
        dApyWeight: parseFloat(box.appliedWeightsD.D || 0),
    }));

    const shipModiInfoData = {
        seqNum: (orderData.dataType === 'payinfo') ? orderData.shipInfoDTO.seqNum : undefined,
    };

    const shipInfoData = boxesData.map((box, index) => {
        const originBox = boxData[index];
        const shipInfoState = originBox.shipInfoDTO || {};
        const fpackInfo = originBox.fpackInfo || { F: false, E: false };

        let dbFedexPackValue = false;

        // 박스정보(boxesData)별로 FedExPack 체크활성화되었을 경우 true 나머지는 false로 설정
        if (shipInfoState.fedexChecked) {
            dbFedexPackValue = fpackInfo.F;
        } else if (shipInfoState.fedexEcoChecked) {
            dbFedexPackValue = fpackInfo.E;
        }

        return {
            boxNum: `B${(index + 1).toString().padStart(4, '0')}`,
            wid: box.wid,
            ver: box.ver,
            hei: box.hei,
            weight: box.weight,

            fedexWeight: box.fVweight,
            fedexApyWeight: box.fApyWeight,
            fedexEcoWeight: box.fVweight,
            fedexEcoApyWeight: box.fApyWeight,
            fedexPack: dbFedexPackValue,

            emsWeight: box.eVweight,
            emsApyWeight: box.eApyWeight,

            emsPreWeight: box.ePVweight,
            emsPreApyWeight: box.ePApyWeight,

            seaApyWeight: box.sApyWeight,

            dhlWeight: 0,
            dhlApyWeight: 0,

            upsWeight: box.pVweight,
            upsApyWeight: box.pApyWeight,
            upsEcoWeight: box.pVweight,
            upsEcoApyWeight: box.pApyWeight,

            kpackWeight: box.kVweight,
            kpackApyWeight: box.kApyWeight,

            airSApyWeight: box.aApyWeight,
        };
    });

    const shipInfoDomeData = boxesDomeData.map((box, index) => ({
        boxNum: `B${(index + 1).toString().padStart(4, '0')}`,
        wid: box.wid || 0,
        ver: box.ver || 0,
        hei: box.hei || 0,
        weight: box.weight,
        fedexWeight: box.fVweight,
        fedexApyWeight: box.fApyWeight,
        fedexEcoWeight: box.fVweight,
        fedexEcoApyWeight: box.fApyWeight,
        fedexPack: box.fedexPack,
        emsWeight: box.eVweight,
        emsApyWeight: box.eApyWeight,
        emsPreWeight: box.eVweight,
        emsPreApyWeight: box.eApyWeight,
        seaApyWeight: box.sApyWeight,
        dhlWeight: 0,
        dhlApyWeight: 0,
        upsWeight: box.pVweight,
        upsApyWeight: box.pApyWeight,
        upsEcoWeight: box.pVweight,
        upsEcoApyWeight: box.pApyWeight,
        kpackWeight: box.kVweight,
        kpackApyWeight: box.kApyWeight,
        airSApyWeight: box.aApyWeight,
        domeWeight: box.dVweight,
        domeApyWeight: box.dApyWeight,
    }));

    const orderDtData = {
        seqnum: (orderData.dataType === 'orderdt') ? orderData.seqnum : orderData.orderdtDTO.seqnum,
        orderStatus: 'OS02'
    };

    const payInfoBuyData = {
        ttProdPrice: buyValue,
    };

    const tEp = (Number(etcValue) || 0) + (Number(codValue) || 0) + (Number(domeValue) || 0);
    const tEf = (Number(etcFeeValue) || 0) + (Number(deliveryFeeValue) || 0) + (Number(repackValue) || 0) + (Number(agenciesValue) || 0) + (Number(removeValue) || 0) + (Number(vacPackPrice) || 0);

    const payInfoEtcData = {
        courierPay: codValue ? codValue : 0,//착불비
        returnFee: domeValue ? domeValue : 0, //인천반송비
        etcCusPrice: numericFedexCusPrepay ? numericFedexCusPrepay : numericFedexEcoCusPrepay ? numericFedexEcoCusPrepay : numericUpsCusPrepay ? numericUpsCusPrepay : numericPostOfficeCusPrepay ? numericPostOfficeCusPrepay : 0, //관부가세선납(저장용X)
        deliveryFee: deliveryFeeValue ? deliveryFeeValue : 0, //배송대행수수료
        repackFee: repackValue ? repackValue : 0, //재포장수수료
        agencyFee: agenciesValue ? agenciesValue : 0, //대행수수료
        removeFee: removeValue ? removeValue : 0, //제거작업 수수료
        comprFee: vacPackPrice ? vacPackPrice : 0, //압축팩수수료
        etcPrice: etcValue ? etcValue : 0, //기타비용
        etcPriceNm: etcNmValue ? etcNmValue : '', //기타비용명
        ttEtcPrice: tEp, //총기타비용
        etcFee: etcFeeValue ? etcFeeValue : 0, //기타수수료
        etcFeeNm: etcFeeNmValue ? etcFeeNmValue : '', //기타수수료명
        ttEtcFee: tEf, //총기타수수료
        lastPrice: tEp + tEf
    };

    const [initialPayInfoBoxData, setInitialPayInfoBoxData] = useState();

    const getPayInfoBoxData = (selectedShipCompany, boxData) => {
        return boxData.map((box, index) => {
            // ✨ 현재 체크되어 있는 배송사 데이터 확인
            const checked = new Set(box.checkedCouriers || []);
            const fedexPrepay = parseInt(numericFedexCusPrepay || 0, 10);
            const fedexEcoPrepay = parseInt(numericFedexEcoCusPrepay || 0, 10);
            const upsPrepay = parseInt(numericUpsCusPrepay || 0, 10);
            const postOfficePrepay = parseInt(numericPostOfficeCusPrepay || 0, 10);

            const manualValueF = manualPrices["FedEx"]?.[index] ? parseInt(manualPrices["FedEx"][index]) : 0;
            const manualValueFe = manualPrices["FedEx-E"]?.[index] ? parseInt(manualPrices["FedEx-E"][index]) : 0;
            const manualValueP = manualPrices["UPS"]?.[index] ? parseInt(manualPrices["UPS"][index]) : 0;
            const manualValuePe = manualPrices["UPS-E"]?.[index] ? parseInt(manualPrices["UPS-E"][index]) : 0;

            const fedexPrice = manualValueF > 0 ? manualValueF : roundToTen(getAmountForWeight(box.appliedWeights.F, fedexExData));
            const fedexFuelSurch = manualValueF > 0 ? 0 : Math.round((fedexPrice * (fedexFuelValue / 100)) / 10) * 10;
            const fedexAddFee = parseInt(boxFedexResultFees[index]);
            const fedexOutOfArea = manualValueF > 0 ? 0 : outAreaCharge;
            const ttFedexPrice = fedexPrice + fedexFuelSurch + fedexAddFee + fedexPrepay + fedexOutOfArea;

            const fedexEcoPrice = manualValueFe > 0 ? manualValueFe : roundToTen(getAmountForWeight(box.appliedWeights.F, fedexEcoExData));
            const fedexEcoFuelSurch = manualValueFe > 0 ? 0 : Math.round((fedexEcoPrice * (fedexFuelValue / 100)) / 10) * 10;
            const ttFedexEcoPrice = fedexEcoPrice + fedexEcoFuelSurch + fedexAddFee + fedexEcoPrepay + fedexOutOfArea;

            const upsPrice = manualValueP > 0 ? manualValueP : roundToTen(getAmountForWeight(box.appliedWeights.P, upsExData));
            const upsFuelSurch = manualValueP > 0 ? 0 : Math.round((upsPrice * (upsFuelValue / 100)) / 10) * 10;
            const upsAddFee = parseInt(boxUpsResultFees[index]);
            const ttUpsPrice = upsPrice + upsFuelSurch + upsAddFee + upsPrepay;

            const upsEcoPrice = manualValuePe > 0 ? manualValuePe : roundToTen(getAmountForWeight(box.appliedWeights.P, upsEcoExData));
            const upsEcoFuelSurch = manualValuePe > 0 ? 0 : Math.round((upsEcoPrice * (upsFuelValue / 100)) / 10) * 10;
            const ttUpsEcoPrice = upsEcoPrice + upsEcoFuelSurch + upsAddFee + upsPrepay;

            const emsPrice = parseFloat(box.netWeight) > 30 || box.appliedWeights.E > 30 ? 0 : getAmountForWeight(box.appliedWeights.E, emsExData);
            const emsPrePrice = parseFloat(box.netWeight) > 70 || box.appliedWeights.EP > 70 ? 0 : getAmountForWeight(box.appliedWeights.EP, emsPreExData);
            const emsAddFee = parseFloat(box.netWeight) > 30 || box.appliedWeights.E > 30 ? 0 : parseInt(boxEmsResultFees[index]);
            const emsPreAddFee = parseFloat(box.netWeight) > 70 || box.appliedWeights.EP > 70 ? 0 : parseInt(boxEmsPreResultFees[index]);
            const ttEmsPrice = emsPrice + emsAddFee + postOfficePrepay;
            const ttEmsPrePrice = emsPrePrice + emsPreAddFee;

            const shipPrice = parseFloat(box.netWeight) > 20 ? 0 : getAmountForWeight(box.appliedWeights.S, shipExData);
            const seaAddFee = parseFloat(box.netWeight) > 20 ? 0 : parseInt(boxSeaResultFees[index]);
            const ttShipPrice = shipPrice + seaAddFee + postOfficePrepay;

            const kPackPrice = parseFloat(box.netWeight) > 2 && box.appliedWeights.K > 2 ? 0 : getAmountForWeight(box.appliedWeights.K, kpExData);
            const kpAddFee = parseFloat(box.netWeight) > 2 ? 0 : parseInt(boxKpResultFees[index]);
            const ttKPackPrice = kPackPrice + kpAddFee + postOfficePrepay;

            const asPrice = parseFloat(box.netWeight) > 2 && box.appliedWeights.A > 2 ? 0 : getAmountForWeight(box.appliedWeights.A, asExData);
            const asAddFee = parseFloat(box.netWeight) > 2 ? 0 : parseInt(boxAsResultFees[index]);
            const ttAirSPrice = asPrice + asAddFee + postOfficePrepay;

            const ttDomPrice = 0;
            let lastPrice;

            const isFedexChecked = checked.has("FedEx");
            const isFedexEcoChecked = checked.has("FedEx-E");
            const isUPSChecked = checked.has("UPS");
            const isUPSEcoChecked = checked.has("UPS-E");
            const isEMSChecked = checked.has("EMS");
            const isEMSPChecked = checked.has("EMSP");
            const isSeaChecked = checked.has("SEA");
            const isKPackChecked = checked.has("KPack");
            const isSPackChecked = checked.has("SPack");

            const finalFedexPrice = isFedexChecked ? ttFedexPrice : 0;
            const finalFedexEcoPrice = isFedexEcoChecked ? ttFedexEcoPrice : 0;
            const finalUpsPrice = isUPSChecked ? ttUpsPrice : 0;
            const finalUpsEcoPrice = isUPSEcoChecked ? ttUpsEcoPrice : 0;
            const finalEmsPrice = isEMSChecked ? ttEmsPrice : 0;
            const finalEmsPrePrice = isEMSPChecked ? ttEmsPrePrice : 0;
            const finalShipPrice = isSeaChecked ? ttShipPrice : 0;
            const finalKPackPrice = isKPackChecked ? ttKPackPrice : 0;
            const finalAirSPrice = isSPackChecked ? ttAirSPrice : 0;

            const defFedexPrice = isFedexChecked ? fedexPrice : 0;
            const defFedexEcoPrice = isFedexEcoChecked ? fedexEcoPrice : 0;
            const defUpsPrice = isUPSChecked ? upsPrice : 0;
            const defUpsEcoPrice = isUPSEcoChecked ? upsEcoPrice : 0;
            const defEmsPrice = isEMSChecked ? emsPrice : 0;
            const defEmsPrePrice = isEMSPChecked ? emsPrePrice : 0;
            const defShipPrice = isSeaChecked ? shipPrice : 0;
            const defKPackPrice = isKPackChecked ? kPackPrice : 0;
            const defAirSPrice = isSPackChecked ? asPrice : 0;

            const defFedexFuelSurch = isFedexChecked ? fedexFuelSurch : 0;
            const defFedexEcoFuelSurch = isFedexEcoChecked ? fedexEcoFuelSurch : 0;
            const defUpsFuelSurch = isUPSChecked ? upsFuelSurch : 0;
            const defUpsEcoFuelSurch = isUPSEcoChecked ? upsEcoFuelSurch : 0;
            const defFedexAddFee = isFedexChecked ? fedexAddFee : 0;
            const defFedexCusPrepay = isFedexChecked ? numericFedexCusPrepay : 0;
            const defFedexEcoAddFee  = isFedexEcoChecked ? fedexAddFee : 0;
            const defFedexEcoCusPrepay  = isFedexEcoChecked ? numericFedexEcoCusPrepay : 0;
            const defUpsAddFee  = isUPSChecked ? upsAddFee : 0;
            const defUpsCusPrepay  = isUPSChecked ? numericUpsCusPrepay : 0;
            const defUpsEcoAddFee  = isUPSEcoChecked ? upsAddFee : 0;
            const defUpsEcoCusPrepay  = isUPSEcoChecked ? numericUpsCusPrepay : 0;
            const defEmsAddFee  = isEMSChecked ? emsAddFee : 0;
            const defEmsCusPrepay  = isEMSChecked ? numericPostOfficeCusPrepay : 0;
            const defEmsPreAddFee  = isEMSPChecked ? emsPreAddFee : 0;
            const defShipAddFee  = isSeaChecked ? seaAddFee : 0;
            const defShipCusPrepay  = isSeaChecked ? numericPostOfficeCusPrepay : 0;
            const defKPackAddFee = isKPackChecked ? kpAddFee : 0;
            const defKPackCusPrepay  = isKPackChecked ? numericPostOfficeCusPrepay : 0;
            const defAirSAddFee  = isSPackChecked ? asAddFee : 0;
            const defAirSCusPrepay  = isSPackChecked ? numericPostOfficeCusPrepay : 0;

            let shipCompanyCode;
            switch (selectedShipCompany) {
                case "FedEx":
                    shipCompanyCode = "D01";
                    break;
                case "FedEx-E":
                    shipCompanyCode = "D16";
                    break;
                case "UPS":
                    shipCompanyCode = "D11";
                    break;
                case "UPS-E":
                    shipCompanyCode = "D17";
                    break;
                case "EMS":
                    shipCompanyCode = "D02";
                    break;
                case "EMSP":
                    shipCompanyCode = "D15";
                    break;
                case "K-Packet":
                    shipCompanyCode = "D13";
                    break;
                case "Small-Packet":
                    shipCompanyCode = "D14";
                    break;
                case "SEA":
                    shipCompanyCode = "D03";
                    break;
                case "국내배송":
                    shipCompanyCode = "D00";
                    break;
                default:
                    shipCompanyCode = "";
            }

            switch (selectedShipCompany) {
                case "FedEx":
                    lastPrice = finalFedexPrice;
                    break;
                case "FedEx-E":
                    lastPrice = finalFedexEcoPrice;
                    break;
                case "UPS":
                    lastPrice = finalUpsPrice;
                    break;
                case "UPS-E":
                    lastPrice = finalUpsEcoPrice;
                    break;
                case "EMS":
                    lastPrice = finalEmsPrice;
                    break;
                case "EMSP":
                    lastPrice = finalEmsPrePrice;
                    break;
                case "K-Packet":
                    lastPrice = finalKPackPrice;
                    break;
                case "Small-Packet":
                    lastPrice = finalAirSPrice;
                    break;
                case "SEA":
                    lastPrice = finalShipPrice;
                    break;
                default:
                    lastPrice = 0;
            }

            return {
                fedexPrice: defFedexPrice,
                fedexEcoPrice: defFedexEcoPrice,
                fedexFuelSurch: defFedexFuelSurch,
                fedexOutOfArea: fedexOutOfArea,
                fedexEcoFuelSurch: defFedexEcoFuelSurch,
                fedexAddFee: defFedexAddFee,
                fedexCusPrepay: defFedexCusPrepay,
                fedexEcoAddFee: defFedexEcoAddFee,
                fedexEcoCusPrepay: defFedexEcoCusPrepay,
                ttFedexPrice: finalFedexPrice,
                ttFedexEcoPrice: finalFedexEcoPrice,

                upsPrice: defUpsPrice,
                upsEcoPrice: defUpsEcoPrice,
                ttUpsPrice: finalUpsPrice,
                upsQuoteId: upsQuoteId,
                ttUpsEcoPrice: finalUpsEcoPrice,
                upsFuelSurch: defUpsFuelSurch,
                upsEcoFuelSurch: defUpsEcoFuelSurch,
                upsAddFee: defUpsAddFee,
                upsCusPrepay: defUpsCusPrepay,
                upsEcoAddFee: defUpsEcoAddFee,
                upsEcoCusPrepay: defUpsEcoCusPrepay,

                emsPrice: defEmsPrice,
                emsPrePrice: defEmsPrePrice,
                emsAddFee: defEmsAddFee,
                emsCusPrepay: defEmsCusPrepay,
                emsPreAddFee: defEmsPreAddFee,
                emsPreCusPrepay: 0,
                ttEmsPrice: finalEmsPrice,
                ttEmsPrePrice: finalEmsPrePrice,

                kpackPrice: defKPackPrice,
                kpackAddFee: defKPackAddFee,
                kpackCusPrepay: defKPackCusPrepay,
                ttKPackPrice: finalKPackPrice,

                airSPrice: defAirSPrice,
                airSAddFee: defAirSAddFee,
                airSCusPrepay: defAirSCusPrepay,
                ttAirSPrice: finalAirSPrice,

                seaPrice: defShipPrice,
                seaAddFee: defShipAddFee,
                seaCusPrepay: defShipCusPrepay,
                ttSeaPrice: finalShipPrice,

                ttDomPrice: ttDomPrice,

                dhlPrice: 0,
                dhlFuelSurch: 0,
                dhlAddFee: 0,
                dhlCusPrepay: 0,
                ttDhlPrice: 0,

                lastPrice: lastPrice,
                payStatus: 'PS0',
                dvType: shipCompanyCode,
            };
        });
    };

    const getPayInfoBoxDomeData = (boxDomeData) => {
        return boxDomeData.map((box, index) => {
            const fedexPrice = 0;
            const fedexEcoPrice = 0;
            const emsPrice = 0;
            const emsPrePrice = 0;
            const shipPrice = 0;
            const dhlPrice = 0;
            const upsPrice = 0;
            const upsEcoPrice = 0;
            const kPackPrice = 0;
            const asPrice = 0;
            const fedexFuelSurch = 0;
            const fedexOutOfArea = 0;
            const fedexEcoFuelSurch = 0;
            const upsFuelSurch = 0;
            const upsEcoFuelSurch = 0;
            const ttFedexPrice = 0;
            const ttEmsPrice = 0;
            const ttDhlPrice = 0;
            const ttUpsPrice = 0;
            const ttKPackPrice = 0;
            const ttAirSPrice = 0;
            const emsAddFee = 0;
            const fedexAddFee = 0;
            const seaAddFee = 0;
            const upsAddFee = 0;
            const kPackAddFee = 0;
            const airSAddFee = 0;
            // 관리자 수기입력값 우선, 없으면 DB요금표 자동조회값(기존 로직 동일)
            const ttDomPrice = getFinalDomePrice(box, index);
            const intToCusPrepay = 0;

            return {
                fedexPrice: fedexPrice,
                fedexEcoPrice: fedexPrice,
                emsPrice: emsPrice,
                emsPrePrice: emsPrice,
                seaPrice: shipPrice,
                dhlPrice: dhlPrice,
                upsPrice: upsPrice,
                upsEcoPrice: upsPrice,
                kpackPrice: kPackPrice,
                airSPrice: asPrice,
                fedexFuelSurch: fedexFuelSurch,
                fedexOutOfArea: fedexOutOfArea,
                fedexEcoFuelSurch: fedexEcoFuelSurch,
                ttFedexPrice: ttFedexPrice,
                ttFedexEcoPrice: ttFedexPrice,
                ttEmsPrice: ttEmsPrice,
                ttEmsPrePrice: ttEmsPrice,
                ttSeaPrice: shipPrice,
                ttDhlPrice: ttDhlPrice,
                dhlFuelSurch: 0,
                upsFuelSurch: upsFuelSurch,
                upsEcoFuelSurch: upsEcoFuelSurch,
                ttUpsPrice: ttUpsPrice,
                ttUpsEcoPrice: ttUpsPrice,
                ttKPackPrice: ttKPackPrice,
                ttAirSPrice: ttAirSPrice,
                fedexAddFee: fedexAddFee,
                fedexCusPrepay: intToCusPrepay,
                fedexEcoAddFee: fedexAddFee,
                fedexEcoCusPrepay: intToCusPrepay,
                emsAddFee: emsAddFee,
                emsCusPrepay: intToCusPrepay,
                emsPreAddFee: emsAddFee,
                emsPreCusPrepay: intToCusPrepay,
                seaAddFee: seaAddFee,
                seaCusPrepay: intToCusPrepay,
                dhlAddFee: 0,
                dhlCusPrepay: 0,
                upsAddFee: upsAddFee,
                upsCusPrepay: intToCusPrepay,
                upsEcoAddFee: upsAddFee,
                upsEcoCusPrepay: intToCusPrepay,
                kpackAddFee: kPackAddFee,
                kpackCusPrepay: intToCusPrepay,
                airSAddFee: airSAddFee,
                airSCusPrepay: intToCusPrepay,
                ttDomPrice: ttDomPrice,
                lastPrice: ttDomPrice,
                payStatus: 'PS2',
                dvType: 'D00'
            };
        });
    };

    // const appReqData = {
    //     seqnum: (orderData.reqmnDTO ? orderData.reqmnDTO.seqnum : (orderData.appReqDTO ? orderData.appReqDTO.seqnum : null))
    // };

    const appReqData = {
        seqnum: (orderData.reqmnDTO ? orderData.reqmnDTO.seqnum : (orderData.appReqDTO ? orderData.appReqDTO.seqnum : null)),
        deliveryAlarm: deliveryAlarm // 화면의 체크박스 상태값 사용
    };

    const appRecData = {
        seqnum: orderData.recinfoDTO ? orderData.recinfoDTO.seqnum : orderData.appRecDTO ? orderData.appRecDTO.seqnum : null,
        selectedCountry: selectedCountry.value
    };

    const [productBoxMap, setProductBoxMap] = useState({});

    const handleBoxSelectChange = (productSeq, boxIndex) => {
        setProductBoxMap((prev) => ({ ...prev, [productSeq]: boxIndex }));
    };

    // 배송료등록
    const expRegComplete = async () => {
        if (isLoading) return;

        // 세관신고항목 자식아이템 세팅(null이면 배송료등록 불가)
        const customsData = prepareCustomsData();
        if (!customsData) {
            return;
        }

        setIsLoading(true);

        try {
            const selectedProductData = boxData.flatMap(box => box.products);
            const selectedProducts = (orderData.productsDTO || orderData.packListDTO?.productsDTO || [])
                .filter(item =>
                    ['IS05', 'IS06'].includes(item.prodSt) && selectedProductData.includes(item.seqnum)
                );

            const productData = selectedProducts.map(product => {
                const boxIndex = productBoxMap?.[product.seqnum] ?? 0;
                const boxNum = `B${(boxIndex + 1).toString().padStart(4, '0')}`;

                return {
                    seqnum: product.seqnum,
                    prodSt: 'IS07',
                    boxNum
                };
            });

            const productInfoMData = orderData.packListDTO ?
                orderData.packListDTO.productsDTO.map(product => ({
                    seqnum: product.seqnum,
                    prodSt: 'IS07'
                })) : [];

            const selectedData = selectedShipCompany === "국내배송" ? shipInfoDomeData : shipInfoData;
            const productInfoData = selectedDataType === "orderdt" ? productData : productInfoMData;

            const formData = new FormData();

            const dataToAppend = {
                orderDtData,
                payInfoBuyData,
                payInfoEtcData,
                payInfoBoxData: selectedShipCompany === "국내배송" ? getPayInfoBoxDomeData(boxDomeData) : getPayInfoBoxData(selectedShipCompany, boxData),
                shipInfoData: selectedData,
                productInfoData,
                appReqData,
                appRecData,
                shipModiInfoData,
                dataType: orderData.dataType,
                tariffItems: customsData
            };

            console.log("customsData List : ", customsData)


            Object.entries(dataToAppend).forEach(([key, value]) => {
                formData.append(key, typeof value === 'string' ? value : JSON.stringify(value));
            });

            const response = await axios.post('/ordPay/expreginsert', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: LCAT
                }
            });

            if (selectedDataType === "orderdt" && stompClient && (Number(boxData[0].netWeight) > 0 || Number(boxesDomeData[0].weight) > 0)) {
                stompClient.send("/app/updateOrderList", {}, JSON.stringify({userMbNum: orderData?.memberDTO?.mbNum}));
                sendMessage();
            }

            setInitialPayInfoBoxData(selectedShipCompany === "국내배송" ? getPayInfoBoxDomeData(boxDomeData) : getPayInfoBoxData(selectedShipCompany, boxData));

            if (window.opener) {
                window.opener.location.reload();
                window.close();
            }
        } catch (error) {
            console.error("Error r:", error.response);
            console.error("Error m:", error.message);
            console.error("Error c:", error.config);
        } finally {
            setIsLoading(false);
        }
    };

    const getOutAreaStatus = async (countryCode, zipcode) => {
        let processedZip = zipcode;
        if (countryCode === 'CA' && zipcode && zipcode.length >= 3) {
            processedZip = zipcode.substring(0, 3);
        }
        try {
            const response = await axios.get('/zipcode/checkOutArea', {
                params: {
                    countryCode: countryCode,
                    zipCode: processedZip
                },
                headers: {
                    Authorization: LCAT
                }
            });
            return response.data;
        } catch (error) {
            console.error("서비스 외 지역 우편번호 조회 에러:", error);
            return false;
        }
    };

    const myPgLink = `https://btorage.com/UserMyPg`;
    // <a href="${myPgLink}">마이페이지 바로가기</a>

    const domesticChatKoMsg = `안녕하세요 ${orderData.memberDTO?.userName}님^^*\n포장완료 후 주문서 상세페이지의 결제목록에 국내배송료가 등록되었습니다.\n\n결제 전까지 결제목록의 '상세'버튼을 통해 열리는 팝업창에서\n최종 한국 수취인정보를 한 번 더 확인해주세요 :)\n\n저희 비토리지를 믿고 이용해주셔서 진심으로 감사드립니다 !`;
    const domesticChatEnMsg = `Hello ${orderData.memberDTO?.userName}^^*\nThe domestic shipping fee has been added to the payment list on the order details page after packaging is complete.\n\nBefore making payment, please double-check the final recipient information in Korea through the pop-up window that opens by clicking the 'Details' button in the payment list :)\n\nThank you sincerely for trusting and using Btorage!`;
    const domesticChatJaMsg = `こんにちは、${orderData.memberDTO?.userName}さん^^*\n梱包完了後、注文書詳細ページの決済リストに国内送料が登録されました。\n\n決済前に、決済リストの「詳細」ボタンから開くポップアップ画面で\n最終受取人情報をもう一度ご確認ください :)\n\nBtorageをご利用いただき、本当にありがとうございます！`;
    const domesticChatZhMsg = `您好，${orderData.memberDTO?.userName}^^*\n打包完成后，订单详情页面的支付列表中已登记国内运费。\n\n在支付之前，请通过支付列表中的“详情”按钮打开的弹窗\n再次确认最终的韩国收件人信息 :)\n\n感谢您信任并使用Btorage！`;
    const domesticChatIdMsg = `Halo ${orderData.memberDTO?.userName}^^*\nSetelah pengemasan selesai, biaya pengiriman domestik telah terdaftar di daftar pembayaran pada halaman detail pesanan.\n\nSebelum melakukan pembayaran, pastikan untuk memeriksa kembali informasi penerima terakhir di Korea melalui jendela pop-up yang terbuka saat Anda mengklik tombol 'Detail' di daftar pembayaran :)\n\nTerima kasih telah mempercayai dan menggunakan Btorage!`;

    const overseasChatKoMsg = `안녕하세요 ${orderData.memberDTO?.userName}님^^*\n포장완료 후 주문서 상세페이지의 결제목록에 해외배송료가 등록되었습니다.\n\n결제 전까지 결제목록의 '상세'버튼을 통해 열리는 팝업창에서\n반드시 최종 수취인정보/세관정보를 확인하신 후 배송사를 선택/결제해주세요 :)\n\n저희 비토리지를 믿고 이용해주셔서 진심으로 감사드립니다 !`;
    const overseasChatEnMsg = `Hello ${orderData.memberDTO?.userName}^^*\nThe international shipping fee has been added to the payment list on the order details page after packaging is complete.\n\nBefore making payment, please be sure to confirm the final recipient and customs information through the pop-up window that opens by clicking the 'Details' button in the payment list, then select the shipping company and proceed with payment :)\n\nThank you sincerely for trusting and using Btorage!`;
    const overseasChatJaMsg = `こんにちは、${orderData.memberDTO?.userName}さん^^*\n梱包完了後、注文書詳細ページの決済リストに海外送料が登録されました。\n\n決済前に、決済リストの「詳細」ボタンから開くポップアップ画面で\n必ず最終受取人情報/通関情報をご確認の上、配送業者を選択し決済してください :)\n\nBtorageをご利用いただき、本当にありがとうございます！`;
    const overseasChatZhMsg = `您好，${orderData.memberDTO?.userName}^^*\n打包完成后，订单详情页面的支付列表中已登记国际运费。\n\n在支付之前，请务必通过支付列表中的“详情”按钮打开的弹窗\n确认最终收件人信息/海关信息后再选择配送公司并支付 :)\n\n感谢您信任并使用Btorage！`;
    const overseasChatIdMsg = `Halo ${orderData.memberDTO?.userName}^^*\nSetelah pengemasan selesai, biaya pengiriman internasional telah terdaftar di daftar pembayaran pada halaman detail pesanan.\n\nSebelum melakukan pembayaran, pastikan untuk memeriksa informasi penerima terakhir/informasi bea cukai di jendela pop-up yang terbuka saat Anda mengklik tombol 'Detail' di daftar pembayaran,\nlalu pilih perusahaan pengiriman dan lanjutkan dengan pembayaran :)\n\nTerima kasih telah mempercayai dan menggunakan Btorage!`;

    const domesticEmailKoMsg = `안녕하세요 ${orderData.memberDTO?.userName}님^^*<br>포장완료 후 주문서 상세페이지의 결제목록에 국내배송료가 등록되었습니다.<br><br>결제 전까지 결제목록의 '상세'버튼을 통해 열리는 팝업창에서<br>최종 한국 수취인정보를 한 번 더 확인해주세요 :)<br><br>저희 비토리지를 믿고 이용해주셔서 진심으로 감사드립니다 !`;
    const domesticEmailEnMsg = `Hello ${orderData.memberDTO?.userName}^^*<br>The domestic shipping fee has been added to the payment list on the order details page after packaging is complete.<br><br>Before making payment, please double-check the final recipient information in Korea through the pop-up window that opens by clicking the 'Details' button in the payment list :)<br><br>Thank you sincerely for trusting and using Btorage!`;
    const domesticEmailJaMsg = `こんにちは、${orderData.memberDTO?.userName}さん^^*<br>梱包完了後、注文書詳細ページの決済リストに国内送料が登録されました。<br><br>決済前に、決済リストの「詳細」ボタンから開くポップアップ画面で<br>最終受取人情報をもう一度ご確認ください :)<br><br>Btorageをご利用いただき、本当にありがとうございます！`;
    const domesticEmailZhMsg = `您好，${orderData.memberDTO?.userName}^^*<br>打包完成后，订单详情页面的支付列表中已登记国内运费。<br><br>在支付之前，请通过支付列表中的“详情”按钮打开的弹窗<br>再次确认最终的韩国收件人信息 :)<br><br>感谢您信任并使用Btorage！`;
    const domesticEmailIdMsg = `Halo ${orderData.memberDTO?.userName}^^*<br>Setelah pengemasan selesai, biaya pengiriman domestik telah terdaftar di daftar pembayaran pada halaman detail pesanan.<br><br>Sebelum melakukan pembayaran, pastikan untuk memeriksa kembali informasi penerima terakhir di Korea melalui jendela pop-up yang terbuka saat Anda mengklik tombol 'Detail' di daftar pembayaran :)<br><br>Terima kasih telah mempercayai dan menggunakan Btorage!`;

    const overseasEmailKoMsg = `안녕하세요 ${orderData.memberDTO?.userName}님^^*<br>포장완료 후 주문서 상세페이지의 결제목록에 해외배송료가 등록되었습니다.<br><br>결제 전까지 결제목록의 '상세'버튼을 통해 열리는 팝업창에서<br>반드시 최종 수취인정보/세관정보를 확인하신 후 배송사를 선택/결제해주세요 :)<br><br>저희 비토리지를 믿고 이용해주셔서 진심으로 감사드립니다 !`;
    const overseasEmailEnMsg = `Hello ${orderData.memberDTO?.userName}^^*<br>The international shipping fee has been added to the payment list on the order details page after packaging is complete.<br><br>Before making payment, please be sure to confirm the final recipient and customs information through the pop-up window that opens by clicking the 'Details' button in the payment list, then select the shipping company and proceed with payment :)<br><br>Thank you sincerely for trusting and using Btorage!`;
    const overseasEmailJaMsg = `こんにちは、${orderData.memberDTO?.userName}さん^^*<br>梱包完了後、注文書詳細ページの決済リストに海外送料が登録されました。<br><br>決済前に、決済リストの「詳細」ボタンから開くポップアップ画面で<br>必ず最終受取人情報/通関情報をご確認の上、配送業者を選択し決済してください :)<br><br>Btorageをご利用いただき、本当にありがとうございます！`;
    const overseasEmailZhMsg = `您好，${orderData.memberDTO?.userName}^^*<br>打包完成后，订单详情页面的支付列表中已登记国际运费。<br><br>在支付之前，请务必通过支付列表中的“详情”按钮打开的弹窗<br>确认最终收件人信息/海关信息后再选择配送公司并支付 :)<br><br>感谢您信任并使用Btorage！`;
    const overseasEmailIdMsg = `Halo ${orderData.memberDTO?.userName}^^*<br>Setelah pengemasan selesai, biaya pengiriman internasional telah terdaftar di daftar pembayaran pada halaman detail pesanan.<br><br>Sebelum melakukan pembayaran, pastikan untuk memeriksa informasi penerima terakhir/informasi bea cukai di jendela pop-up yang terbuka saat Anda mengklik tombol 'Detail' di daftar pembayaran,<br>lalu pilih perusahaan pengiriman dan lanjutkan dengan pembayaran :)<br><br>Terima kasih telah mempercayai dan menggunakan Btorage!`;

    const domesticChatSendLang = orderData.memberDTO?.lang === "Korean" ? domesticChatKoMsg : orderData.memberDTO?.lang === "Chinese" ? domesticChatZhMsg :
        orderData.memberDTO?.lang === "Japanese" ? domesticChatJaMsg : orderData.memberDTO?.lang === "Indonesian" ? domesticChatIdMsg : domesticChatEnMsg;
    const overseasChatSendLang = orderData.memberDTO?.lang === "Korean" ? overseasChatKoMsg : orderData.memberDTO?.lang === "Chinese" ? overseasChatZhMsg :
        orderData.memberDTO?.lang === "Japanese" ? overseasChatJaMsg : orderData.memberDTO?.lang === "Indonesian" ? overseasChatIdMsg : overseasChatEnMsg;

    const domesticEmailSendLang = orderData.memberDTO?.lang === "Korean" ? domesticEmailKoMsg : orderData.memberDTO?.lang === "Chinese" ? domesticEmailZhMsg :
        orderData.memberDTO?.lang === "Japanese" ? domesticEmailJaMsg : orderData.memberDTO?.lang === "Indonesian" ? domesticEmailIdMsg : domesticEmailEnMsg;
    const overseasEmailSendLang = orderData.memberDTO?.lang === "Korean" ? overseasEmailKoMsg : orderData.memberDTO?.lang === "Chinese" ? overseasEmailZhMsg :
        orderData.memberDTO?.lang === "Japanese" ? overseasEmailJaMsg : orderData.memberDTO?.lang === "Indonesian" ? overseasEmailIdMsg : overseasEmailEnMsg;

    // const sendMessage = async () => {
    //     if (!stompClient && stompClient.connected) {
    //         console.log("메시지 전송실패: STOMP 클라이언트가 없습니다.");
    //         return;
    //     }
    //
    //     if (!orderData) {
    //         console.error("orderData가 null입니다. 메시지를 보낼 수 없습니다.");
    //         return;
    //     }
    //
    //     if (stompClient) {
    //         const mstMbNum = orderData.dataType === "payinfo" ? orderData.orderdtDTO?.memberDTO?.mbNum || null : orderData.memberDTO?.mbNum || null;
    //
    //         const mstUserNm = orderData.dataType === "payinfo" ? orderData.orderdtDTO.memberDTO.userName : orderData.memberDTO.userName;
    //
    //         const email = orderData.dataType === "payinfo" ? orderData.orderdtDTO?.memberDTO?.id || null : orderData.memberDTO?.id || null;
    //
    //         const lang = orderData.dataType === "payinfo" ? orderData.orderdtDTO.memberDTO.lang : orderData.memberDTO.lang;
    //
    //         const memberDTO = orderData.dataType === "payinfo" ? orderData.orderdtDTO?.memberDTO : orderData.memberDTO;
    //
    //         if (!mstMbNum || !email) {
    //             console.error("mstMbNum 또는 email이 null입니다. 메시지를 보낼 수 없습니다.");
    //             return;
    //         }
    //
    //         const chatMessage = {
    //             chatKey: selectedShipCompany === "국내배송" ? domesticChatSendLang : overseasChatSendLang,
    //             fileNm: null,
    //             chatOrdNum: Number(orderData.orderNumber),
    //             mbNum: adminInfo.mbNum,
    //             mstMbNum: mstMbNum,
    //             mstUserNm: mstUserNm,
    //             email: email,
    //             sendMailFl: true,
    //             autoChatFl: true,
    //             lang: lang,
    //             process: "PS0",
    //             emailKey: selectedShipCompany === "국내배송" ? domesticEmailSendLang : overseasEmailSendLang,
    //             memberDTO: memberDTO
    //         };
    //         await stompClient.send("/app/chat/adminMessage", {}, JSON.stringify(chatMessage));
    //     } else {
    //         console.log("메시지 전송실패");
    //     }
    // };

    const sendMessage = async () => {
        if (!orderData) {
            console.error("orderData가 null입니다. 메시지를 보낼 수 없습니다.");
            return false;
        }

        if (stompClient && stompClient.connected) {
            return await executeSend(stompClient);
        } else {
            console.log("웹소켓 끊김 감지, 재연결 시도 중...");
            try {
                const activeClient = await websocketConnect(adminInfo.mbNum);
                if (activeClient && activeClient.connected) {
                    return await executeSend(activeClient);
                }
            } catch (error) {
                console.error("재연결 실패:", error);
            }
            console.log("메시지 전송실패");
            return false;
        }
    };

    const executeSend = async (client) => {
        const mstMbNum = orderData.dataType === "payinfo" ? orderData.orderdtDTO?.memberDTO?.mbNum || null : orderData.memberDTO?.mbNum || null;
        const mstUserNm = orderData.dataType === "payinfo" ? orderData.orderdtDTO.memberDTO.userName : orderData.memberDTO.userName;
        const email = orderData.dataType === "payinfo" ? orderData.orderdtDTO?.memberDTO?.id || null : orderData.memberDTO?.id || null;
        const lang = orderData.dataType === "payinfo" ? orderData.orderdtDTO.memberDTO.lang : orderData.memberDTO.lang;
        const memberDTO = orderData.dataType === "payinfo" ? orderData.orderdtDTO?.memberDTO : orderData.memberDTO;

        if (!mstMbNum || !email) {
            console.error("mstMbNum 또는 email이 null입니다. 메시지를 보낼 수 없습니다.");
            return false;
        }

        const chatMessage = {
            chatKey: selectedShipCompany === "국내배송" ? domesticChatSendLang : overseasChatSendLang,
            fileNm: null,
            chatOrdNum: Number(orderData.orderNumber),
            mbNum: adminInfo.mbNum,
            mstMbNum: mstMbNum,
            mstUserNm: mstUserNm,
            email: email,
            sendMailFl: true,
            autoChatFl: true,
            lang: lang,
            process: "PS0",
            emailKey: selectedShipCompany === "국내배송" ? domesticEmailSendLang : overseasEmailSendLang,
            memberDTO: memberDTO
        };
        await client.send("/app/chat/adminMessage", {}, JSON.stringify(chatMessage));
        return true;
    };

    const regExit = () => {
        window.close();
    }

    // 1. orderData.productsDTO 순회하면서 prodTy === "P05"만 추출
    // 2. 1번에서 추출된 데이터 개수를 deliveryQy에 +해야하지만 그 전에 inWaynum 필드값을 모두 비교해서 값이 완벽하게 동일한 데이터들은 중복없이 deliveryQy에 +1만 count되어야 함
    // 3. 모두 추출+계산되어 값이 업데이트된 deliveryQy에 800을 곱하여 계산된 값을 setDeliveryFeeValue에 업데이트
    useEffect(() => {
        if (
            orderData &&
            orderData.productsDTO &&
            orderData.productsDTO.length > 0 &&
            !orderData.memberDTO.delFeeEmpFl
        ) {
            let deliveryQy = 0;
            const filteredProducts = orderData.productsDTO.filter(
                (product) =>
                    product.prodTy === "P05" && ["IS01", "IS05", "IS06"].includes(product.prodSt)
            );
            const uniqueInWaynumSet = new Set();
            filteredProducts.forEach((product) => {
                const normalizedWaynum = product.inWaynum?.replace(/[-\s]/g, "");
                if (!normalizedWaynum) {
                    deliveryQy += 1;
                } else if (!uniqueInWaynumSet.has(normalizedWaynum)) {
                    uniqueInWaynumSet.add(normalizedWaynum);
                    deliveryQy += 1;
                }
            });
            const calculatedFee = deliveryQy * 800;
            if (calculatedFee > 0) {
                // 기본수수료 3,000원
                setDeliveryFeeValue(3000 + calculatedFee);
            } else {
                setDeliveryFeeValue(calculatedFee);
            }
        } else {
            setDeliveryFeeValue(0);
        }
    }, [orderData]);

    /** endregion */

    const assignRef = useRef(null);



    /** 여기서부터 관부가세선납 토글팝업 */
    const [isTariffPanelOpen, setIsTariffPanelOpen] = useState(false);
    const [tariffItems, setTariffItems] = useState([]); // 부모(ordTariffData) 대신 자식 아이템 배열(tariffItems)을 직접 관리
    const [ordCustom, setOrdCustom] = useState([]); // HS Code 목록
    const [childItemShow, setChildItemShow] = useState({}); // HS Code 드롭다운 표시
    const [childSearchText, setChildSearchText] = useState({});

    useEffect(() => {
        customItemSelect();
    }, []);

    useEffect(() => {
        if (ordCustom.length === 0 || tariffItems.length === 0) return;

        setTariffItems(currentData => {
            const needsUpdate = currentData.some(child => child.hscode && !child.customItemDTO);
            if (!needsUpdate) {
                return currentData;
            }

            const hsCodeMap = new Map(ordCustom.map(item => [item.hsCode, item]));
            return currentData.map(child => {
                if (child.hscode && !child.customItemDTO) {
                    const matchingCustomItem = hsCodeMap.get(child.hscode);
                    return {
                        ...child,
                        customItemDTO: matchingCustomItem || null,
                    };
                }
                return child;
            });
        });
    }, [ordCustom, tariffItems]);

    // HS Code 검색창 초기값 설정
    useEffect(() => {
        if (tariffItems.length === 0) return;

        const initialChildSearchText = {};
        tariffItems.forEach((child, j) => {
            initialChildSearchText[`${j}`] = child.customItemDTO?.hsCodeNm || "";
        });
        setChildSearchText(initialChildSearchText);
    }, [tariffItems]);

    const handlePanelClick = (event) => {
        // hscode 타영역 클릭 시 닫기
        if (!event.target.closest('.hscode-dropdown-container')) {
            setChildItemShow({});
        }
        // 통화 타영역 클릭 시 닫기
        if (!event.target.closest('.currency-selector')) {
            setCurrencyShow({});
        }
    };

    // API 호출: HS Code 목록 가져오기
    const customItemSelect = () => {
        axios.get('/admincustomitem/admincustomitemselect')
            .then((response) => {
                setOrdCustom(response.data);
            })
            .catch(() => {})
    }

    // --- '자식 아이템' 전용 핸들러 ---

    // [수정] 자식 HS Code 드롭다운 토글
    const openChildItemShow = (index) => {
        const key = `${index}`;
        setChildItemShow({ [key]: true });
    };

    // [수정] 자식 HS Code 검색어 변경
    const handleChildSearchChange = (index, value) => {
        const key = `${index}`;
        setChildSearchText(prev => ({ ...prev, [key]: value }));
    };

    // [수정] 자식 HS Code 선택
    const handleChildItemChange = (selectedItem, index) => {
        const updatedData = tariffItems.map((item, i) => {
            if (i !== index) {
                return item;
            }
            // 선택된 HS Code 정보로 아이템 업데이트
            return {
                ...item,
                customItemDTO: selectedItem,
                content: selectedItem.hsCodeEnNm, // 내용(content) 자동 완성
                hscode: selectedItem.hsCode,       // hscode 필드 업데이트
                mcNm: selectedItem.mcNm,       // 제조사상호
                mcAddress: selectedItem.mcAddress,       // 제조사주소
                mcZipcode: selectedItem.mcZipcode,       // 제조사우편번호
            };
        });
        setTariffItems(updatedData);
        setChildItemShow(prev => ({ ...prev, [`${index}`]: false }));
    };

    // [보조] 콤마 제거 함수 (계산용)
    const unformat = (value) => {
        return String(value).replace(/,/g, '');
    };

    // [개선] 콤마 + 소수점 포맷팅 함수
    const formatCurrency = (value) => {
        if (value === null || value === undefined || value === '') return '';

        // 1. 일단 콤마를 모두 제거한 순수 숫자/소수점 문자열로 변환
        let strValue = unformat(value);

        // 2. 소수점 분리
        const parts = strValue.split('.');

        // 3. 정수 부분 처리 (콤마 추가)
        // 정수부가 너무 길어지는 것 방지 (DB 18자리 - 소수점 고려 안전하게 15~16자리 제한 추천, 여기선 요청대로 입력값 그대로 둠)
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        // 4. 소수점 뒷자리 처리 (2자리까지만 유지)
        if (parts.length > 1) {
            // 소수점이 존재하면 합침 (소수점 뒤 숫자가 2자리 넘어가면 자름)
            return parts[0] + '.' + parts[1].substring(0, 5);
        } else {
            return parts[0];
        }
    };

    // [수정] 자식 아이템 필드값 변경 (내용, 수량, 단가 등)
    const handleItemChange = (index, field, value) => {
        const updatedData = tariffItems.map((item, i) => {
            if (i !== index) return item;

            let processedValue = value;

            // --- 1. 입력값 정제 (수량) ---
            if (field === 'quantity') {
                // 숫자만 허용
                processedValue = value.replace(/\D/g, '');
            }

            // --- 2. 입력값 정제 (단가, 총단가) ---
            if (field === 'price' || field === 'ttPrice') {
                // 1) 숫자와 소수점(.)만 남기고 모두 제거 (한글, 영어 등 차단)
                let sanitized = value.replace(/[^0-9.]/g, '');

                // 2) 소수점이 여러 개면 첫 번째만 남김
                const parts = sanitized.split('.');
                if (parts.length > 2) {
                    sanitized = parts[0] + '.' + parts.slice(1).join('');
                }

                // 3) 정수부 / 소수부 길이 제한 (DB: decimal(18,2))
                // 정수부는 콤마 없이 16자리 정도가 안전 (18 - 2)
                const integerPart = parts[0];
                const decimalPart = parts[1];

                if (integerPart.length > 16) {
                    // 정수부가 너무 길면 잘라냄
                    sanitized = integerPart.substring(0, 16) + (decimalPart !== undefined ? '.' + decimalPart : '');
                }

                // 소수점 5자리 제한은 formatCurrency에서도 하지만, 입력 단계에서도 제어
                if (decimalPart && decimalPart.length > 5) {
                    sanitized = integerPart + '.' + decimalPart.substring(0, 5);
                }

                // 4) 최종적으로 콤마 포맷팅 적용하여 화면에 보여질 값 생성
                processedValue = formatCurrency(sanitized);
            }

            const updatedChildItem = {
                ...item,
                [field]: processedValue
            };

            // --- 3. 자동 계산 로직 ---

            // 사용자가 총단가를 직접 수정한 경우 플래그 설정
            if (field === 'ttPrice') {
                updatedChildItem.isTotalManual = true;
            }

            // 수량이나 단가가 변경되었고, 총단가 수동 모드가 아니라면 자동 계산
            if ((field === 'quantity' || field === 'price') && !updatedChildItem.isTotalManual) {
                updatedChildItem.isTotalManual = false;

                // [중요] 계산할 때는 콤마를 제거(unformat)하고 숫자로 변환해야 함
                const quantityNum = parseFloat(unformat(updatedChildItem.quantity)) || 0;
                const priceNum = parseFloat(unformat(updatedChildItem.price)) || 0;

                const total = quantityNum * priceNum;

                // 계산 결과 포맷팅 (소수점 있으면 2자리, 없으면 정수 + 콤마)
                // toFixed(2)는 문자열을 반환하며 반올림을 수행함
                // 예: 1.125 -> "1.13", 1000 -> "1000.00"

                let totalStr;
                if (total % 1 === 0) {
                    // 정수면 그냥 콤마만
                    totalStr = total.toString();
                } else {
                    // 소수면 5자리 고정
                    totalStr = total.toFixed(5);
                }

                updatedChildItem.ttPrice = formatCurrency(totalStr);
            }

            return updatedChildItem;
        });

        setTariffItems(updatedData);
    };

    // [수정] 자식 아이템 추가
    const addCustomItem = () => {
        setTariffItems(prevItems => [
            ...prevItems,
            {
                customItemDTO: null,
                content: "",
                quantity: "",
                price: "",
                ttPrice: "",
                currency: "USD",
                hscode: null,
                mcNm: null,
                mcAddress: null,
                mcZipcode: null,
                isTotalManual: false
            }
        ]);
    };

    // [수정] 자식 아이템 삭제
    const removeCustomItem = (index) => {
        setTariffItems(prevItems => prevItems.filter((_, i) => i !== index));
    };

    const [cusDataInputError, setCusDataInputError] = useState(false);
    const closeCusDataInputError = () => {
        setCusDataInputError(false);
    }

    // API 전송 직전에 호출할 세관신고 데이터 가공 함수
    const prepareCustomsData = () => {

        const itemCount = tariffItems.length;

        // [개선6] 세관신고 미작성 검증은 handleAlert()에서 [등록완료] 즉시 수행한다.
        //  여기서는 다른 경로로 진입했을 때를 대비한 '이중 안전망' 으로만 동일 조건을 한 번 더 확인한다.
        if (isCustomsDeclarationMissing()) {
            setAlertShow(false);
            setAlertShow3(false);
            setCusDataInputError(true);
            return null;
        }

        // 최종적으로 백엔드에 보낼 CustomsDTO 객체(초기화)
        let customsData = {
            customItemDTO: null, // HScode 정보객체
            customItemsDTO: null, // 자식 아이템 리스트
            custContent: null,
            custQty: null,
            custPrice: null,
            custCurrency: "USD",
            hscode: null
        };

        // 자식아이템이 1row일 때
        if (itemCount === 1) {
            const item = tariffItems[0];

            customsData.custContent = item.content;
            customsData.custQty = parseInt(item.quantity || 0, 10);
            // 1줄일 땐 총단가(ttPrice)를 부모의 가격(custPrice)으로 사용
            customsData.custPrice = parseFloat(unformat(item.ttPrice) || 0); // 가격 콤마제거
            customsData.custCurrency = item.currency || "USD";
            customsData.hscode = item.hscode;
            customsData.customItemDTO = item.customItemDTO;
            customsData.customItemsDTO = null; // 1줄일 땐 자식 리스트 null (백엔드 분기 처리용)
        }
        // 자식아이템이 2row 이상일 때
        else if (itemCount >= 2) {
            // 모든 자식 아이템의 수량 합계
            const totalQty = tariffItems.reduce((sum, item) => sum + (parseInt(item.quantity || 0, 10)), 0);
            // 모든 자식 아이템의 총단가(ttPrice) 합계
            const totalPrice = tariffItems.reduce((sum, item) => sum + (parseFloat(unformat(item.ttPrice) || 0)), 0); // 가격 콤마제거

            // 모든 자식 아이템의 내용품명 " and "로 연결
            customsData.custContent = tariffItems.map(item => item.content).join(" and ");
            customsData.custQty = totalQty;       // 총 수량
            customsData.custPrice = totalPrice;   // 총 가격
            customsData.custCurrency = tariffItems[0].currency || "USD";

            // 부모 DTO에 hscode 등 첫번째 자식데이터로 설정
            customsData.hscode = tariffItems[0].hscode;
            customsData.customItemDTO = tariffItems[0].customItemDTO;

            customsData.customItemsDTO = tariffItems.map(item => {
                const { customItemDTO, isTotalManual, ...rest } = item; // customItemDTO 필드를 분리
                return {
                    ...rest,
                    // 가격 콤마제거
                    currency: item.currency || "USD",
                    price: parseFloat(unformat(item.price) || 0),     // "2,341.4" -> 2341.4
                    ttPrice: parseFloat(unformat(item.ttPrice) || 0)  // "2,341.4" -> 2341.4
                };
                // return rest; // customItemDTO가 제거된 나머지 객체(content, hscode 등)만 반환
            });
        }

        return customsData;
    };

    // 자식아이템 개별통화
    const customCurrencyList = ['KRW', 'USD', 'CAD', 'AUD', 'NZD', 'EUR', 'JPY', 'SGD'];
    const [currencyShow, setCurrencyShow] = useState({});

    // 개별통화 드랍다운토글
    const toggleCurrencyShow = (index, e) => {
        e.stopPropagation(); // 이벤트 버블링 방지
        setCurrencyShow(prev => {
            const isCurrentlyOpen = !!prev[index];
            return { [index]: !isCurrentlyOpen };
        });
    };

    // 개별통화값 변경
    const handleCurrencyChange = (index, value) => {
        const updatedData = tariffItems.map((item, i) => {
            if (i !== index) return item;
            return { ...item, currency: value }; // 해당 아이템의 통화 변경
        });
        setTariffItems(updatedData);
        setCurrencyShow(prev => ({ ...prev, [index]: false })); // 선택 후 닫기
    };

    const [fedexLiveAccountNum, setFedexLiveAccountNum] = useState(null);
    const selectedLiveFedexAccount = async () => {
        try {
            const response = await axios.get('/credentials/secretManager/liveFedexAccount');
            setFedexLiveAccountNum(response.data);
        } catch (error) {
            console.error('Failed to Selected Live FedEx Account:', error);
        }
    };
    const [fedexSandboxAccountNum, setFedexSandboxAccountNum] = useState(null);
    const selectedSandboxFedexAccount = async () => {
        try {
            const response = await axios.get('/credentials/secretManager/sandboxFedexAccount');
            setFedexSandboxAccountNum(response.data);
        } catch (error) {
            console.error('Failed to Selected Sandbox FedEx Account:', error);
        }
    };

    const [upsLiveAccountNum, setUpsLiveAccountNum] = useState(null);
    const selectedLiveUpsAccount = async () => {
        try {
            const response = await axios.get('/credentials/secretManager/liveUpsAccount');
            setUpsLiveAccountNum(response.data);
        } catch (error) {
            console.error('Failed to Selected Live UPS Account:', error);
        }
    };

    useEffect(() => {
        // selectedSandboxFedexAccount();
        selectedLiveFedexAccount();
        selectedLiveUpsAccount();
    }, []);

    // FedEx 임시 로그기록용
    const fedexLogCountRef = useRef(0);
    const fedexIncreaseCount = () => {
        fedexLogCountRef.current += 1;
        return fedexLogCountRef.current;
    };
    // UPS 임시 로그기록용
    const upsLogCountRef = useRef(0);
    const upsIncreaseCount = () => {
        upsLogCountRef.current += 1;
        return upsLogCountRef.current;
    };

    // FedEx 관세조회 API
    const checkedFedExCusPrepay = async (type) => {
        const itemCount = tariffItems.length;

        if (itemCount === 0) {
            setCusDataInputError(true);
            return null;
        }

        // type에 따른 상태 변경(Setter) 함수 및 체크박스 Setter 매핑
        let setCusPrepay;
        let setCusPrepayCheckBox;

        if (type === "FEDEX") {
            setCusPrepay = setFedexCusPrepay;
            setCusPrepayCheckBox = setFedexCusPrepayCheckBox;
        } else if (type === "FEDEX-E") {
            setCusPrepay = setFedexEcoCusPrepay;
            setCusPrepayCheckBox = setFedexEcoCusPrepayCheckBox;
        } else {
            setCusPrepay = setPostOfficeCusPrepay;
            setCusPrepayCheckBox = () => {}; // 우체국용 체크박스 Setter가 있다면 여기에 할당
        }

        const customsData = prepareCustomsData();
        if (!customsData) {
            // 입력누락에러는 prepareCustomsData()함수 담당
            return;
        }

        const member = orderData.memberDTO;
        const customs = customsData;
        const shipInfo = boxData[0];

        const parentCurrency = customsData.custCurrency || "USD";
        const customItems = customs.customItemsDTO || [];

        const {address1, address2, address3, zipcode, recname, city, telnum} = orderData.recinfoDTO;
        const countryCode = orderData.recinfoDTO.countryDTO.countryCode;

        const fullAddress = [address1, address2, address3].filter(Boolean).join(' ');
        const streetLines = [];
        let remainingAddress = fullAddress.trim();
        const maxLines = 3; // FedEx API는 보통 streetLines를 2-3개까지 지원
        const maxLength = 35;
        while (remainingAddress.length > 0 && streetLines.length < maxLines) {
            // 남은 주소가 35자 이하면 그대로 추가하고 종료
            if (remainingAddress.length <= maxLength) {
                streetLines.push(remainingAddress);
                remainingAddress = '';
                break;
            }
            // 35자 이내에서 단어가 잘리지 않도록 마지막 공백 위치를 찾음
            let splitIndex = remainingAddress.substring(0, maxLength + 1).lastIndexOf(' ');
            // 만약 35자 이내에 공백이 없다면 (예: 매우 긴 단어), 그냥 35자에서 자름
            if (splitIndex <= 0) {
                splitIndex = maxLength;
            }
            const line = remainingAddress.substring(0, splitIndex);
            streetLines.push(line);
            remainingAddress = remainingAddress.substring(splitIndex).trim();
        }
        // streetLines 배열(최대 3줄)을 채우고도 남은 주소가 있다면, 기존 city 정보 앞에 추가
        const finalCity = remainingAddress.length > 0 ? `${remainingAddress} ${city}`.trim() : city;
        // const stateProvinceCode = (countryCode === 'US' || countryCode === 'CA' || countryCode === 'PR') ? await getStateCodeFromZip(zipcode, countryCode) : "";
        const stateProvinceCode = "";

        const useType = orderData.useType === "U0" ? "GIFT" : orderData.useType === "U1" ? "SOLD" : "SAMPLE"
        const residential = (orderData.useType === "U0" || orderData.useType === "U1");

        // 수취인 주소 객체
        const recipientAddress = {
            streetLines: streetLines,
            city: finalCity,
            stateOrProvinceCode: stateProvinceCode, // 백엔드에서 US/CA/PR일 경우 조회 필요
            postalCode: zipcode || "",
            countryCode: countryCode || "",
            residential: residential
        };

        const totalWeightValue = parseFloat(shipInfo.netWeight) || 0;
        const totalItemsValue = customs.custPrice; // prepareCustomsData에서 계산된 총액

        // --- Commodities 생성 로직 (AdminReceiptList.js의 fetchFedexData 로직 차용) ---
        let commodities;

        // CASE 1: 자식 아이템이 1개 초과일 때
        if (customItems.length > 0) {
            const averageItemWeight = customItems.length > 0 ? totalWeightValue / customItems.length : 0;
            const truncatedAvgWeight = Math.trunc(averageItemWeight * 10) / 10;

            commodities = customItems.map(childItem => {
                // const qty = Number(childItem.quantity) || 0;
                // const price = Number(childItem.price) || 0;
                // const numericUnitPrice = (qty > 0) ? Math.trunc((price / qty) * 1000) / 1000 : 0;

                const qty = Number(childItem.quantity) || 0;
                const totalItemPrice = Number(childItem.ttPrice) || (Number(childItem.price || 0) * qty);
                const calUnitPrice = Number((totalItemPrice / qty).toFixed(5));
                const calTotalValue = Number((calUnitPrice * qty).toFixed(5));
                const itemCurrency = childItem.currency || "USD";

                return {
                    description: childItem.content,
                    harmonizedCode: (childItem.hscode || '').replace(/\./g, ''),
                    quantity: qty,
                    quantityUnits: "PCS",
                    unitPrice: { amount: calTotalValue, currency: itemCurrency },
                    countryOfManufacture: "KR",
                    weight: { units: "KG", value: truncatedAvgWeight }, // KG
                    customsValue: { amount: calTotalValue, currency: itemCurrency } // 자식 아이템 총가
                };
            });
        }
        // CASE 2: 자식 아이템이 없거나 1개일 때 (부모 DTO 데이터 사용)
        else {
            // const qty = Number(customs.custQty) || 0;
            // const price = Number(customs.custPrice) || 0; // 부모 총가
            // const numericUnitPrice = (qty > 0) ? Math.trunc((price / qty) * 1000) / 1000 : 0; // 총가/총수량

            const qty = Number(customs.custQty) || 1;
            const originalTotalPrice = Number(customs.custPrice) || 0;
            // 1. 단가 역산
            const calUnitPrice = Number((originalTotalPrice / qty).toFixed(5));
            // 2. 총액 재계산 (단가 * 수량)
            const calTotalValue = Number((calUnitPrice * qty).toFixed(5));

            commodities = [{
                description: customs.custContent,
                harmonizedCode: (customs.hscode || '').replace(/\./g, ''),
                quantity: qty,
                quantityUnits: "PCS",
                unitPrice: { amount: calUnitPrice, currency: parentCurrency },
                countryOfManufacture: "KR", // 'KR'로 고정
                weight: { units: "KG", value: totalWeightValue || 0 }, // KG
                customsValue: { amount: calTotalValue, currency: parentCurrency } // 부모 총가
            }];
        }
        // --- End: 데이터 준비 ---


        // 2. FedEx Rate Quote API 요청 본문 생성
        const rateRequestPayload = {
            "accountNumber": {
                // Sandbox 계정 번호 사용
                "value": String(fedexLiveAccountNum)
            },
            "rateRequestControlParameters": {
                "returnTransitTimes": false,
                "servicesNeededOnRateFailure": true,
                "variableOptions": "FREIGHT_GUARANTEE",
                "rateSortOrder": "SERVICENAMETRADITIONAL"
            },
            "requestedShipment": {
                "edtRequestType": "ALL",
                "shipper": { // AdminReceiptList.js의 Btorage 발송인 정보
                    "address": {
                        "streetLines": ["32-15 Yeongok-gil 42beon-gil"],
                        "city": "Gonjiam-eup Gwangjusi",
                        "stateOrProvinceCode": "",
                        "postalCode": "12722",
                        "countryCode": "KR",
                        "residential": false
                    },
                    "contact": {
                        "personName": "IMEUNWOO",
                        "emailAddress": "hcm@btorage.com",
                        "phoneNumber": "821033389354",
                        "companyName": "Btorage"
                    }
                },
                "recipient": { // 위에서 준비한 수취인 정보
                    "address": recipientAddress,
                    "contact": {
                        "personName": recname,
                        "emailAddress": member.id,
                        "phoneNumber": telnum,
                        "companyName": ""
                    }
                },
                "serviceType": "FEDEX_INTERNATIONAL_PRIORITY",
                "preferredCurrency": "KRW", // 응답 관부가세 통화?
                "rateRequestType": [],
                "shipDateStamp": new Date().toISOString().slice(0, 10), // 오늘 날짜
                "pickupType": "USE_SCHEDULED_PICKUP",
                "requestedPackageLineItems": [
                    {
                        "groupPackageCount": 1,
                        "declaredValue": {
                            "amount": totalItemsValue, // 총 신고 금액
                            "currency": parentCurrency
                        },
                        "weight": {
                            "units": "KG",
                            "value": totalWeightValue
                        },
                        "dimensions": {
                            "length": shipInfo.width,
                            "width": shipInfo.length,
                            "height": shipInfo.height,
                            "units": "CM"
                        }
                    }
                ],
                "packagingType": (shipInfo.fpackInfo?.F || shipInfo.fpackInfo?.E) ? "FEDEX_PAK" : "YOUR_PACKAGING",
                "totalPackageCount": 1,
                "totalWeight": totalWeightValue,
                "customsClearanceDetail": {
                    "dutiesPayment": {
                        "paymentType": "SENDER" // *매우 중요*: 관부가세 조회를 위해 발송인(SENDER) 지불로 설정
                    },
                    "commodities": commodities, // 위에서 생성한 상품 목록
                    "commercialInvoice": {
                        "shipmentPurpose": useType
                    }
                }
            },
            "carrierCodes": [
                "FDXE",
                "FDXG"
            ]
        };

        // 3. 백엔드 API 호출
        try {
            const setCusPrepay = type === "FEDEX" ? setFedexCusPrepay : type === "FEDEX-E" ? setFedexEcoCusPrepay : setPostOfficeCusPrepay;

            setCusPrepay("Loading..."); // 조회 중임을 표시
            console.log("rateRequestPayload : ", rateRequestPayload)
            const response = await axios({
                method: 'post',
                url: '/externalApi/fedexRateQuote', // 새로 만들 백엔드 엔드포인트
                data: rateRequestPayload,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: LCAT
                }
            });

            // 4. 응답 처리
            const data = response.data;
            console.log("FedEx Rate Quote Response: ", data);

            // FedEx Rate API의 성공 응답 구조 (output.rateReplyDetails[...])
            if (data && data.output && data.output.rateReplyDetails && data.output.rateReplyDetails.length > 0) {

                const rateDetails = data.output.rateReplyDetails[0];

                if (rateDetails.ratedShipmentDetails && rateDetails.ratedShipmentDetails.length > 0) {
                    const shipmentDetails = rateDetails.ratedShipmentDetails[0];

                    // 응답 관세값
                    if (shipmentDetails && shipmentDetails.totalDutiesAndTaxes > 0) {
                        const rawDuties = parseFloat(shipmentDetails.totalDutiesAndTaxes);
                        // 마진 10% 및 금액 추가하고 소숫점 및 십원단위 제거
                        const fedexFinalDuties = Math.floor(((rawDuties * 1.1) + 22000) / 10) * 10;
                        const postOfficeFinalDuties = Math.floor(((rawDuties * 1.1) + 12000) / 10) * 10;
                        const finalDuties = (type === "FEDEX" || type === "FEDEX-E") ? fedexFinalDuties : postOfficeFinalDuties;
                        setCusPrepay(String(finalDuties));
                        // 값을 받아왔으므로 체크박스 상태도 자동으로 활성화 처리
                        if(finalDuties > 0) setCusPrepayCheckBox(true);

                        const id = fedexIncreaseCount();
                        console.log("마진 합산 전 응답관세[" + id + "] : ", rawDuties)
                        console.log("마진 합산 후 관세[" + id + "] : ", finalDuties)
                    } else {
                        // 관부가세가 0이거나 없는 경우
                        console.warn("totalDutiesAndTaxes not found or is zero.");
                        setCusPrepay("0");
                        setCusPrepayCheckBox(false);
                    }
                } else {
                    console.error("No 'ratedShipmentDetails' in FedEx response.");
                    alert("관부가세 조회에 실패했습니다. (No ratedShipmentDetails)");
                    setCusPrepay(""); // 오류
                }

            } else if (data && data.errors) {
                // FedEx API가 비즈니스 오류(e.g., 주소 불명확)를 반환한 경우
                console.error("FedEx API Error: ", data.errors);
                alert(`관부가세 조회 실패: ${data.errors[0].message}`);
                setCusPrepay("");
            } else {
                console.error("Invalid response structure from FedEx Rate API.");
                alert("관부가세 조회에 실패했습니다. (Invalid response)");
                setCusPrepay("");
            }

        } catch (error) {
            // 네트워크 또는 서버 오류 처리
            console.error('FedEx Rate Quote API 요청 실패:', error.response || error.message);
            // 백엔드에서 보낸 오류 메시지(FedEx 오류 포함)를 표시
            const errorMsg = error.response?.data?.errors?.[0]?.message ||
                error.response?.data?.errorMessage ||
                error.message;
            alert(`관부가세 조회 중 오류가 발생했습니다: ${errorMsg}`);
            setCusPrepay(""); // 오류 시 상태 초기화
        }
    }

    // UPS 관세조회 API
    const checkedUpsCusPrepay = async () => {
        const itemCount = tariffItems.length;

        if (itemCount === 0) {
            setCusDataInputError(true);
            return null;
        }

        if (!upsLiveAccountNum) {
            console.error("UPS 계약 번호(upsLiveAccountNum)가 없습니다.");
            alert("UPS 계약 번호를 불러오지 못했습니다. 새로고침 후 다시 시도해주세요.");
            return;
        }

        // console.log("orderData : ", orderData);
        // console.log("tariffItems : ", tariffItems);
        // console.log("boxData : ", boxData);

        const shipInfo = boxData[0]; // boxData가 shipInfoDTO와 동일한 구조라고 가정

        // --- 1. itemInput (GraphQL 변수용 데이터) ---
        const itemInput = tariffItems.map(item => {
            const quantity = parseInt(item.quantity || 1, 10);
            const unitPrice = parseFloat(item.price || 0);
            const itemCurrency = item.currency || "USD";

            return {
                amount: unitPrice,
                currencyCode: itemCurrency,
                name: item.content.slice(0, 35),
                description: item.content.slice(0, 70),
                countryOfOrigin: "KR",
                sku: item.hscode || "SKU-DEFAULT",
                quantity: quantity,
                hsCode: item.hscode || "0000.00.0000",
            };
        });

        // --- 2. cartonInput (GraphQL 변수용 데이터) ---
        const cartonInput = [{ // GCO API는 carton도 배열(input: [...])을 받음
            dimensionalUnit: "CENTIMETER",
            weight: parseFloat(shipInfo.netWeight || 1),
            weightUnit: "KILOGRAM",
            height: parseFloat(shipInfo.height || 10),
            length: parseFloat(shipInfo.length || 10),
            width: parseFloat(shipInfo.width || 10),
        }];

        // --- 3. partyInput (GraphQL 변수용 데이터) ---
        const {address1, address2, address3, zipcode, recname, city} = orderData.recinfoDTO;
        const countryCode = orderData.recinfoDTO.countryDTO.countryCode;

        // 주소 처리 로직 (기존과 동일)
        const fullAddress = [address1, address2, address3].filter(Boolean).join(' ');
        const addressLines = [];
        let remainingAddress = fullAddress.trim();
        const maxLines = 3;
        const maxLength = 35;
        while (remainingAddress.length > 0 && addressLines.length < maxLines) {
            if (remainingAddress.length <= maxLength) {
                addressLines.push(remainingAddress);
                remainingAddress = '';
                break;
            }
            let splitIndex = remainingAddress.substring(0, maxLength + 1).lastIndexOf(' ');
            if (splitIndex <= 0) { splitIndex = maxLength; }
            const line = remainingAddress.substring(0, splitIndex);
            addressLines.push(line);
            remainingAddress = remainingAddress.substring(splitIndex).trim();
        }
        const finalCity = remainingAddress.length > 0 ? `${remainingAddress} ${city}`.trim() : city;

        const partyInput = [
            {
                type: "ORIGIN",
                location: {
                    postalCode: "12722", // 발신자 우편번호 (AdminReceiptList.js 참조)
                    countryCode: "KR"
                }
            },
            {
                type: "DESTINATION",
                location: {
                    line1: addressLines[0] || "N/A",
                    ...(addressLines.length > 1 && { line2: addressLines[1] }),
                    ...(addressLines.length > 2 && { line3: addressLines[2] }),
                    administrativeArea: "", // 비워둠 (백엔드에서 처리 권장)
                    countryCode: countryCode,
                    locality: finalCity,
                    postalCode: zipcode
                }
            }
        ];

        // --- 4. ratingInput (GraphQL 변수용 데이터) ---
        const ratingInput = {
            serviceLevelCode: "ups.standard", // 예시 값
            amount: 0.00,
            currencyCode: "USD",
            displayName: "UPS Standard"
        };

        // --- 5. landedCostInput (GraphQL 변수용 데이터) ---
        const reasonForExport = orderData.useType === "U0" ? "NOT_FOR_RESALE" :
            orderData.useType === "U1" ? "NOT_FOR_RESALE" : "NOT_FOR_RESALE";

        const landedCostInput = {
            endUse: reasonForExport,
            currencyCode: "KRW",
            calculationMethod: "DDP_PREFERRED"
        };

        setUpsQuoteId(null);

        try {
            const response = await axios.post('/externalApi/upsLandedCost', {
                shipperNumber: upsLiveAccountNum,
                variables: {
                    partyInput: partyInput,
                    itemInput: itemInput,
                    cartonInput: cartonInput,
                    ratingInput: ratingInput,
                    landedCostInput: landedCostInput
                }
            });

            console.log("UPS GCO Response:", response.data);

            if (response.data.errors) {
                const errorMessage = response.data.errors[0].message || "UPS 관세 조회 실패";
                console.error("UPS GCO Error:", errorMessage);
                alert(`UPS 관세 조회 실패: ${errorMessage}`);
                setUpsCusPrepay("조회 실패");
                return;
            }

            const landedCostData = response.data.data.landedCostCalculateWorkflow;

            if (landedCostData && landedCostData.length > 0) {
                const actualData = landedCostData[0];
                const subtotals = actualData.amountSubtotals;

                // amountSubtotals가 존재하는지 안전하게 확인
                if (!subtotals) {
                    console.error("amountSubtotals 정보가 없습니다.");
                    setUpsCusPrepay("계산 오류");
                    return;
                }

                const rawTotalPrepay = (parseFloat(subtotals.duties) || 0) +
                    (parseFloat(subtotals.taxes) || 0) +
                    (parseFloat(subtotals.fees) || 0);

                const quoteId = actualData.id; // 여기도 actualData.id로 접근

                // 마진 10% 추가하고 소숫점 및 십원단위 제거
                if (rawTotalPrepay > 0) {
                    const finalDuties = Math.floor(((rawTotalPrepay * 1.1) + 10000) / 10) * 10;
                    setUpsCusPrepay(String(finalDuties));

                    const id = upsIncreaseCount();
                    console.log("마진 합산 전 응답관세[" + id + "] : ", rawTotalPrepay)
                    console.log("마진 합산 후 관세[" + id + "] : ", finalDuties)
                    console.log("Ups Quote Id : ", quoteId);
                } else {
                    setUpsCusPrepay("0");
                }
                setUpsQuoteId(quoteId);

            } else {
                // 데이터가 비어있거나 올바르지 않은 경우
                throw new Error("Landed cost data가 응답에 없습니다 (빈 배열).");
            }

        } catch (error) {
            console.error('UPS 관세조회 API 요청 실패:', error.response?.data || error.message);
            const errorMsg = error.response?.data?.errorMessage || error.message || "서버 통신 오류";
            alert(`관세 조회 중 오류 발생: ${errorMsg}`);
            setUpsCusPrepay("오류");
        }
    }

    const isHeavyOrLarge = (box) => {
        const w = parseFloat(box.width) || 0;
        const h = parseFloat(box.height) || 0;
        const l = parseFloat(box.length) || 0;
        const weight = parseFloat(box.netWeight) || 0;

        // 조건 1: 부피무게(5000) > 30
        const volWeight = (w * h * l) / 5000;
        // 조건 2: 실무게 > 30

        return volWeight > 30 || weight > 30;
    };





    return (
        <div className="AdminNewRegModal font-t-cont">
            <div className="an-header-frame">
                <div className="an-header-title display-flex flex-row just-cont-fstart c-def align-center p-l-17">
                    <img className="wd-35 ht-35" alt="" src={maCateImg}/>
                    <p className="font-t-title font-s-18 p-t-4 m-l-2" style={{color: "#FFF"}}>비용등록</p>
                </div>
                <div className="an-ord-info-frame c-def">
                    <div className="ht-100pc display-flex flex-column just-cont-sb">
                        <div className="display-flex flex-row just-cont-fstart m-b-5">
                            <img className="wd-18 ht-18 m-t-2 m-r-5" alt="" src={orderIMG}/>
                            <p className="font-b font-s-16">{orderData.orderNumber ? orderData.orderNumber : (orderData.orderdtDTO ? orderData.orderdtDTO.orderNumber : '')}</p>
                        </div>
                        <div className="display-flex flex-row just-cont-fstart">
                            <div className="display-flex flex-column wd-120 font-s-13" style={{backgroundColor: "#f3f3f3"}}>
                                <div className="pd12"><p className="m-l-8">고객명</p></div>
                                <div className="pd12"><p className="m-l-8">수취인명</p></div>
                                <div className="pd12"><p className="m-l-8">국가</p></div>
                                {/*<div className="pd7"><p className="m-l-7">배송사</p></div>*/}
                            </div>
                            <div className="display-flex flex-column wd-220 font-s-13 m-l-8">
                                <div className="pd12"><p>{orderData.memberDTO ? orderData.memberDTO.userName : (orderData.orderdtDTO ? orderData.orderdtDTO.memberDTO.userName : '')}</p></div>
                                <div className="pd12"><p className="font-b">{orderData.memberDTO ? orderData.recinfoDTO.recname : (orderData.orderdtDTO ? orderData.orderdtDTO.recinfoDTO.recname : '')}</p></div>
                                <div className="pd3">
                                    {/*국가 커스텀 셀렉트new*/}
                                    <div ref={countryRef} className="ht-37 c-point position-relative" onClick={toggleCountryShow}>
                                        <div className="order-rec-country-input display-flex flex-row wd-100pc ht-100pc">
                                            {selectedCountry.value ? (
                                                <div className="wd-15pc text-center align-center-c">
                                                    <div className={`m-l-6 font-s-20 fi fi-${selectedCountry.value.toLowerCase()}`} />
                                                </div>
                                            ) : (
                                                <div className="wd-15pc text-center align-center-c p-l-5">
                                                    <div className="wd-27 ht-20 text-center font-s-12 m-0-a country-select-flag">?</div>
                                                </div>
                                            )}
                                            <input className="country-select-in-input wd-100pc ht-100pc c-point font-s-13 p-l-15"
                                                   type="text" placeholder={"국가명 입력 또는 선택"} autoComplete="nope"
                                                   value={searchKeyword || (selectedCountry.value ? selectedCountry.label : '') || (selectedCountry.value ? selectedCountry.label : '')}
                                                   onChange={handleCountrySearch}
                                                   onKeyDown={handleKeyDown} />
                                            <i className="wd-10pc text-center align-center-c font-s-20 p-b-2 font-c-darkgrey">
                                                <BiCaretDown />
                                            </i>
                                        </div>
                                        {countryShow && (
                                            <div className="country-select-data wd-100pc position-absolute m-t-5">
                                                <div className="country-select-data-child">
                                                {filteredCountryList.map((country, index) => (
                                                    <div key={index} className={`selectCrListBt display-flex c-point p-t-10 p-b-10 p-l-20 ${
                                                        index === selectedIndex ? "arrow-selected" : ""
                                                    }`} onClick={(event) => handleCountryChange(country, event)}>
                                                        <div className={`font-s-17 m-r-8 fi fi-${country.value.toLowerCase()}`}></div>
                                                        <p className="font-s-15">{country.label}</p>
                                                    </div>
                                                ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    {/*여기까지 커스텀 국가셀렉트*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="an-cont-frame pop-scroll">
                <div className="m-a-open-bar m-a-open-bar-pc p-l-20 p-r-20 c-point" onClick={() => setShowCostInputs(!showCostInputs)}>
                    <p className="font-t-title font-s-14">비용입력</p>
                    {showCostInputs ?
                        <i className="m-a-ord-accordion-icon" style={{transform: "rotate(90deg)"}}/> :
                        <i className="m-a-ord-accordion-icon"></i>
                    }
                </div>
                {showCostInputs &&
                    <div className="m-a-top-border-card display-flex flex-column wd-100pc font-t-cont">
                        <div className="display-flex flex-row just-cont-sb wd-100pc m-b-13">
                            <div
                                className={`wd-30pc ht-40 font-s-15 p-t-8 c-def ${codCheckbox ? 'm-a-text-colored' : ''}`}>
                                <p className="">택배착불비</p></div>
                            <div className="m-a-input-frame ht-40 wd-60pc">
                                <input className="m-a-input wd-100pc p-l-5 text-right p-r-5" type="text" placeholder="0"
                                       maxLength="7" inputMode="numeric" pattern="\d*"
                                       value={codCheckbox ? parseInt(codValue).toLocaleString() : ""}
                                       onChange={(e) => {
                                           const newValue = e.target.value.replace(/,/g, '');
                                           if (/^\d*$/.test(newValue)) {
                                               setCodValue(newValue);
                                               setCodCheckbox(newValue !== '' && parseInt(newValue) !== 0);
                                           }
                                       }}
                                />
                            </div>
                        </div>
                        <div className="display-flex flex-row just-cont-sb wd-100pc m-b-13">
                            <div
                                className={`wd-30pc ht-40 font-s-15 p-t-8 c-def ${domeCheckbox ? 'm-a-text-colored' : ''}`}>
                                <p className="">국내반송비</p></div>
                            <div className="m-a-input-frame ht-40 wd-60pc">
                                <input className="m-a-input wd-100pc p-l-5 text-right p-r-5" type="text" placeholder="0"
                                       maxLength="7" inputMode="numeric" pattern="\d*"
                                       value={domeCheckbox ? parseInt(domeValue).toLocaleString() : ""}
                                       onChange={(e) => {
                                           const newValue = e.target.value.replace(/,/g, '');
                                           if (/^\d*$/.test(newValue)) {
                                               setDomeValue(newValue);
                                               setDomeCheckbox(newValue !== "" && parseInt(newValue) !== 0);
                                           }
                                       }}
                                />
                            </div>
                        </div>

                        {/* FedEx 관부가세선납 UI */}
                        <div className="display-flex flex-row just-cont-sb wd-100pc m-b-13">
                            <div
                                className={`wd-35pc ht-40 font-s-15 p-t-8 c-def ${fedexCusPrepayCheckBox ? 'm-a-text-colored' : ''}`}>
                                <div className="display-flex align-center gap5">
                                    <p className="">FedEx 관세선납</p>

                                    {/* 세관신고항목 자식아이템 팝업오픈 */}
                                    <button
                                        className="admin-btn-B user-center wd-20 ht-20 m-t-3 pd3"
                                        onClick={() => setIsTariffPanelOpen(true)}
                                    >
                                        <FiPlus className="wd-100pc ht-100pc"/>
                                    </button>

                                    <button onClick={() => checkedFedExCusPrepay("FEDEX")} className="admin-btn-B user-center wd-20 ht-20 m-t-3 pd2">
                                        <img src={fedexLogo} className="wd-100pc ht-40pc" alt="FedEx Logo"/>
                                    </button>
                                </div>
                            </div>
                            <div className="m-a-input-frame ht-40 wd-60pc">
                                <input className="m-a-input wd-100pc p-l-5 text-right p-r-5" type="text" placeholder="0"
                                       maxLength="7" inputMode="numeric" pattern="\d*"
                                       value={(fedexCusPrepay).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") || ""}
                                       onChange={(e) => {
                                           const newValue = e.target.value.replace(/,/g, '');
                                           if (/^\d*$/.test(newValue)) {
                                               setFedexCusPrepay(newValue);
                                               setFedexCusPrepayCheckBox(newValue !== "" && parseInt(newValue) !== 0);
                                           }
                                       }}
                                />
                            </div>
                        </div>

                        {/* FedEx-E 관부가세선납 UI */}
                        <div className="display-flex flex-row just-cont-sb wd-100pc m-b-13">
                            <div
                                className={`wd-35pc ht-40 font-s-15 p-t-8 c-def ${fedexEcoCusPrepayCheckBox ? 'm-a-text-colored' : ''}`}>
                                <div className="display-flex align-center gap5">
                                    <p className="">FedEx-E 관세선납</p>

                                    {/* 세관신고항목 자식아이템 팝업오픈 */}
                                    <button
                                        className="admin-btn-B user-center wd-20 ht-20 m-t-3 pd3"
                                        onClick={() => setIsTariffPanelOpen(true)}
                                    >
                                        <FiPlus className="wd-100pc ht-100pc"/>
                                    </button>

                                    <button onClick={() => checkedFedExCusPrepay("FEDEX-E")} className="admin-btn-B user-center wd-20 ht-20 m-t-3 pd2">
                                        <img src={fedexLogo} className="wd-100pc ht-40pc" alt="FedEx Logo"/>
                                    </button>
                                </div>
                            </div>
                            <div className="m-a-input-frame ht-40 wd-60pc">
                                <input className="m-a-input wd-100pc p-l-5 text-right p-r-5" type="text" placeholder="0"
                                       maxLength="7" inputMode="numeric" pattern="\d*"
                                       value={(fedexEcoCusPrepay).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") || ""}
                                       onChange={(e) => {
                                           const newValue = e.target.value.replace(/,/g, '');
                                           if (/^\d*$/.test(newValue)) {
                                               setFedexEcoCusPrepay(newValue);
                                               setFedexEcoCusPrepayCheckBox(newValue !== "" && parseInt(newValue) !== 0);
                                           }
                                       }}
                                />
                            </div>
                        </div>

                         {/* UPS 관부가세선납 UI */}
                        <div className="display-flex flex-row just-cont-sb wd-100pc m-b-13">
                            <div
                                className={`wd-35pc ht-40 font-s-15 p-t-8 c-def ${upsCusPrepayCheckBox ? 'm-a-text-colored' : ''}`}>
                                <div className="display-flex align-center gap5">
                                    <p className="">UPS 관세선납</p>

                                    {/* 세관신고항목 자식아이템 팝업오픈 */}
                                    <button
                                        className="admin-btn-B user-center wd-20 ht-20 m-t-3 pd3"
                                        onClick={() => setIsTariffPanelOpen(true)}
                                    >
                                        <FiPlus className="wd-100pc ht-100pc"/>
                                    </button>

                                    <button onClick={checkedUpsCusPrepay} className="admin-btn-B user-center wd-20 ht-20 m-t-3 pd3">
                                        <img src={upsLogo} className="wd-100pc ht-100pc" alt="Ups Logo"/>
                                    </button>
                                </div>
                            </div>
                            <div className="m-a-input-frame ht-40 wd-60pc">
                                <input className="m-a-input wd-100pc p-l-5 text-right p-r-5" type="text" placeholder="0"
                                       maxLength="7" inputMode="numeric" pattern="\d*"
                                       value={(upsCusPrepay).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") || ""}
                                       onChange={(e) => {
                                           const newValue = e.target.value.replace(/,/g, '');
                                           if (/^\d*$/.test(newValue)) {
                                               setUpsCusPrepay(newValue);
                                               setUpsCusPrepayCheckBox(newValue !== "" && parseInt(newValue) !== 0);
                                           }
                                       }}
                                />
                            </div>
                        </div>

                        {/* 우체국 관부가세선납 UI */}
                        <div className="display-flex flex-row just-cont-sb wd-100pc m-b-13">
                            <div
                                className={`wd-35pc ht-40 font-s-15 p-t-8 c-def ${postOfficeCusPrepayCheckBox ? 'm-a-text-colored' : ''}`}>
                                <div className="display-flex align-center gap5">
                                    <p className="">우체국 관세선납</p>

                                    {/* 세관신고항목 자식아이템 팝업오픈 */}
                                    <button
                                        className="admin-btn-B user-center wd-20 ht-20 m-t-3 pd3"
                                        onClick={() => setIsTariffPanelOpen(true)}
                                    >
                                        <FiPlus className="wd-100pc ht-100pc"/>
                                    </button>
                                    <button onClick={() => checkedFedExCusPrepay("POSTOFFICE")}
                                            className="admin-btn-B user-center wd-20 ht-20 m-t-3 pd2">
                                        <img src={postOfficeLogo} className="wd-100pc ht-40pc" alt="PostOffice Logo"/>
                                    </button>

                                </div>
                            </div>
                            <div className="m-a-input-frame ht-40 wd-60pc">
                                <input className="m-a-input wd-100pc p-l-5 text-right p-r-5" type="text" placeholder="0"
                                       maxLength="7" inputMode="numeric" pattern="\d*"
                                       value={(postOfficeCusPrepay).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") || ""}
                                       onChange={(e) => {
                                           const newValue = e.target.value.replace(/,/g, '');
                                           if (/^\d*$/.test(newValue)) {
                                               setPostOfficeCusPrepay(newValue);
                                               setPostOfficeCusPrepayCheckBox(newValue !== "" && parseInt(newValue) !== 0);
                                           }
                                       }}
                                />
                            </div>
                        </div>

                        {isTariffPanelOpen && (
                            <div
                                className="TariffCustomModal admin-modal-default"
                                // '드롭다운식 전체화면' 스타일
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: 'white',
                                    zIndex: 100,
                                    overflowY: 'auto'
                                }}
                                onClick={e => e.stopPropagation()} // 이벤트 버블링 방지
                            >
                                <div className="regModal openModal">
                                    <section style={{
                                        width: '100%',
                                        height: '100%',
                                        margin: 0,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        overflow: 'hidden'
                                    }} onClick={handlePanelClick}>
                                        <header style={{ flexShrink: 0 }}
                                            className="display-flex align-center justify-content-between admin-work-title pd10">
                                            <b style={{color: "#ffffff"}}>개별 자식아이템 세관신고</b>
                                            <button
                                                onClick={() => setIsTariffPanelOpen(false)}
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    color: 'white',
                                                    fontSize: '24px',
                                                    cursor: 'pointer',
                                                    paddingRight: '15px'
                                                }}
                                            >
                                                <FiX/>
                                            </button>
                                        </header>

                                        {/* 세관신고항목 자식아이템들 */}
                                        <main>
                                            <div className="div-tb m-b-10" style={{minHeight: "800px"}}>
                                                <div className="div-tb-head ht-50" style={{zIndex: 3}}>
                                                    <div style={{width: "40px"}}><p></p></div>
                                                    <div style={{width: "200px"}}><p>개별내용품명</p></div>
                                                    <div style={{width: "120px"}}><p>HS CODE</p></div>
                                                    <div style={{width: "30px"}}><p>수량</p></div>
                                                    <div style={{width: "80px"}}><p>단가</p></div>
                                                    <div style={{width: "80px"}}><p>총단가</p></div>
                                                    <div style={{width: "80px"}}><p>통화</p></div>
                                                    <div style={{width: "120px"}}><p></p></div>
                                                </div>

                                                {/* '자식 아이템' 목록 맵핑 */}
                                                {tariffItems.map((data, j) => (
                                                    <div key={j} className="user-center wd-100pc ht-50"
                                                         style={{padding: "10px 0",}}>
                                                        <div style={{width: "40px"}}>{j + 1}</div>

                                                        {/* 개별내용품명 */}
                                                        <div className="wd-200 m-r-10">
                                                            <input
                                                                className="admin-input-line ht-30 text-center font-s-12 m-l-5 wd-100pc"
                                                                maxLength={100}
                                                                type="text"
                                                                placeholder="개별내용품명"
                                                                value={data.content}
                                                                onChange={e => handleItemChange(j, "content", e.target.value)}
                                                            />
                                                        </div>

                                                         {/*자식아이템 (HS Code Dropdown) */}
                                                        <div className="childSearch wd-120 m-r-5" style={{position: "relative"}}
                                                             onClick={e => e.stopPropagation()}>
                                                            <input
                                                                style={{padding: "0 5px"}}
                                                                className="admin-input-line ht-30 font-s-12 wd-100pc text-center"
                                                                placeholder="HScode"
                                                                value={childSearchText[`${j}`] ?? (data.customItemDTO?.hsCodeNm || "")}
                                                                onChange={e => handleChildSearchChange(j, e.target.value)}
                                                                onFocus={() => openChildItemShow(j)}
                                                            />
                                                            {childItemShow[`${j}`] && (
                                                                <div
                                                                    className="selectChildBt" // 외부 클릭 감지를 위한 클래스
                                                                    style={{
                                                                        width: "200px",
                                                                        border: "solid 1px lightgray",
                                                                        position: "absolute",
                                                                        top: "120%",
                                                                        left: 0,
                                                                        backgroundColor: "white",
                                                                        zIndex: 2,
                                                                        maxHeight: "300px",
                                                                        overflowY: "auto",
                                                                    }}
                                                                >
                                                                    {ordCustom.filter(item => !childSearchText[`${j}`] ||
                                                                        item.hsCodeNm.includes(childSearchText[`${j}`]))
                                                                        .map((item, index) => (
                                                                            <div
                                                                                className="selectChildBt" // 외부 클릭 감지를 위한 클래스
                                                                                key={index}
                                                                                onClick={() => handleChildItemChange(item, j)}
                                                                                style={{
                                                                                    padding: "10px",
                                                                                    cursor: "pointer",
                                                                                    fontSize: "12px",
                                                                                    textAlign: "center"
                                                                                }}
                                                                            >
                                                                                {item.hsCodeNm}
                                                                            </div>
                                                                        ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                        {/*<div className="wd-120 m-r-10">*/}
                                                        {/*    <input*/}
                                                        {/*        className="admin-input-line ht-30 text-center font-s-12 m-l-5 wd-100pc"*/}
                                                        {/*        type="text"*/}
                                                        {/*        placeholder="테스트입력"*/}
                                                        {/*        value={data.hscode || ""} // data.hscode가 null이면 빈 문자열*/}
                                                        {/*        onChange={e => handleItemChange(j, "hscode", e.target.value)} // handleItemChange 재사용*/}
                                                        {/*    />*/}
                                                        {/*</div>*/}

                                                        {/* 개별수량 */}
                                                        <div className="wd-50 m-r-5">
                                                            <input
                                                                className="admin-input-line ht-30 text-center font-s-12 wd-100pc"
                                                                maxLength={5}
                                                                type="text"
                                                                placeholder="수량"
                                                                value={data.quantity}
                                                                onChange={e => handleItemChange(j, "quantity", e.target.value)}
                                                            />
                                                        </div>

                                                        {/* 개별단가 */}
                                                        <div className="wd-80 m-r-5">
                                                            <input
                                                                className="admin-input-line ht-30 text-center font-s-12 wd-100pc"
                                                                maxLength={20}
                                                                type="text"
                                                                placeholder="단가"
                                                                value={data.price}
                                                                onChange={e => handleItemChange(j, "price", e.target.value)}
                                                            />
                                                        </div>

                                                        {/* 총단가 */}
                                                        <div className="wd-80 m-r-5">
                                                            <input
                                                                className="admin-input-line ht-30 text-center font-s-12 wd-100pc"
                                                                maxLength={20}
                                                                type="text"
                                                                placeholder="총단가"
                                                                value={data.ttPrice}
                                                                onChange={e => handleItemChange(j, "ttPrice", e.target.value)}
                                                            />
                                                        </div>

                                                        {/*개별통화 셀렉트박스*/}
                                                        <div className="ht-30 wd-50 position-relative">
                                                            <button className="selectParentBt wd-100pc ht-100pc" onClick={(e) => toggleCurrencyShow(j, e)}>
                                                                <p style={{
                                                                    margin: "0",
                                                                    fontSize: "12px",
                                                                    padding: "0 5px"
                                                                }}>{data.currency || "USD"}</p>
                                                            </button>
                                                            {currencyShow[j] && (
                                                                <div style={{
                                                                    position: "absolute",
                                                                    width: "200%",
                                                                    border: "1px solid lightgray",
                                                                    backgroundColor: "white",
                                                                    zIndex: 999,
                                                                    top: "120%",
                                                                    left: 0,
                                                                    maxHeight: "200px",
                                                                    overflowY: "auto"
                                                                }}>
                                                                    {customCurrencyList.map((cur, idx) => (
                                                                        <div
                                                                            className="selectChildBt user-center pd5 c-point font-s-12"
                                                                            key={idx}
                                                                            onClick={() => handleCurrencyChange(j, cur)} // Index, Value 전달
                                                                            style={{ padding: '5px' }}
                                                                        >
                                                                            {cur}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* Add/Remove Buttons */}
                                                        <div className="user-center m-l-3" style={{width: "120px"}}>
                                                            <button
                                                                onClick={() => removeCustomItem(j)} // 해당 인덱스 아이템 삭제
                                                                className="admin-btn-B wd-45 ht-30 m-r-5">
                                                                <FiMinus/>
                                                            </button>
                                                            <button
                                                                onClick={addCustomItem} // 새 아이템 추가
                                                                className="admin-btn-B wd-45 ht-30">
                                                                <FiPlus/>
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}

                                                {/* 아이템이 하나도 없을 때 '추가' 버튼 표시 */}
                                                {tariffItems.length === 0 &&
                                                    <div style={{padding: '20px', textAlign: 'center'}}>
                                                        <button onClick={addCustomItem}
                                                                className="admin-btn-B wd-45 ht-30 m-t-3"><FiPlus/>
                                                        </button>
                                                    </div>
                                                }
                                            </div>
                                        </main>

                                        {/* [신규] Footer: '저장' 버튼 제거, '닫기' 버튼만 배치 */}
                                        <footer>
                                            <div className="user-center">
                                                <button
                                                    className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event"
                                                    onClick={() => setIsTariffPanelOpen(false)} // 패널 닫기
                                                >
                                                    닫기
                                                </button>
                                            </div>
                                        </footer>
                                    </section>
                                </div>
                            </div>
                        )}

                        <div className="display-flex flex-row just-cont-sb wd-100pc m-b-13">
                            <div
                                className={`wd-30pc ht-40 font-s-15 p-t-8 ${deliveryFeeCheckbox ? 'm-a-text-colored' : ''}`}>
                                <p className="">배송대행수수료</p></div>
                            <div className="m-a-input-frame ht-40 wd-60pc">
                                <input className="m-a-input wd-100pc p-l-5 text-right p-r-5" type="text" placeholder="0"
                                       maxLength="7" inputMode="numeric" pattern="\d*"
                                       value={deliveryFeeValue ? parseInt(deliveryFeeValue).toLocaleString() : ""}
                                       onChange={(e) => {
                                           const newValue = e.target.value.replace(/,/g, '');
                                           if (/^\d*$/.test(newValue)) {
                                               setDeliveryFeeValue(newValue);
                                               setDeliveryFeeCheckbox(newValue !== "" && parseInt(newValue) !== 0);
                                           }
                                       }}
                                />
                            </div>
                        </div>
                        <div className="display-flex flex-row just-cont-sb wd-100pc m-b-13">
                            <div
                                className={`wd-30pc ht-40 font-s-15 p-t-8 ${repackCheckbox ? 'm-a-text-colored' : ''}`}>
                                <p className="">재포장수수료</p></div>
                            <div className="m-a-input-frame ht-40 wd-60pc">
                                <input className="m-a-input wd-100pc p-l-5 text-right p-r-5" type="text" placeholder="0"
                                       maxLength="7" inputMode="numeric" pattern="\d*"
                                       value={repackCheckbox ? parseInt(repackValue).toLocaleString() : ""}
                                       onChange={(e) => {
                                           const newValue = e.target.value.replace(/,/g, '');
                                           if (/^\d*$/.test(newValue)) {
                                               setRePackValue(newValue);
                                               setRePackCheckbox(newValue !== "" && parseInt(newValue) !== 0);
                                           }
                                       }}
                                />
                            </div>
                        </div>
                        <div className="display-flex flex-row just-cont-sb wd-100pc m-b-13">
                            <div
                                className={`wd-30pc ht-40 font-s-15 p-t-8 c-def ${agenciesCheckbox ? 'm-a-text-colored' : ''}`}>
                                <p className="">대행수수료</p></div>
                            <div className="m-a-input-frame ht-40 wd-60pc">
                                <input className="m-a-input wd-100pc p-l-5 text-right p-r-5" type="text" placeholder="0"
                                       maxLength="8" inputMode="numeric" pattern="\d*"
                                       value={agenciesCheckbox ? parseInt(agenciesValue).toLocaleString() : ""}
                                       onChange={(e) => {
                                           const newValue = e.target.value.replace(/,/g, '');
                                           if (/^\d*$/.test(newValue)) {
                                               setAgenciesValue(newValue);
                                               setAgenciesCheckbox(newValue !== "" && parseInt(newValue) !== 0);
                                           }
                                       }}
                                />
                            </div>
                        </div>
                        {/* 제거작업 수수료 */}
                        <div className="display-flex flex-row just-cont-sb wd-100pc m-b-13">
                            <div
                                className={`wd-30pc ht-40 font-s-15 p-t-8 c-def ${removeCheckbox ? 'm-a-text-colored' : ''}`}>
                                <p className="">제거작업 수수료</p></div>
                            <div className="m-a-input-frame ht-40 wd-60pc">
                                <input className="m-a-input wd-100pc p-l-5 text-right p-r-5" type="text" placeholder="0"
                                       maxLength="8" inputMode="numeric" pattern="\d*"
                                       value={removeCheckbox ? parseInt(removeValue).toLocaleString() : ""}
                                       onChange={(e) => {
                                           const newValue = e.target.value.replace(/,/g, '');
                                           if (/^\d*$/.test(newValue)) {
                                               setRemoveValue(newValue);
                                               setRemoveCheckbox(newValue !== "" && parseInt(newValue) !== 0);
                                           }
                                       }}
                                />
                            </div>
                        </div>
                        <div className="display-flex flex-row just-cont-sb wd-100pc m-b-13">
                            <div
                                className={`wd-30pc ht-40 font-s-15 p-t-8 c-def ${vacuumPack ? 'm-a-text-colored' : ''}`}>
                                <p className="">압축팩수수료</p></div>
                            <div className="wd-26pc font-s-14 font-c-default font-t-cont" style={{marginLeft: "6%"}}>
                                <select className="admin-combo wd-100pc ht-40" value={packSize}
                                        onChange={handleVacPackSizeChange}>
                                    <option value="선택">선택</option>
                                    <option value="소형">소형</option>
                                    <option value="대형">대형</option>
                                </select>
                            </div>
                            <div className="m-a-input-frame ht-40 wd-30pc">
                                <input className="m-a-input wd-100pc p-l-5 text-right p-r-5" type="text" placeholder="0"
                                       disabled={true}
                                       value={vacuumPack ? parseInt(vacPackPrice).toLocaleString() : ""}/>
                            </div>
                        </div>
                        <div className="display-flex flex-row just-cont-sb wd-100pc m-b-13">
                            <div
                                className={`wd-30pc ht-40 font-s-15 p-t-8 c-def ${etcCheckbox ? 'm-a-text-colored' : ''}`}>
                                <p className="">기타비용</p></div>
                            <div className="m-a-input-frame ht-40 wd-60pc">
                                <input className="m-a-input wd-100pc p-l-5 text-right p-r-5" type="text" placeholder="0"
                                       maxLength="8" inputMode="numeric" pattern="\d*"
                                       value={etcCheckbox ? parseInt(etcValue).toLocaleString() : ""}
                                       onChange={(e) => {
                                           const newValue = e.target.value.replace(/,/g, '');
                                           if (/^\d*$/.test(newValue)) {
                                               setEtcValue(newValue);
                                               setEtcCheckbox(newValue !== "" && parseInt(newValue) !== 0);
                                           }
                                       }}
                                />
                            </div>
                        </div>
                        <div className="display-flex flex-row just-cont-sb wd-100pc m-b-13">
                            <div
                                className={`wd-30pc ht-40 font-s-15 p-t-8 c-def ${etcNmValue ? 'm-a-text-colored' : ''}`}>
                                <p className="">기타비용 내용</p></div>
                            <div className="m-a-input-frame ht-40 wd-60pc">
                                <input className="m-a-input wd-100pc p-l-5 font-s-14" type={"text"} maxLength={100}
                                       placeholder="비용 입력시 활성화"
                                       value={etcCheckbox ? etcNmValue : ""} disabled={etcCheckbox === false}
                                       onChange={(e) => {
                                           setEtcNmValue(e.target.value)
                                       }}
                                />
                            </div>
                        </div>
                        <div className="display-flex align-items-center justify-content-center border-rd6 m-b-20"
                             style={{lineHeight: "20px", border: "solid 1px #EAEAEA", padding: "20px 0"}}>
                            <div className="text-left font-s-12">
                                <p style={{color: "#DB5744", fontSize: "13px"}}>※ 누락된 각 해외배송료 추가 시 반드시 기타비용 내용에 아래문구로
                                    통일</p>
                                <div className="display-flex align-center">
                                    <p>- Add missing</p>
                                    <p style={{color: "#4B89DC"}}>&nbsp;FedEx&nbsp;</p>
                                    <p>international shipping charges</p>
                                </div>
                                <div className="display-flex align-center">
                                    <p>- Add missing</p>
                                    <p style={{color: "#4B89DC"}}>&nbsp;UPS&nbsp;</p>
                                    <p>international shipping charges</p>
                                </div>
                                <div className="display-flex align-center">
                                    <p>- Add missing</p>
                                    <p style={{color: "#4B89DC"}}>&nbsp;Post-Office&nbsp;</p>
                                    <p>international shipping charges</p>
                                </div>
                                <div className="display-flex align-center">
                                    <p>- Add missing</p>
                                    <p style={{color: "#4B89DC"}}>&nbsp;K-Packet&nbsp;</p>
                                    <p>international shipping charges</p>
                                </div>
                                <div className="display-flex align-center">
                                    <p>- Add missing</p>
                                    <p style={{color: "#4B89DC"}}>&nbsp;S-Packet&nbsp;</p>
                                    <p>international shipping charges</p>
                                </div>
                                <div className="display-flex align-center">
                                    <p>- Add missing</p>
                                    <p style={{color: "#4B89DC"}}>&nbsp;Sea-Parcel&nbsp;</p>
                                    <p>international shipping charges</p>
                                </div>
                                <div className="display-flex align-center">
                                    <p>- Add missing</p>
                                    <p style={{color: "#4B89DC"}}>&nbsp;Domestic_Delivery&nbsp;</p>
                                    <p>international shipping charges</p>
                                </div>
                            </div>
                        </div>
                        <div className="display-flex flex-row just-cont-sb wd-100pc m-b-13">
                            <div
                                className={`wd-30pc ht-40 font-s-15 p-t-8 c-def ${etcFeeCheckbox ? 'm-a-text-colored' : ''}`}>
                                <p className="">기타수수료</p></div>
                            <div className="m-a-input-frame ht-40 wd-60pc">
                                <input className="m-a-input wd-100pc p-l-5 text-right p-r-5" type="text" placeholder="0"
                                       maxLength="8" inputMode="numeric" pattern="\d*"
                                       value={etcFeeCheckbox ? parseInt(etcFeeValue).toLocaleString() : ""}
                                       onChange={(e) => {
                                           const newValue = e.target.value.replace(/,/g, '');
                                           if (/^\d*$/.test(newValue)) {
                                               setEtcFeeValue(newValue);
                                               setEtcFeeCheckbox(newValue !== "" && parseInt(newValue) !== 0);
                                           }
                                       }}
                                />
                            </div>
                        </div>
                        <div className="display-flex flex-row just-cont-sb wd-100pc">
                            <div
                                className={`wd-30pc ht-40 font-s-15 p-t-8 c-def ${etcFeeNmValue ? 'm-a-text-colored' : ''}`}>
                                <p className="">기타수수료 내용</p></div>
                            <div className="m-a-input-frame ht-40 wd-60pc">
                                <input className="m-a-input wd-100pc p-l-5 font-s-14" type={"text"} maxLength={100}
                                       placeholder="수수료 입력시 활성화"
                                       value={etcFeeCheckbox ? etcFeeNmValue : ""} disabled={etcFeeCheckbox === false}
                                       onChange={(e) => {
                                           setEtcFeeNmValue(e.target.value)
                                       }}/>
                            </div>
                        </div>

                        {/* 패키지관련 옵션 */}
                        <div className="display-flex align-center border-rd6" style={{
                            backgroundColor: "#FFF3F1", padding: "5px 10px", marginTop: "30px"}}>
                            <div className="wd-100pc delivery-alarm-checkbox-dash display-flex align-center justify-content-between font-s-13">
                                <label className="delivery-alarm-checkbox display-flex align-center gap5">
                                    {/* 배송알림옵션 UI */}
                                    <input
                                        type="checkbox"
                                        checked={deliveryAlarm}
                                        onChange={(e) => setDeliveryAlarm(e.target.checked)}
                                    />
                                    <span style={{ color: "#FF7962", fontWeight: 500 }}>배송사알림</span>
                                </label>
                            </div>
                        </div>

                    </div>
                }
                <div className="m-a-open-bar p-l-20 p-r-20 m-t-20">
                    <p className="font-t-title font-s-14 c-def">박스정보</p>
                    <div>
                        <AiOutlineMinusSquare
                            className="font-c-default font-s-28 c-point btorage-hover-exp btorage-hover m-r-5"
                            onClick={handleMinusClick}/>
                        <AiOutlinePlusSquare
                            className="font-c-default font-s-28 c-point btorage-hover-exp btorage-hover"
                            onClick={handlePlusClick}/>
                    </div>
                </div>

                {/*국내배송 박스정보*/}
                { selectedShipCompany === "국내배송" ?
                    <div className="m-a-top-border-card display-flex flex-column wd-100pc">
                        {boxDomeData.map((box, index) => (
                            <div key={index} className="wd-100pc">
                                <div className="display-flex flex-row just-cont-sb font-s-14 wd-100pc text-center gap7">
                                    <p className="wd-20pc c-def">가로(cm)</p>
                                    <p className="wd-20pc c-def">세로(cm)</p>
                                    <p className="wd-20pc c-def">높이(cm)</p>
                                    <p className="wd-20pc c-def">실무게(kg)</p>
                                </div>
                                <div className="display-flex flex-row just-cont-sb wd-100pc gap7">
                                    {/*가로*/}
                                    <input className="admin-input-line font-b font-c-default wd-20pc ht-40 text-center font-s-16 com-input" inputMode="numeric" pattern="\d*"
                                           minLength={1} maxLength={3}  type="text" placeholder="0"
                                           value={inputType === 'shipInfoDTO' ? orderData?.shipInfoDTO?.wid : box.width}
                                           onChange={(e) => {
                                               const newValue = e.target.value;
                                               if (orderData.dataType === 'payinfo') {
                                                   handleBoxChange(index, "width", newValue);
                                                   const updatedShipInfoDTO = { ...orderData.shipInfoDTO, wid: newValue };
                                                   setOrderData({ ...orderData, shipInfoDTO: updatedShipInfoDTO });
                                               } else {
                                                   handleBoxChange(index, "width", newValue);
                                               }
                                               setInputType(newValue === box.width ? 'box' : 'shipInfoDTO');
                                           }}
                                    />
                                    {/*세로*/}
                                    <input className="admin-input-line font-b font-c-default wd-20pc ht-40 text-center font-s-16 com-input" inputMode="numeric" pattern="\d*"
                                           minLength={1} maxLength={3} type="text" placeholder="0"
                                           value={inputType === 'shipInfoDTO' ? orderData.shipInfoDTO.ver : box.height}
                                           onChange={(e) => {
                                               const newValue = e.target.value;
                                               if (orderData.dataType === 'payinfo') {
                                                   handleBoxChange(index, "height", newValue);
                                                   const updatedShipInfoDTO = { ...orderData.shipInfoDTO, ver: newValue };
                                                   setOrderData({ ...orderData, shipInfoDTO: updatedShipInfoDTO });
                                               } else {
                                                   handleBoxChange(index, "height", newValue);
                                               }
                                               setInputType(newValue === box.height ? 'box' : 'shipInfoDTO');
                                           }}
                                    />
                                    {/*높이*/}
                                    <input className="admin-input-line font-b font-c-default wd-20pc ht-40 text-center font-s-16 com-input" inputMode="numeric" pattern="\d*"
                                           minLength={1} maxLength={3} type="text" placeholder="0"
                                           value={inputType === 'shipInfoDTO' ? orderData.shipInfoDTO.hei : box.length}
                                           onChange={(e) => {
                                               const newValue = e.target.value;
                                               if (orderData.dataType === 'payinfo') {
                                                   handleBoxChange(index, "length", newValue);
                                                   const updatedShipInfoDTO = { ...orderData.shipInfoDTO, hei: newValue };
                                                   setOrderData({ ...orderData, shipInfoDTO: updatedShipInfoDTO });
                                               } else {
                                                   handleBoxChange(index, "length", newValue);
                                               }
                                               setInputType(newValue === box.length ? 'box' : 'shipInfoDTO');
                                           }}
                                    />
                                    {/*실무게*/}
                                    <input className="admin-input-line font-b font-c-default wd-20pc ht-40 text-center font-s-16 com-input" inputMode="numeric" pattern="\d*"
                                           minLength={1} maxLength={5} type="text " placeholder="0.00" style={{ color: box.netWeight > 30 ? "red" : ""}}
                                           value={inputType === 'shipInfoDTO' ? orderData.shipInfoDTO.weight : box.netWeight}
                                           onChange={(e) => {
                                               const newValue = e.target.value;
                                               if (orderData.dataType === 'payinfo') {
                                                   handleBoxChange(index, "netWeight", newValue);
                                                   if (!box.width && !box.height && !box.length) {
                                                       handleBoxChange(index, "width", "0");
                                                       handleBoxChange(index, "height", "0");
                                                       handleBoxChange(index, "length", "0");
                                                   }
                                                   if (e.target.value !== "") {
                                                       setEfeeCheckbox(true);
                                                       setFfeeCheckbox(true);
                                                   } else {
                                                       setEfeeCheckbox(false);
                                                       setFfeeCheckbox(false);
                                                   }
                                                   const updatedShipInfoDTO = { ...orderData.shipInfoDTO, weight: newValue };
                                                   setOrderData({ ...orderData, shipInfoDTO: updatedShipInfoDTO });
                                               } else {
                                                   handleBoxChange(index, "netWeight", newValue);
                                                   if (!box.width && !box.height && !box.length) {
                                                       handleBoxChange(index, "width", "0");
                                                       handleBoxChange(index, "height", "0");
                                                       handleBoxChange(index, "length", "0");
                                                   }
                                                   if (e.target.value !== "") {
                                                       setEfeeCheckbox(true);
                                                       setFfeeCheckbox(true);
                                                   } else {
                                                       setEfeeCheckbox(false);
                                                       setFfeeCheckbox(false);
                                                   }
                                               }
                                               setInputType(newValue === box.netWeight ? 'box' : 'shipInfoDTO');
                                           }}
                                    />
                                </div>
                                <div className="display-flex flex-column m-t-5 m-b-25">
                                    <div className="display-flex flex-row just-cont-sb">
                                        <div><p className="font-s-14 font-c-btorage">Box {index + 1}</p></div>
                                        <div className="display-flex flex-row text-active c-point" onClick={() => handleToggle(index)}>
                                            <p className="font-s-14">자세히</p>
                                            {showBoxDtPrice[index] ?
                                                <IoIosArrowDropdown className="font-s-18 font-c-default"/> :
                                                <IoIosArrowDropright className="font-s-18 font-c-default"/>
                                            }
                                        </div>
                                    </div>
                                    {showBoxDtPrice[index] && (
                                        <div>
                                            <div className="display-flex flex-column wd-100pc m-a-reg-box-price m-t-15">
                                                <div className="display-flex flex-row just-cont-sb wd-100pc">
                                                    <p className="font-t-title">국내배송</p>
                                                    <div className="display-flex flex-row font-s-15">
                                                        <p className="" style={{ color: (parseFloat(box.width) + parseFloat(box.height) + parseFloat(box.length)) > 200 ? "red" : "" }}>
                                                            {(!isNaN(parseFloat(box.width)) ? parseFloat(box.width) : 0) +
                                                                (!isNaN(parseFloat(box.height)) ? parseFloat(box.height) : 0) +
                                                                (!isNaN(parseFloat(box.length)) ? parseFloat(box.length) : 0) + "cm"}
                                                        </p>
                                                        <p className="m-l-4 m-r-5">/</p>
                                                        <a className="font-b" style={{ color: parseFloat(box.netWeight) > 30 ? "red" : "" }}>
                                                            {box.netWeight + " kg"}
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="display-flex flex-row just-cont-sb wd-100pc font-t-title">
                                                    <div className="display-flex flex-row align-center">
                                                        <p className="">총배송비용</p>
                                                        {isManualDomePrice(index) &&
                                                            <p className="font-s-11 font-c-btorage m-l-5">(수기입력)</p>
                                                        }
                                                    </div>
                                                    {/* 국내배송 택배비 : DB요금표 자동조회값이 기본세팅되고, 관리자가 직접 수정/입력도 가능(값을 비우면 자동조회값으로 복귀) */}
                                                    <input className="admin-input-line wd-130 ht-25 text-right font-b font-c-btorage p-r-5"
                                                           type="text" inputMode="numeric" maxLength="11" placeholder="직접입력"
                                                           onChange={(e) => {
                                                               const rawValue = e.target.value.replace(/[^0-9]/g, '');
                                                               setManualPrices(prev => ({
                                                                   ...prev,
                                                                   DOME: {...prev.DOME, [index]: rawValue},
                                                               }));
                                                           }}
                                                        // value={(parseFloat(box.netWeight) > 70 || getVolumeWeightFedex(box.width, box.height, box.length) > 70) ? "-"
                                                        //     : (parseFloat(box.netWeight) > 30 || getVolumeWeightFedex(box.width, box.height, box.length) > 30)
                                                        //         ? "\u20A9 " + (getFedexCalculatedValue(box, fedexExData) + parseInt(boxFedexResultFees[index]) + outAreaCharge).toLocaleString()
                                                        //         : "\u20A9 " + roundToTen(getAmountForWeight(box.appliedWeights.F, fedexExData) * (1 + fedexFuelValue / 100) + parseInt(boxFedexResultFees[index]) + outAreaCharge).toLocaleString()}
                                                           value={isManualDomePrice(index)
                                                               ? Number(manualPrices["DOME"][index]).toLocaleString()
                                                               : (getAutoDomePrice(box) > 0 ? getAutoDomePrice(box).toLocaleString() : "")} />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                    :
                // 해외배송 박스정보
                selectedCountry.value !== "KR" && showBoxInputs ?
                    <div className="m-a-top-border-card display-flex flex-column wd-100pc">
                        {boxData.map((box, index) => (
                            <div key={index} className="wd-100pc">
                                <div className="display-flex flex-row just-cont-sb font-s-14 wd-100pc text-center gap7">
                                    <p className="wd-20pc c-def">가로(cm)</p>
                                    <p className="wd-20pc c-def">세로(cm)</p>
                                    <p className="wd-20pc c-def">높이(cm)</p>
                                    <p className="wd-20pc c-def">실무게(kg)</p>
                                </div>
                                <div className="display-flex flex-row just-cont-sb wd-100pc gap7">
                                    {/*가로*/}
                                    <input
                                        className="admin-input-line font-b font-c-default wd-20pc ht-40 text-center font-s-16 com-input"
                                        inputMode="numeric" pattern="\d*"
                                        minLength={1} maxLength={3} type="text" placeholder="0"
                                        // disabled={box.fpackInfo?.F || box.fpackInfo?.E}
                                        value={inputType === 'shipInfoDTO' ? orderData?.shipInfoDTO?.wid || '' : box.width}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            if (orderData.dataType === 'payinfo') {
                                                handleBoxChange(index, "width", newValue);
                                                const updatedShipInfoDTO = {...orderData.shipInfoDTO, wid: newValue};
                                                setOrderData({...orderData, shipInfoDTO: updatedShipInfoDTO});
                                            } else {
                                                handleBoxChange(index, "width", newValue);
                                            }
                                            setInputType(newValue === box.width ? 'box' : 'shipInfoDTO');
                                        }}
                                    />
                                    {/*세로*/}
                                    <input
                                        className="admin-input-line font-b font-c-default wd-20pc ht-40 text-center font-s-16 com-input"
                                        inputMode="numeric" pattern="\d*"
                                        minLength={1} maxLength={3} type="text" placeholder="0"
                                        // disabled={box.fpackInfo?.F || box.fpackInfo?.E}
                                        value={inputType === 'shipInfoDTO' ? orderData?.shipInfoDTO?.ver || '' : box.height}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            if (orderData.dataType === 'payinfo') {
                                                handleBoxChange(index, "height", newValue);
                                                const updatedShipInfoDTO = {...orderData.shipInfoDTO, ver: newValue};
                                                setOrderData({...orderData, shipInfoDTO: updatedShipInfoDTO});
                                            } else {
                                                handleBoxChange(index, "height", newValue);
                                            }
                                            setInputType(newValue === box.height ? 'box' : 'shipInfoDTO');
                                        }}
                                    />
                                    {/*높이*/}
                                    <input
                                        className="admin-input-line font-b font-c-default wd-20pc ht-40 text-center font-s-16 com-input"
                                        inputMode="numeric" pattern="\d*"
                                        minLength={1} maxLength={3} type="text" placeholder="0"
                                        // disabled={box.fpackInfo?.F || box.fpackInfo?.E}
                                        value={inputType === 'shipInfoDTO' ? orderData?.shipInfoDTO?.hei || '' : box.length}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            if (orderData.dataType === 'payinfo') {
                                                handleBoxChange(index, "length", newValue);
                                                const updatedShipInfoDTO = {...orderData.shipInfoDTO, hei: newValue};
                                                setOrderData({...orderData, shipInfoDTO: updatedShipInfoDTO});
                                            } else {
                                                handleBoxChange(index, "length", newValue);
                                            }
                                            setInputType(newValue === box.length ? 'box' : 'shipInfoDTO');
                                        }}
                                    />
                                    {/*실무게*/}
                                    <input
                                        className="admin-input-line font-b font-c-default wd-20pc ht-40 text-center font-s-16 com-input"
                                        inputMode="numeric" pattern="\d*"
                                        minLength={1} maxLength={5} type="text " placeholder="0.00"
                                        style={{color: box.netWeight > 30 ? "red" : ""}}
                                        value={inputType === 'shipInfoDTO' ? orderData?.shipInfoDTO?.weight || '' : box.netWeight || ""}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            if (orderData.dataType === 'payinfo') {
                                                handleBoxChange(index, "netWeight", newValue);
                                                if (!box.width && !box.height && !box.length) {
                                                    handleBoxChange(index, "width", "0");
                                                    handleBoxChange(index, "height", "0");
                                                    handleBoxChange(index, "length", "0");
                                                }
                                                if (e.target.value !== "") {
                                                    setEfeeCheckbox(true);
                                                    setFfeeCheckbox(true);
                                                } else {
                                                    setEfeeCheckbox(false);
                                                    setFfeeCheckbox(false);
                                                }
                                                const updatedShipInfoDTO = {...orderData.shipInfoDTO, weight: newValue};
                                                setOrderData({...orderData, shipInfoDTO: updatedShipInfoDTO});
                                            } else {
                                                handleBoxChange(index, "netWeight", newValue);
                                                if (!box.width && !box.height && !box.length) {
                                                    handleBoxChange(index, "width", "0");
                                                    handleBoxChange(index, "height", "0");
                                                    handleBoxChange(index, "length", "0");
                                                }
                                                if (e.target.value !== "") {
                                                    setEfeeCheckbox(true);
                                                    setFfeeCheckbox(true);
                                                } else {
                                                    setEfeeCheckbox(false);
                                                    setFfeeCheckbox(false);
                                                }
                                            }
                                            setInputType(newValue === box.netWeight ? 'box' : 'shipInfoDTO');
                                        }}
                                    />
                                </div>

                                {/*개별 견적체크박스*/}
                                <div className="display-flex flex-column border-rd6" style={{
                                    backgroundColor: "#FFF3F1", padding: "5px 10px", marginTop: "10px"
                                }}>
                                    {/* 첫 번째 줄: FedEx, FedEx-E, UPS, UPS-E */}
                                    <div
                                        className="wd-100pc courier-checkbox-dash display-flex align-center justify-content-between font-s-12"
                                        style={{marginBottom: "5px"}}>
                                        {/* 배열 끝에 "" (빈값)을 추가하여 5개를 맞춤 */}
                                        {["FedEx", "FedEx-E", "UPS", "UPS-E", ""].map((courier, idx) => {
                                            // 빈 값(더미)일 경우 보이지 않는 박스 렌더링
                                            if (courier === "") {
                                                return (
                                                    <label key={idx}
                                                           className="courier-checkbox display-flex align-center gap5"
                                                           style={{marginRight: "15px", visibility: "hidden"}}>
                                                        <input type="checkbox" disabled/>
                                                        <span>dummy</span>
                                                    </label>
                                                );
                                            }

                                            // 정상적인 배송사 라벨
                                            return (
                                                <label key={courier}
                                                       className="courier-checkbox display-flex align-center gap5 c-point"
                                                       style={{marginRight: "15px"}}>
                                                    <input className="c-point"
                                                           type="checkbox"
                                                           checked={box.checkedCouriers?.includes(courier) || false}
                                                           onChange={(e) => {
                                                               const updatedBoxData = [...boxData];
                                                               const currentBox = updatedBoxData[index];
                                                               if (!currentBox.checkedCouriers) currentBox.checkedCouriers = [];

                                                               if (e.target.checked) {
                                                                   if (!currentBox.checkedCouriers.includes(courier)) {
                                                                       currentBox.checkedCouriers.push(courier);
                                                                   }
                                                               } else {
                                                                   currentBox.checkedCouriers = currentBox.checkedCouriers.filter(
                                                                       (c) => c !== courier
                                                                   );
                                                               }

                                                               // shipInfoDTO 업데이트
                                                               currentBox.shipInfoDTO = {
                                                                   fedexChecked: currentBox.checkedCouriers.includes("FedEx"),
                                                                   fedexEcoChecked: currentBox.checkedCouriers.includes("FedEx-E"),
                                                                   upsChecked: currentBox.checkedCouriers.includes("UPS"),
                                                                   upsEcoChecked: currentBox.checkedCouriers.includes("UPS-E"),
                                                                   emsChecked: currentBox.checkedCouriers.includes("EMS"),
                                                                   emspChecked: currentBox.checkedCouriers.includes("EMSP"),
                                                                   seaChecked: currentBox.checkedCouriers.includes("SEA"),
                                                                   kpackChecked: currentBox.checkedCouriers.includes("KPack"),
                                                                   spackChecked: currentBox.checkedCouriers.includes("SPack"),
                                                               };

                                                               setBoxData(updatedBoxData);
                                                           }}
                                                    />
                                                    <span style={{color: "#FF7962", fontWeight: 500}}>{courier}</span>
                                                </label>
                                            );
                                        })}
                                    </div>

                                    {/* 두 번째 줄: 나머지 배송사들 */}
                                    <div
                                        className="wd-100pc courier-checkbox-dash display-flex align-center justify-content-between font-s-12">
                                        {["EMS", "EMSP", "SEA", "KPack", "SPack"].map((courier) => (
                                            <label key={courier}
                                                   className="courier-checkbox display-flex align-center gap5 c-point"
                                                   style={{marginRight: "15px"}}>
                                                <input className="c-point"
                                                       type="checkbox"
                                                       checked={box.checkedCouriers?.includes(courier) || false}
                                                       onChange={(e) => {
                                                           const updatedBoxData = [...boxData];
                                                           const currentBox = updatedBoxData[index];
                                                           if (!currentBox.checkedCouriers) currentBox.checkedCouriers = [];

                                                           if (e.target.checked) {
                                                               if (!currentBox.checkedCouriers.includes(courier)) {
                                                                   currentBox.checkedCouriers.push(courier);
                                                               }
                                                           } else {
                                                               currentBox.checkedCouriers = currentBox.checkedCouriers.filter(
                                                                   (c) => c !== courier
                                                               );
                                                           }

                                                           // shipInfoDTO 업데이트 (위와 동일 로직)
                                                           currentBox.shipInfoDTO = {
                                                               fedexChecked: currentBox.checkedCouriers.includes("FedEx"),
                                                               fedexEcoChecked: currentBox.checkedCouriers.includes("FedEx-E"),
                                                               upsChecked: currentBox.checkedCouriers.includes("UPS"),
                                                               upsEcoChecked: currentBox.checkedCouriers.includes("UPS-E"),
                                                               emsChecked: currentBox.checkedCouriers.includes("EMS"),
                                                               emspChecked: currentBox.checkedCouriers.includes("EMSP"),
                                                               seaChecked: currentBox.checkedCouriers.includes("SEA"),
                                                               kpackChecked: currentBox.checkedCouriers.includes("KPack"),
                                                               spackChecked: currentBox.checkedCouriers.includes("SPack"),
                                                           };

                                                           setBoxData(updatedBoxData);
                                                       }}
                                                />
                                                <span style={{color: "#FF7962", fontWeight: 500}}>{courier}</span>
                                            </label>
                                        ))}
                                    </div>
                                </div>

                                <div className="display-flex flex-column m-t-5 m-b-25">

                                    <div className="display-flex flex-row just-cont-sb">
                                        <div><p className="font-s-14 c-def">Box {index + 1}</p></div>

                                        {/* ✨ 해외배송 [자세히]문구 - 실중량 or 부피중량이 30kg 초과 시 이펙트효과 */}
                                        <div
                                            className="display-flex flex-row align-center c-point"
                                            onClick={() => handleToggle(index)}
                                            style={{
                                                transition: "all 0.3s ease",
                                                // 조건부 스타일 시작
                                                ...(isHeavyOrLarge(boxData[index]) ? {
                                                    background: "linear-gradient(135deg, #6e8efb, #a777e3)",
                                                    padding: "2px 8px",
                                                    borderRadius: "12px",
                                                    boxShadow: "0 2px 8px rgba(167, 119, 227, 0.4)",
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    fontSize: "11px",
                                                    height: "24px",
                                                    animation: "softPulse 2s infinite"
                                                } : {
                                                    // 조건 미충족 시 (기존 스타일)
                                                    color: "inherit",
                                                    height: "auto"
                                                })
                                            }}
                                        >
                                            <p className={`m-r-2 ${isHeavyOrLarge(boxData[index]) ? "" : "font-s-14 btorage-hover"}`}
                                               style={{marginRight: "3px"}}>
                                                {isHeavyOrLarge(boxData[index]) ? "CHECK" : "자세히"}
                                            </p>

                                            {showBoxDtPrice[index] ? (
                                                <IoIosArrowDropdown
                                                    className={isHeavyOrLarge(boxData[index]) ? "" : "font-s-17 m-t-2"}
                                                    style={{
                                                        color: isHeavyOrLarge(boxData[index]) ? "white" : "inherit",
                                                        fontSize: isHeavyOrLarge(boxData[index]) ? "12px" : undefined,
                                                        marginTop: isHeavyOrLarge(boxData[index]) ? "1px" : "2px"
                                                    }}
                                                />
                                            ) : (
                                                <IoIosArrowDropright
                                                    className={isHeavyOrLarge(boxData[index]) ? "" : "font-s-17 m-t-2"}
                                                    style={{
                                                        color: isHeavyOrLarge(boxData[index]) ? "white" : "inherit",
                                                        fontSize: isHeavyOrLarge(boxData[index]) ? "12px" : undefined,
                                                        marginTop: isHeavyOrLarge(boxData[index]) ? "1px" : "2px"
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>

                                    {showBoxDtPrice[index] && (
                                        <div className="c-def">
                                            {/*FedEx*/}
                                            <div
                                                className="display-flex flex-column wd-100pc m-a-reg-box-price m-a-reg-box-price-top m-t-10 p-t-5 p-b-5">
                                                <div className="display-flex flex-row just-cont-sb wd-100pc">
                                                    <div className="display-flex flex-row align-center">
                                                        <span style={{
                                                            width: "15px",
                                                            marginRight: "4px",
                                                            height: "1px",
                                                            backgroundColor: "#d5d5d5"
                                                        }}></span>
                                                        <p className="font-t-title font-s-16"
                                                           style={{color: "#FFAF34", fontStyle: "italic"}}>FedEx</p>
                                                        <span style={{
                                                            width: "15px",
                                                            marginLeft: "4px",
                                                            height: "1px",
                                                            backgroundColor: "#d5d5d5"
                                                        }}></span>
                                                    </div>
                                                    <div className="display-flex flex-row font-s-15">
                                                        <p>{getVolumeWeightFedex(box.width, box.height, box.length) + "kg"}</p>
                                                        <p className="m-l-4 m-r-5">/</p>
                                                        <p className="font-b">{box.appliedWeights?.F + "kg"}</p>
                                                    </div>
                                                </div>
                                                <div
                                                    className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                    <div className="display-flex flex-row align-center">
                                                        <p className="m-r-10">페덱스팩여부</p>
                                                        <input className="m-a-admin-input-chkBox m-0-a m-r-5"
                                                               type="checkbox"
                                                               checked={parseFloat(box.netWeight) > 2 ? false : box.fpackInfo?.F}
                                                               disabled={parseFloat(box.netWeight) > 2 || !box.checkedCouriers.includes("FedEx")}
                                                               onChange={() => handleFpackCheckboxChange(index, 'F')}
                                                        />
                                                    </div>
                                                    <div className="display-flex flex-row">
                                                        <p className="font-b">{parseFloat(box.netWeight) > 2 ? false : box.fpackInfo?.F}</p>
                                                    </div>
                                                </div>
                                                <div
                                                    className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                    <div className="display-flex flex-row align-center">
                                                        <p className="m-r-10">유류할증료</p>
                                                        <div className="m-a-input-frame ht-28 wd-65 m-l-10">
                                                            <input
                                                                className="m-a-input text-center wd-65 ht-28 font-c-default"
                                                                type={"text"} value={fedexFuelValue} maxLength="4"
                                                                onChange={(e) => setFedexFuelValue(e.target.value)}
                                                                inputMode="numeric" pattern="\d*"
                                                                disabled={parseFloat(box.netWeight) > 30 || getVolumeWeightFedex(box.width, box.height, box.length) > 30}
                                                            />
                                                        </div>
                                                        <p className="m-t-3"> %</p>
                                                    </div>
                                                    <div className="display-flex flex-row">
                                                        <input
                                                            className="wd-90 ht-25 text-right font-c-default m-a-all-none"
                                                            type={"text"} disabled placeholder="0"
                                                            value={parseFloat(box.netWeight) > 30 ? "-" : "\u20A9 " + roundToTen(getAmountForWeight(box.appliedWeights?.F, fedexExData) * (fedexFuelValue / 100)).toLocaleString()}
                                                        />
                                                    </div>
                                                </div>
                                                {isOutArea && (
                                                    <div
                                                        className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                        <p className="font-c-cancel">서비스 외 지역 수수료</p>
                                                        <input
                                                            className="wd-30pc ht-25 text-right font-c-default m-a-all-none"
                                                            type={"text"} placeholder="0" disabled
                                                            value={`\u20A9 ${outAreaCharge.toLocaleString()}`}
                                                        />
                                                    </div>
                                                )}
                                                <div
                                                    className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                    <p className="">수수료</p>
                                                    <input
                                                        className="wd-30pc ht-25 text-right font-c-default m-a-all-none"
                                                        type={"text"} placeholder="0" disabled
                                                        value={(parseFloat(box.netWeight) > 70 || getVolumeWeightFedex(box.width, box.height, box.length) > 70) ? "-" : "\u20A9 " + parseInt(boxFedexResultFees[index]).toLocaleString()}
                                                        onChange={(e) => {
                                                            const newValue = e.target.value.replace(/,/g, '');
                                                            if (/^\d*$/.test(newValue)) {
                                                                const updatedBoxFedexResultFees = [...boxFedexResultFees];
                                                                updatedBoxFedexResultFees[index] = newValue * appliedWeights?.F * 10;
                                                                setBoxFedexResultFees(updatedBoxFedexResultFees);
                                                                setEfeeCheckbox(newValue !== "" && parseInt(newValue) !== 0);
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                    <p className="">배송료</p>
                                                    <p className="">{parseFloat(box.netWeight) > 30 ? "-" : "\u20A9 " + getAmountForWeight(box.appliedWeights?.F, fedexExData).toLocaleString()}</p>
                                                </div>
                                                <div
                                                    className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                    <p className="">관부가세선납</p>
                                                    <p className="">{"\u20A9 "}{fedexCusPrepay.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</p>
                                                </div>
                                                <div style={{marginTop: "5px"}}
                                                     className="display-flex flex-row just-cont-sb wd-100pc font-t-title">
                                                    <p className="">총배송비용</p>
                                                    {parseFloat(box.netWeight) > 30 || getVolumeWeightUps(box.width, box.height, box.length) > 30 ? (
                                                        <input
                                                            className="admin-input-line wd-130 ht-30 text-right font-b font-c-btorage p-r-5 p-t-2"
                                                            type="text"
                                                            minLength="5" maxLength="10" placeholder="직접입력"
                                                            value={manualPrices["FedEx"]?.[index] ? Number(manualPrices["FedEx"][index]).toLocaleString() : ""}
                                                            onChange={(e) => {
                                                                const rawValue = e.target.value.replace(/[^0-9]/g, '');
                                                                setManualPrices(prev => ({
                                                                    ...prev,
                                                                    ["FedEx"]: {...prev["FedEx"], [index]: rawValue,},
                                                                }));
                                                            }}
                                                        />
                                                    ) : (
                                                        <input
                                                            className="wd-30pc ht-30 text-right font-b font-c-btorage m-a-all-none"
                                                            type="text"
                                                            disabled={!(parseFloat(box.netWeight) > 30 || getVolumeWeightFedex(box.width, box.height, box.length) > 30)}
                                                            value={(parseFloat(box.netWeight) > 70 || getVolumeWeightFedex(box.width, box.height, box.length) > 70) ? "-"
                                                                : (parseFloat(box.netWeight) > 30 || getVolumeWeightFedex(box.width, box.height, box.length) > 30)
                                                                    ? "\u20A9 " + (getFedexCalculatedValue(box, fedexExData) + parseInt(boxFedexResultFees[index]) + numericFedexCusPrepay).toLocaleString()
                                                                    : "\u20A9 " + roundToTen(getAmountForWeight(box.appliedWeights?.F, fedexExData) * (1 + fedexFuelValue / 100) + parseInt(boxFedexEcoResultFees[index]) + numericFedexCusPrepay).toLocaleString()}
                                                            onChange={(e) => {
                                                                const newValue = e.target.value.replace(/[^0-9.]/g, '');
                                                                if (newValue === "" || !isNaN(newValue)) {
                                                                    handleFedexValueChange(index, newValue);
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                            {/*FedEx-E*/}
                                            <div
                                                className="display-flex flex-column wd-100pc m-a-reg-box-price m-t-10 p-t-5 p-b-5">
                                                <div className="display-flex flex-row just-cont-sb wd-100pc">
                                                    <div className="display-flex flex-row align-center">
                                                        <span style={{
                                                            width: "15px",
                                                            marginRight: "4px",
                                                            height: "1px",
                                                            backgroundColor: "#d5d5d5"
                                                        }}></span>
                                                        <p className="font-t-title font-s-16"
                                                           style={{color: "#FFAF34", fontStyle: "italic"}}>FedEx-E</p>
                                                        <span style={{
                                                            width: "15px",
                                                            marginLeft: "4px",
                                                            height: "1px",
                                                            backgroundColor: "#d5d5d5"
                                                        }}></span>
                                                    </div>
                                                    <div className="display-flex flex-row font-s-15">
                                                        <p>{getVolumeWeightFedex(box.width, box.height, box.length) + "kg"}</p>
                                                        <p className="m-l-4 m-r-5">/</p>
                                                        <p className="font-b">{box.appliedWeights?.F + "kg"}</p>
                                                    </div>
                                                </div>
                                                <div
                                                    className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                    <div className="display-flex flex-row align-center">
                                                        <p className="m-r-10">페덱스팩여부</p>
                                                        <input className="m-a-admin-input-chkBox m-0-a m-r-5"
                                                               type="checkbox"
                                                               checked={parseFloat(box.netWeight) > 2 ? false : box.fpackInfo?.E}
                                                               disabled={parseFloat(box.netWeight) > 2 || !box.checkedCouriers.includes("FedEx-E")}
                                                               onChange={() => handleFpackCheckboxChange(index, 'E')}/>
                                                        {/*<p className="">FedEx Pack</p>*/}
                                                    </div>
                                                    <div className="display-flex flex-row">
                                                        <p className="font-b">{parseFloat(box.netWeight) > 2 ? false : box.fpackInfo?.E}</p>
                                                    </div>
                                                </div>
                                                <div
                                                    className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                    <div className="display-flex flex-row align-center">
                                                        <p className="m-r-10">유류할증료</p>
                                                        <div className="m-a-input-frame ht-28 wd-65 m-l-10">
                                                            <input
                                                                className="m-a-input text-center wd-65 ht-28 font-c-default"
                                                                type={"text"} value={fedexFuelValue} maxLength="4"
                                                                onChange={(e) => setFedexFuelValue(e.target.value)}
                                                                inputMode="numeric" pattern="\d*"
                                                                disabled={parseFloat(box.netWeight) > 30 || getVolumeWeightFedex(box.width, box.height, box.length) > 30}
                                                            />
                                                        </div>
                                                        <p className="m-t-3"> %</p>
                                                    </div>
                                                    <div className="display-flex flex-row">
                                                        <input
                                                            className="wd-90 ht-25 text-right font-c-default m-a-all-none"
                                                            type={"text"} disabled placeholder="0"
                                                            value={parseFloat(box.netWeight) > 30 ? "-" : "\u20A9 " + roundToTen(getAmountForWeight(box.appliedWeights?.F, fedexEcoExData) * (fedexFuelValue / 100)).toLocaleString()}
                                                        />
                                                    </div>
                                                </div>
                                                <div
                                                    className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                    <p className="">수수료</p>
                                                    <input
                                                        className="wd-30pc ht-30 text-right font-c-default m-a-all-none"
                                                        type={"text"} placeholder="0" disabled
                                                        value={(parseFloat(box.netWeight) > 70 || getVolumeWeightFedex(box.width, box.height, box.length) > 70) ? "-" : "\u20A9 " + parseInt(boxFedexEcoResultFees[index]).toLocaleString()}
                                                        onChange={(e) => {
                                                            const newValue = e.target.value.replace(/,/g, '');
                                                            if (/^\d*$/.test(newValue)) {
                                                                const updatedBoxFedexEcoResultFees = [...boxFedexEcoResultFees];
                                                                updatedBoxFedexEcoResultFees[index] = newValue * appliedWeights?.F * 10;
                                                                setBoxFedexEcoResultFees(updatedBoxFedexEcoResultFees);
                                                                setEfeeCheckbox(newValue !== "" && parseInt(newValue) !== 0);
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                    <p className="">배송료</p>
                                                    <p className="">{parseFloat(box.netWeight) > 30 ? "-" : "\u20A9 " + getAmountForWeight(box.appliedWeights?.F, fedexEcoExData).toLocaleString()}</p>
                                                </div>
                                                <div
                                                    className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                    <p className="">관부가세선납</p>
                                                    <p className="">{"\u20A9 "}{fedexEcoCusPrepay.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</p>
                                                </div>
                                                <div style={{marginTop: "5px"}}
                                                     className="display-flex flex-row just-cont-sb wd-100pc font-t-title">
                                                    <p className="">총배송비용</p>
                                                    {parseFloat(box.netWeight) > 30 || getVolumeWeightUps(box.width, box.height, box.length) > 30 ? (
                                                        <input
                                                            className="admin-input-line wd-130 ht-30 text-right font-b font-c-btorage p-r-5 p-t-2"
                                                            type="text"
                                                            minLength="5" maxLength="10" placeholder="직접입력"
                                                            value={manualPrices["FedEx-E"]?.[index] ? Number(manualPrices["FedEx-E"][index]).toLocaleString() : ""}
                                                            onChange={(e) => {
                                                                const rawValue = e.target.value.replace(/[^0-9]/g, '');
                                                                setManualPrices(prev => ({
                                                                    ...prev,
                                                                    ["FedEx-E"]: {
                                                                        ...prev["FedEx-E"],
                                                                        [index]: rawValue,
                                                                    },
                                                                }));
                                                            }}
                                                        />
                                                    ) : (
                                                        <input
                                                            className="wd-30pc ht-25 text-right font-b font-c-btorage m-a-all-none"
                                                            type="text"
                                                            disabled={!(parseFloat(box.netWeight) > 30 || getVolumeWeightFedex(box.width, box.height, box.length) > 30)}
                                                            value={(parseFloat(box.netWeight) > 70 || getVolumeWeightFedex(box.width, box.height, box.length) > 70) ? "-"
                                                                : (parseFloat(box.netWeight) > 30 || getVolumeWeightFedex(box.width, box.height, box.length) > 30)
                                                                    ? "\u20A9 " + (getFedexCalculatedValue(box, fedexEcoExData) + parseInt(boxFedexEcoResultFees[index]) + numericFedexCusPrepay).toLocaleString()
                                                                    : "\u20A9 " + roundToTen(getAmountForWeight(box.appliedWeights?.F, fedexEcoExData) * (1 + fedexFuelValue / 100) + parseInt(boxFedexEcoResultFees[index]) + numericFedexCusPrepay).toLocaleString()}
                                                            onChange={(e) => {
                                                                const newValue = e.target.value.replace(/[^0-9.]/g, '');
                                                                if (newValue === "" || !isNaN(newValue)) {
                                                                    handleFedexValueChange(index, newValue);
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                            {/*UPS*/}
                                            <div
                                                className="display-flex flex-column wd-100pc m-a-reg-box-price m-t-10 p-t-5 p-b-5">
                                                <div className="display-flex flex-row just-cont-sb wd-100pc">
                                                    <div className="display-flex flex-row align-center">
                                                        <span style={{
                                                            width: "15px",
                                                            marginRight: "4px",
                                                            height: "1px",
                                                            backgroundColor: "#d5d5d5"
                                                        }}></span>
                                                        <p className="font-t-title font-s-16"
                                                           style={{color: "#FFAF34", fontStyle: "italic"}}>UPS</p>
                                                        <span style={{
                                                            width: "15px",
                                                            marginLeft: "4px",
                                                            height: "1px",
                                                            backgroundColor: "#d5d5d5"
                                                        }}></span>
                                                    </div>
                                                    <div className="display-flex flex-row font-s-15">
                                                        <p>{getVolumeWeightUps(box.width, box.height, box.length) + "kg"}</p>
                                                        <p className="m-l-4 m-r-5">/</p>
                                                        <p className="font-b">{box.appliedWeights.P + "kg"}</p>
                                                    </div>
                                                </div>
                                                <div
                                                    className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                    <div className="display-flex flex-row align-center">
                                                        <p className="m-r-10">유류할증료</p>
                                                        <div className="m-a-input-frame ht-28 wd-65 m-l-10">
                                                            <input
                                                                className="m-a-input text-center wd-65 ht-28 font-c-default"
                                                                type={"text"} value={upsFuelValue} maxLength="4"
                                                                onChange={(e) => setUpsFuelValue(e.target.value)}
                                                                inputMode="numeric" pattern="\d*"
                                                                disabled={parseFloat(box.netWeight) > 30 || getVolumeWeightUps(box.width, box.height, box.length) > 30}
                                                            />
                                                        </div>
                                                        <p className="m-t-3"> %</p>
                                                    </div>
                                                    <div className="display-flex flex-row">
                                                        <input
                                                            className="wd-90 ht-25 text-right font-c-default m-a-all-none"
                                                            type={"text"} disabled placeholder="0"
                                                            value={parseFloat(box.netWeight) > 30 ? "-" : "\u20A9 " + roundToTen(getAmountForWeight(box.appliedWeights.P, upsExData) * (upsFuelValue / 100)).toLocaleString()}
                                                        />
                                                    </div>
                                                </div>
                                                <div
                                                    className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                    <p className="">수수료</p>
                                                    <input
                                                        className="wd-30pc ht-25 text-right font-c-default m-a-all-none"
                                                        type={"text"} placeholder="0" disabled
                                                        value={parseFloat(box.netWeight) > 70 || getVolumeWeightUps(box.width, box.height, box.length) > 70 ? "-" : box.netWeight ? "\u20A9 " + parseInt(boxUpsResultFees[index]).toLocaleString() : "-"}
                                                        onChange={(e) => {
                                                            const newValue = e.target.value.replace(/,/g, '');
                                                            if (/^\d*$/.test(newValue)) {
                                                                const updatedBoxUpsResultFees = [...boxUpsResultFees];
                                                                updatedBoxUpsResultFees[index] = newValue * appliedWeights.P * 10;
                                                                setBoxUpsResultFees(updatedBoxUpsResultFees);
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                    <p className="">배송료</p>
                                                    <p>{parseFloat(box.netWeight) > 30 || getVolumeWeightUps(box.width, box.height, box.length) > 30 ? "-" : "\u20A9 " + getAmountForWeight(box.appliedWeights.P, upsExData).toLocaleString()}</p>
                                                </div>
                                                <div
                                                    className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                    <p className="">관부가세선납</p>
                                                    <p className="">{"\u20A9 "}{upsCusPrepay.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</p>
                                                </div>
                                                <div style={{marginTop: "5px"}}
                                                     className="display-flex flex-row just-cont-sb wd-100pc font-t-title">
                                                    <p className="">총배송비용</p>
                                                    {parseFloat(box.netWeight) > 30 || getVolumeWeightUps(box.width, box.height, box.length) > 30 ? (
                                                        <input
                                                            className="admin-input-line wd-130 ht-30 text-right font-b font-c-btorage p-r-5 p-t-2"
                                                            type="text"
                                                            minLength="5" maxLength="10" placeholder="직접입력"
                                                            value={manualPrices["UPS"]?.[index] ? Number(manualPrices["UPS"][index]).toLocaleString() : ""}
                                                            onChange={(e) => {
                                                                const rawValue = e.target.value.replace(/[^0-9]/g, '');
                                                                setManualPrices(prev => ({
                                                                    ...prev,
                                                                    ["UPS"]: {...prev["UPS"], [index]: rawValue,},
                                                                }));
                                                            }}
                                                        />
                                                    ) : (
                                                        <input
                                                            className="wd-30pc ht-30 text-right font-b font-c-btorage m-a-all-none"
                                                            type="text"
                                                            disabled={!(parseFloat(box.netWeight) > 30 || getVolumeWeightFedex(box.width, box.height, box.length) > 30)}
                                                            value={"\u20A9 " + roundToTen(getAmountForWeight(box.appliedWeights.P, upsExData) * (1 + upsFuelValue / 100) + parseInt(boxUpsResultFees[index]) + numericUpsCusPrepay).toLocaleString()}
                                                            onChange={(e) => {
                                                                const newValue = e.target.value.replace(/[^0-9.]/g, '');
                                                                if (newValue === "" || !isNaN(newValue)) {
                                                                    handleFedexValueChange(index, newValue);
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                            {/*UPS-E*/}
                                            <div
                                                className="display-flex flex-column wd-100pc m-a-reg-box-price m-t-10 p-t-5 p-b-5">
                                                <div className="display-flex flex-row just-cont-sb wd-100pc">
                                                    <div className="display-flex flex-row align-center">
                                                        <span style={{
                                                            width: "15px",
                                                            marginRight: "4px",
                                                            height: "1px",
                                                            backgroundColor: "#d5d5d5"
                                                        }}></span>
                                                        <p className="font-t-title font-s-16"
                                                           style={{color: "#FFAF34", fontStyle: "italic"}}>UPS-E</p>
                                                        <span style={{
                                                            width: "15px",
                                                            marginLeft: "4px",
                                                            height: "1px",
                                                            backgroundColor: "#d5d5d5"
                                                        }}></span>
                                                    </div>
                                                    <div className="display-flex flex-row font-s-15">
                                                        <p>{getVolumeWeightUps(box.width, box.height, box.length) + "kg"}</p>
                                                        <p className="m-l-4 m-r-5">/</p>
                                                        <p className="font-b">{box.appliedWeights.P + "kg"}</p>
                                                    </div>
                                                </div>
                                                <div
                                                    className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                    <div className="display-flex flex-row align-center">
                                                        <p className="m-r-10">유류할증료</p>
                                                        <div className="m-a-input-frame ht-28 wd-65 m-l-10">
                                                            <input
                                                                className="m-a-input text-center wd-65 ht-28 font-c-default"
                                                                type={"text"} value={upsFuelValue} maxLength="4"
                                                                onChange={(e) => setUpsFuelValue(e.target.value)}
                                                                inputMode="numeric" pattern="\d*"
                                                                disabled={parseFloat(box.netWeight) > 30 || getVolumeWeightUps(box.width, box.height, box.length) > 30}
                                                            />
                                                        </div>
                                                        <p className="m-t-3"> %</p>
                                                    </div>
                                                    <div className="display-flex flex-row">
                                                        <input
                                                            className="wd-90 ht-25 text-right font-c-default m-a-all-none"
                                                            type={"text"} disabled placeholder="0"
                                                            value={parseFloat(box.netWeight) > 30 ? "-" : "\u20A9 " + roundToTen(getAmountForWeight(box.appliedWeights.P, upsEcoExData) * (upsFuelValue / 100)).toLocaleString()}
                                                        />
                                                    </div>
                                                </div>
                                                <div
                                                    className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                    <p className="">수수료</p>
                                                    <input
                                                        className="wd-30pc ht-25 text-right font-c-default m-a-all-none"
                                                        type={"text"} placeholder="0" disabled
                                                        value={parseFloat(box.netWeight) > 70 || getVolumeWeightUps(box.width, box.height, box.length) > 70 ? "-" : box.netWeight ? "\u20A9 " + parseInt(boxUpsEcoResultFees[index]).toLocaleString() : "-"}
                                                        onChange={(e) => {
                                                            const newValue = e.target.value.replace(/,/g, '');
                                                            if (/^\d*$/.test(newValue)) {
                                                                const updatedBoxUpsEcoResultFees = [...boxUpsEcoResultFees];
                                                                updatedBoxUpsEcoResultFees[index] = newValue * appliedWeights.P * 10;
                                                                setBoxUpsEcoResultFees(updatedBoxUpsEcoResultFees);
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                    <p>배송료</p>
                                                    <p>{parseFloat(box.netWeight) > 30 || getVolumeWeightUps(box.width, box.height, box.length) > 30 ? "-" : "\u20A9 " + getAmountForWeight(box.appliedWeights.P, upsEcoExData).toLocaleString()}</p>
                                                </div>
                                                <div
                                                    className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                    <p className="">관부가세선납</p>
                                                    <p className="">{"\u20A9 "}{upsCusPrepay.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</p>
                                                </div>
                                                <div style={{marginTop: "5px"}}
                                                     className="display-flex flex-row just-cont-sb wd-100pc font-t-title">
                                                    <p className="">총배송비용</p>
                                                    {parseFloat(box.netWeight) > 30 || getVolumeWeightUps(box.width, box.height, box.length) > 30 ? (
                                                        <input
                                                            className="admin-input-line wd-130 ht-30 text-right font-b font-c-btorage p-r-5 p-t-2"
                                                            type="text"
                                                            minLength="5" maxLength="10" placeholder="직접입력"
                                                            value={manualPrices["UPS-E"]?.[index] ? Number(manualPrices["UPS-E"][index]).toLocaleString() : ""}
                                                            onChange={(e) => {
                                                                const rawValue = e.target.value.replace(/[^0-9]/g, '');
                                                                setManualPrices(prev => ({
                                                                    ...prev,
                                                                    ["UPS-E"]: {...prev["UPS-E"], [index]: rawValue,},
                                                                }));
                                                            }}
                                                        />
                                                    ) : (
                                                        <input
                                                            className="wd-30pc ht-30 text-right font-b font-c-btorage m-a-all-none"
                                                            type="text"
                                                            disabled={!(parseFloat(box.netWeight) > 30 || getVolumeWeightFedex(box.width, box.height, box.length) > 30)}
                                                            value={"\u20A9 " +
                                                                roundToTen(
                                                                    getAmountForWeight(box.appliedWeights.P, upsEcoExData) * (1 + upsFuelValue / 100) +
                                                                    parseInt(boxUpsEcoResultFees[index]) + numericUpsCusPrepay
                                                                ).toLocaleString()
                                                            }
                                                            onChange={(e) => {
                                                                const newValue = e.target.value.replace(/[^0-9.]/g, '');
                                                                if (newValue === "" || !isNaN(newValue)) {
                                                                    handleFedexValueChange(index, newValue);
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                            {/*EMS*/}
                                            {parseFloat(box.netWeight) <= 30 && getVolumeWeightEms(box.width, box.height, box.length) <= 30 && (
                                                <div
                                                    className="display-flex flex-column wd-100pc m-a-reg-box-price m-t-10 p-t-5 p-b-5">
                                                    <div className="display-flex flex-row just-cont-sb wd-100pc">
                                                        <div className="display-flex flex-row align-center">
                                                            <span style={{
                                                                width: "15px",
                                                                marginRight: "4px",
                                                                height: "1px",
                                                                backgroundColor: "#d5d5d5"
                                                            }}></span>
                                                            <p className="font-t-title font-s-16"
                                                               style={{color: "#FFAF34", fontStyle: "italic"}}>EMS</p>
                                                            <span style={{
                                                                width: "15px",
                                                                marginLeft: "4px",
                                                                height: "1px",
                                                                backgroundColor: "#d5d5d5"
                                                            }}></span>
                                                        </div>
                                                        <div className="display-flex flex-row font-s-15">
                                                            <p className="">{getVolumeWeightEms(box.width, box.height, box.length) + "kg"}</p>
                                                            <p className="m-l-4 m-r-5">/</p>
                                                            <p className="font-b">{box.appliedWeights.E + "kg"}</p>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                        <p className="">수수료</p>
                                                        <input className="wd-30pc ht-25 text-right m-a-all-none"
                                                               type={"text"} placeholder="0" disabled
                                                               value={parseFloat(box.netWeight) > 30 || getVolumeWeightEms(box.width, box.height, box.length) > 30 ? "-" : box.netWeight ? "\u20A9 " + parseInt(boxEmsResultFees[index]).toLocaleString() : "-"}
                                                               onChange={(e) => {
                                                                   const newValue = e.target.value.replace(/,/g, '');
                                                                   if (/^\d*$/.test(newValue)) {
                                                                       const updatedBoxEmsResultFees = [...boxEmsResultFees];
                                                                       updatedBoxEmsResultFees[index] = newValue * appliedWeights.E * 10;
                                                                       setBoxEmsResultFees(updatedBoxEmsResultFees);
                                                                       setEfeeCheckbox(newValue !== "" && parseInt(newValue) !== 0);
                                                                       if (newValue !== "" && parseInt(newValue) !== 0) {
                                                                           setEmsAmount(true);
                                                                       }
                                                                   }
                                                               }}
                                                        />
                                                    </div>
                                                    <div
                                                        className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                        <p className="">배송료</p>
                                                        <p>{parseFloat(box.netWeight) > 30 || getVolumeWeightEms(box.width, box.height, box.length) > 30 ? "-" : "\u20A9 " + getAmountForWeight(box.appliedWeights.E, emsExData).toLocaleString()}</p>
                                                    </div>
                                                    <div
                                                        className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                        <p className="">관부가세선납</p>
                                                        <p className="">{"\u20A9 "}{postOfficeCusPrepay.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</p>
                                                    </div>
                                                    <div style={{marginTop: "5px"}}
                                                         className="display-flex flex-row just-cont-sb wd-100pc font-t-title">
                                                        <p className="">총배송비용</p>
                                                        <input
                                                            className="wd-30pc ht-25 text-right font-b font-c-btorage m-a-all-none"
                                                            type="text" disabled
                                                            value={parseFloat(box.netWeight) > 30 || getVolumeWeightEms(box.width, box.height, box.length) > 30 ? "-"
                                                                : "\u20A9 " + (getAmountForWeight(box.appliedWeights.E, emsExData) + parseInt(boxEmsResultFees[index]) + numericPostOfficeCusPrepay).toLocaleString()}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            {/*EMSP*/}
                                            {parseFloat(box.netWeight) <= 70 && getVolumeWeightEms(box.width, box.height, box.length) <= 70 && (
                                                <div
                                                    className="display-flex flex-column wd-100pc m-a-reg-box-price m-t-10 p-t-5 p-b-5">
                                                    <div className="display-flex flex-row just-cont-sb wd-100pc">
                                                        <div className="display-flex flex-row align-center">
                                                            <span style={{
                                                                width: "15px",
                                                                marginRight: "4px",
                                                                height: "1px",
                                                                backgroundColor: "#d5d5d5"
                                                            }}></span>
                                                            <p className="font-t-title font-s-16"
                                                               style={{color: "#FFAF34", fontStyle: "italic"}}>EMSP</p>
                                                            <span style={{
                                                                width: "15px",
                                                                marginLeft: "4px",
                                                                height: "1px",
                                                                backgroundColor: "#d5d5d5"
                                                            }}></span>
                                                        </div>
                                                        <div className="display-flex flex-row font-s-15">
                                                            <p className="">{getVolumeWeightEms(box.width, box.height, box.length) + "kg"}</p>
                                                            <p className="m-l-4 m-r-5">/</p>
                                                            <p className="font-b">{box.appliedWeights.EP + "kg"}</p>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                        <p className="">수수료</p>
                                                        <input className="wd-30pc ht-25 text-right m-a-all-none"
                                                               type={"text"} placeholder="0" disabled
                                                               value={parseFloat(box.netWeight) > 70 || getVolumeWeightEms(box.width, box.height, box.length) > 70 ? "-" : box.netWeight ? "\u20A9 " + parseInt(boxEmsPreResultFees[index]).toLocaleString() : "-"}
                                                               onChange={(e) => {
                                                                   const newValue = e.target.value.replace(/,/g, '');
                                                                   if (/^\d*$/.test(newValue)) {
                                                                       const updatedBoxEmsResultFees = [...boxEmsPreResultFees];
                                                                       updatedBoxEmsResultFees[index] = newValue * appliedWeights.EP * 10;
                                                                       setBoxEmsPreResultFees(updatedBoxEmsResultFees);
                                                                       setEfeeCheckbox(newValue !== "" && parseInt(newValue) !== 0);
                                                                       if (newValue !== "" && parseInt(newValue) !== 0) {
                                                                           setEmsAmount(true);
                                                                       }
                                                                   }
                                                               }}
                                                        />
                                                    </div>
                                                    <div
                                                        className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                        <p className="">배송료</p>
                                                        <p>{parseFloat(box.netWeight) > 70 || getVolumeWeightEms(box.width, box.height, box.length) > 70 ? "-" : "\u20A9 " + getAmountForWeight(box.appliedWeights.EP, emsPreExData).toLocaleString()}</p>
                                                    </div>
                                                    <div
                                                        className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                        <p className="">관부가세선납</p>
                                                        <p className="">0</p>
                                                    </div>
                                                    <div style={{marginTop: "5px"}}
                                                         className="display-flex flex-row just-cont-sb wd-100pc font-t-title">
                                                        <p className="">총배송비용</p>
                                                        <input
                                                            className="wd-30pc ht-25 text-right font-b font-c-btorage m-a-all-none"
                                                            type="text" disabled
                                                            value={parseFloat(box.netWeight) > 70 || getVolumeWeightEms(box.width, box.height, box.length) > 70 ? "-"
                                                                : "\u20A9 " + (getAmountForWeight(box.appliedWeights.EP, emsPreExData) + parseInt(boxEmsPreResultFees[index])).toLocaleString()}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            {/*K-Packet*/}
                                            {parseFloat(box.netWeight) <= 2 && getVolumeWeightEms(box.width, box.height, box.length) <= 2 && (
                                                <div
                                                    className="display-flex flex-column wd-100pc m-a-reg-box-price m-t-10 p-t-5 p-b-5">
                                                    <div className="display-flex flex-row just-cont-sb wd-100pc">
                                                        <div className="display-flex flex-row align-center">
                                                            <span style={{
                                                                width: "15px",
                                                                marginRight: "4px",
                                                                height: "1px",
                                                                backgroundColor: "#d5d5d5"
                                                            }}></span>
                                                            <p className="font-t-title font-s-16" style={{
                                                                color: "#FFAF34",
                                                                fontStyle: "italic"
                                                            }}>K-Packet</p>
                                                            <span style={{
                                                                width: "15px",
                                                                marginLeft: "4px",
                                                                height: "1px",
                                                                backgroundColor: "#d5d5d5"
                                                            }}></span>
                                                        </div>
                                                        <div className="display-flex flex-row font-s-15">
                                                            <p className="">{getVolumeWeightEms(box.width, box.height, box.length) + "kg"}</p>
                                                            <p className="m-l-4 m-r-5">/</p>
                                                            <p className="font-b">{box.appliedWeights.K + "kg"}</p>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                        <p className="">수수료</p>
                                                        <input className="wd-30pc ht-25 text-right m-a-all-none"
                                                               type={"text"} placeholder="0" disabled
                                                               value={parseFloat(box.netWeight) > 2 || getVolumeWeightEms(box.width, box.height, box.length) > 2 ? "-" : box.netWeight ? "\u20A9 " + parseInt(boxKpResultFees[index]).toLocaleString() : "-"}
                                                               onChange={(e) => {
                                                                   const newValue = e.target.value.replace(/,/g, '');
                                                                   if (/^\d*$/.test(newValue)) {
                                                                       const updatedBoxKpResultFees = [...boxKpResultFees];
                                                                       updatedBoxKpResultFees[index] = newValue * appliedWeights.K * 10
                                                                       setBoxKpResultFees(updatedBoxKpResultFees);
                                                                   }
                                                               }}
                                                        />
                                                    </div>
                                                    <div
                                                        className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                        <p className="">배송료</p>
                                                        {/*<p>{parseFloat(box.netWeight) > 2 || box.appliedWeights.E > 2 ? "-" : "\u20A9 " + getAmountForWeight(box.appliedWeights.K, kpExData).toLocaleString()}</p>*/}
                                                        <p>{parseFloat(box.netWeight) > 2 || getVolumeWeightEms(box.width, box.height, box.length) > 2 ? "-" : "\u20A9 " + getAmountForWeight(box.appliedWeights.K, kpExData).toLocaleString()}</p>
                                                    </div>
                                                    <div
                                                        className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                        <p className="">관부가세선납</p>
                                                        <p className="">{"\u20A9 "}{postOfficeCusPrepay.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</p>
                                                    </div>
                                                    <div style={{marginTop: "5px"}}
                                                         className="display-flex flex-row just-cont-sb wd-100pc font-t-title">
                                                        <p className="">총배송비용</p>
                                                        <input
                                                            className="wd-30pc ht-25 text-right font-b font-c-btorage m-a-all-none"
                                                            type="text" disabled
                                                            // value={parseFloat(box.netWeight) > 2 || box.appliedWeights.E > 2 ? "-"
                                                            //     : "\u20A9 " + (getAmountForWeight(box.appliedWeights.K, kpExData) + parseInt(boxKpResultFees[index])).toLocaleString()}
                                                            value={parseFloat(box.netWeight) > 2 || getVolumeWeightEms(box.width, box.height, box.length) > 2 ? "-"
                                                                : "\u20A9 " + (getAmountForWeight(box.appliedWeights.K, kpExData) + parseInt(boxKpResultFees[index]) + numericPostOfficeCusPrepay).toLocaleString()}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            {/*Small-Packet*/}
                                            {parseFloat(box.netWeight) <= 2 && (
                                                <div
                                                    className="display-flex flex-column wd-100pc m-a-reg-box-price m-t-10 p-t-5 p-b-5">
                                                    <div className="display-flex flex-row just-cont-sb wd-100pc">
                                                        <div className="display-flex flex-row align-center">
                                                            <span style={{
                                                                width: "15px",
                                                                marginRight: "4px",
                                                                height: "1px",
                                                                backgroundColor: "#d5d5d5"
                                                            }}></span>
                                                            <p className="font-t-title font-s-16" style={{
                                                                color: "#FFAF34",
                                                                fontStyle: "italic"
                                                            }}>Small-Packet</p>
                                                            <span style={{
                                                                width: "15px",
                                                                marginLeft: "4px",
                                                                height: "1px",
                                                                backgroundColor: "#d5d5d5"
                                                            }}></span>
                                                        </div>
                                                        <div className="display-flex flex-row font-s-15">
                                                            <p className="font-b">{box.appliedWeights.A + "kg"}</p>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                        <p className="">수수료</p>
                                                        <input className="wd-30pc ht-25 text-right m-a-all-none"
                                                               type={"text"} placeholder="0" disabled
                                                               value={parseFloat(box.netWeight) > 2 ? "-" : boxAsResultFees[index] > 0 ? "\u20A9 " + parseInt(boxAsResultFees[index]).toLocaleString() : "-"}
                                                               onChange={(e) => {
                                                                   const newValue = e.target.value.replace(/,/g, '');
                                                                   if (/^\d*$/.test(newValue)) {
                                                                       const updatedBoxAsResultFees = [...boxAsResultFees];
                                                                       updatedBoxAsResultFees[index] = newValue * appliedWeights.A * 10;
                                                                       setBoxAsResultFees(updatedBoxAsResultFees);
                                                                   }
                                                               }}
                                                        />

                                                    </div>
                                                    <div
                                                        className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                        <p className="">배송료</p>
                                                        <p>{parseFloat(box.netWeight) > 2 ? "-" : "\u20A9 " + getAmountForWeight(box.appliedWeights.A, asExData).toLocaleString()}</p>
                                                    </div>
                                                    <div
                                                        className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                        <p className="">관부가세선납</p>
                                                        <p className="">{"\u20A9 "}{postOfficeCusPrepay.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</p>
                                                    </div>
                                                    <div style={{marginTop: "5px"}}
                                                         className="display-flex flex-row just-cont-sb wd-100pc font-t-title">
                                                        <p className="">총배송비용</p>
                                                        <input
                                                            className="wd-30pc ht-25 text-right font-b font-c-btorage m-a-all-none"
                                                            type="text" disabled
                                                            value={parseFloat(box.netWeight) > 2 ? "-"
                                                                : "\u20A9 " + (getAmountForWeight(box.appliedWeights.A, asExData) + parseInt(boxAsResultFees[index]) + numericPostOfficeCusPrepay).toLocaleString()}/>
                                                    </div>
                                                </div>
                                            )}
                                            {/*SEA*/}
                                            {parseFloat(box.netWeight) <= 20 && (
                                                <div
                                                    className="display-flex flex-column wd-100pc m-a-reg-box-price m-t-10 p-t-5 p-b-5">
                                                    <div className="display-flex flex-row just-cont-sb wd-100pc">
                                                        <div className="display-flex flex-row align-center">
                                                            <span style={{
                                                                width: "15px",
                                                                marginRight: "4px",
                                                                height: "1px",
                                                                backgroundColor: "#d5d5d5"
                                                            }}></span>
                                                            <p className="font-t-title font-s-16"
                                                               style={{color: "#FFAF34", fontStyle: "italic"}}>SEA</p>
                                                            <span style={{
                                                                width: "15px",
                                                                marginLeft: "4px",
                                                                height: "1px",
                                                                backgroundColor: "#d5d5d5"
                                                            }}></span>
                                                        </div>
                                                        <div className="display-flex flex-row font-s-15"><p
                                                            className="font-b">{box.appliedWeights.S + "kg"}</p></div>
                                                    </div>
                                                    <div
                                                        className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                        <p className="">수수료</p>
                                                        <input className="wd-100 ht-25 text-right m-a-all-none"
                                                               type={"text"} placeholder="0" disabled
                                                               value={parseFloat(box.netWeight) > 20 ? "-" : boxSeaResultFees[index] > 0 ? "\u20A9 " + parseInt(boxSeaResultFees[index]).toLocaleString() : "-"}
                                                               onChange={(e) => {
                                                                   const newValue = e.target.value.replace(/,/g, '');
                                                                   if (/^\d*$/.test(newValue)) {
                                                                       const updatedBoxSeaResultFees = [...boxSeaResultFees];
                                                                       updatedBoxSeaResultFees[index] = newValue * appliedWeights.S * 10;
                                                                       setBoxSeaResultFees(updatedBoxSeaResultFees);
                                                                   }
                                                               }}
                                                        />
                                                    </div>
                                                    <div
                                                        className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                        <p className="">배송료</p>
                                                        <p>{parseFloat(box.netWeight) > 20 ? "-" : "\u20A9 " + getAmountForWeight(box.appliedWeights.S, shipExData).toLocaleString()}</p>
                                                    </div>
                                                    <div
                                                        className="display-flex flex-row just-cont-sb wd-100pc font-t-cont font-s-13">
                                                        <p className="">관부가세선납</p>
                                                        <p className="">{"\u20A9 "}{postOfficeCusPrepay.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</p>
                                                    </div>
                                                    <div style={{marginTop: "5px"}}
                                                         className="display-flex flex-row just-cont-sb wd-100pc font-t-title">
                                                        <p className="">총배송비용</p>
                                                        <input
                                                            className="wd-30pc ht-25 text-right font-b font-c-btorage m-a-all-none"
                                                            type="text" disabled
                                                            value={parseFloat(box.netWeight) > 20 ? "-"
                                                                : "\u20A9 " + (getAmountForWeight(box.appliedWeights.S, shipExData) + parseInt(boxSeaResultFees[index]) + numericPostOfficeCusPrepay).toLocaleString()}/>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                    :
                    null
                }

                <div ref={assignRef} className={`m-t-20 ${assignError ? "error-highlight" : ""}`}>
                <div className="m-a-open-bar m-a-open-bar-pc p-l-20 p-r-20  c-point"
                         onClick={() => setShowItemInputs(!showItemInputs)}>
                        <p className={`font-t-title font-s-14 ${assignError ? "error-text-glow" : ""}`}>상품할당</p>
                        {assignErrorMsg && (<p className="font-s-13 font-c-cancel">상품을 할당하세요</p>)}
                        {showItemInputs ?
                            <i className="m-a-ord-accordion-icon" style={{transform: "rotate(90deg)"}}/> :
                            <i className="m-a-ord-accordion-icon"></i>
                        }
                    </div>
                    {showItemInputs && (
                        <div className="m-a-top-border-card wd-100pc font-t-cont">
                            <div className="m-a-tb-frame-b ht-350">
                                <div className="m-a-div-tb">
                                    <div className="m-a-div-tb-head-b ht-35 font-s-13">
                                        <div className="wd-10pc">
                                            {/*<input className="admin-input-chkBox-s m-0-a"*/}
                                            {/*       type="checkbox"*/}
                                            {/*       checked={*/}
                                            {/*           (orderData.dataType === "orderdt"*/}
                                            {/*                   ? orderData.productsDTO*/}
                                            {/*                   : orderData.packListDTO.productsDTO*/}
                                            {/*           )?.some(item => item.prodSt === "IS05" || item.prodSt === "IS06") && checked*/}
                                            {/*       }*/}
                                            {/*       onChange={allcheckBoxChange}/>*/}
                                            <input className="admin-input-chkBox-s m-0-a"
                                                   type="checkbox"
                                                   onChange={handleAllCheck}
                                                   checked={isAllChecked}
                                            />
                                        </div>
                                        <div className="wd-15pc"><p>번호</p></div>
                                        <div className="wd-35pc"><p>품명&운송장</p></div>
                                        <div className="wd-20pc"><p>상태구분</p></div>
                                        <div className="wd-20pc"><p>박스번호</p></div>
                                    </div>
                                    {(orderData.dataType === "orderdt" ? orderData.productsDTO : orderData.packListDTO.productsDTO)?.sort((a, b) => a.seqnum - b.seqnum).map((item, i) => (
                                        <div key={i} className="m-a-div-tb-body-b ht-45">
                                            <div className="wd-10pc">
                                                {/*<input className="admin-input-chkBox-s m-0-a"*/}
                                                {/*       type="checkbox"*/}
                                                {/*       name={item.seqnum}*/}
                                                {/*       checked={(item?.prodSt === "IS05" || item?.prodSt === "IS06") && boxData[selectedBoxIndex[i]]?.products.includes(item.seqnum)}*/}
                                                {/*       onChange={() => handleBoxSelection(i, selectedBoxIndex[i])}*/}
                                                {/*       disabled={item?.prodSt !== "IS05" && item?.prodSt !== "IS06"}/>*/}
                                                <input className="admin-input-chkBox-s m-0-a" type="checkbox" name={item.seqnum}
                                                       checked={checkedItems.includes(item.seqnum)}
                                                       onChange={(e) =>
                                                           handleSingleCheck(item.seqnum, e.target.checked, item.prodSt)
                                                       }
                                                       disabled={item.prodSt !== "IS05" && item.prodSt !== "IS06"}
                                                />
                                            </div>
                                            <div className="wd-15pc font-s-14"><p>{i + 1}</p></div>
                                            <div className="wd-35pc font-s-12 text-center"><p className="m-a-text-cut">{item?.name}</p></div>
                                            <div className="wd-20pc"><a className="font-b font-s-13">{prodStPrint(item?.prodSt)}</a></div>
                                            <div className="wd-20pc align-center">
                                                {/*{(item?.prodSt === "IS05" || item?.prodSt === "IS06") && (*/}
                                                {/*    <select className="admin-combo wd-80 font-s-13 ht-25 font-b" value={selectedBoxIndex[i]}*/}
                                                {/*            onChange={e => handleBoxSelection(i, parseInt(e.target.value))}>*/}
                                                {/*        {boxData.map((box, j) => (*/}
                                                {/*            <option key={j} value={j}>*/}
                                                {/*                Box {j + 1}*/}
                                                {/*            </option>*/}
                                                {/*        ))}*/}
                                                {/*    </select>*/}
                                                {/*)}*/}
                                                {(item?.prodSt === "IS05" || item?.prodSt === "IS06") && (
                                                    // <select className="admin-combo wd-80 font-s-13 ht-25 font-b" value={setCheckedItems[i]}
                                                    //         onChange={e => handleSingleCheck(i, parseInt(e.target.value))}>
                                                    //     {boxData.map((box, j) => (
                                                    //         <option key={j} value={j}>
                                                    //             Box {j + 1}
                                                    //         </option>
                                                    //     ))}
                                                    // </select>
                                                    <select className="admin-combo wd-80 font-s-13 ht-25 font-b"
                                                            value={productBoxMap[item.seqnum] ?? 0}
                                                            onChange={(e) => handleBoxSelectChange(item.seqnum, parseInt(e.target.value))}
                                                    >
                                                        {boxData.map((box, j) => (
                                                            <option key={j} value={j}>Box {j + 1}</option>
                                                        ))}
                                                    </select>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                { selectedShipCompany === "국내배송" && tables.length > 0 && tables.length === tableCount - 1 ?
                    <div className="display-flex flex-column font-c-default m-t-20">
                        <div className="m-a-open-bar p-l-20 p-r-20">
                            <p className="font-t-title font-s-14">총배송비용[전체박스]</p>
                            <i className="m-a-ord-accordion-icon" style={{transform: "rotate(90deg)"}}/>
                        </div>
                        <div className="m-a-top-border-card display-flex flex-column wd-100pc">
                            <div className="display-flex flex-column wd-100pc">
                                <div className="display-flex flex-row just-cont-sb wd-100pc font-t-title p-t-3 p-b-3">
                                    <p className="">국내배송</p>
                                    <p className="font-c-btorage">{calculateTotalDOMECost()}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    selectedShipCompany !== "국내배송" && tables.length > 0 && tables.length === tableCount - 1 ?
                    <div className="display-flex flex-column font-c-default m-t-20">
                        <div className="m-a-open-bar p-l-20 p-r-20">
                            <p className="font-t-title font-s-14">총배송비용[전체박스]</p>
                            <i className="m-a-ord-accordion-icon" style={{transform: "rotate(90deg)"}}/>
                        </div>
                        <div className="m-a-top-border-card display-flex flex-column wd-100pc">
                            <div className="display-flex flex-column wd-100pc">
                                <div className="display-flex flex-row just-cont-sb wd-100pc font-t-title p-t-3 p-b-3">
                                    <p className="">FedEx</p>
                                    <p className="font-c-btorage">{calculateTotalFEDEXCost()}</p>
                                </div>
                                <div className="display-flex flex-row just-cont-sb wd-100pc font-t-title p-t-3 p-b-3">
                                    <p className="">FedEx-E</p>
                                    <p className="font-c-btorage">{calculateTotalFEDEXECost()}</p>
                                </div>
                                <div className="display-flex flex-row just-cont-sb wd-100pc font-t-title p-t-3 p-b-3">
                                    <p className="">UPS</p>
                                    <p className="font-c-btorage">{calculateTotalUPSCost()}</p>
                                </div>
                                <div className="display-flex flex-row just-cont-sb wd-100pc font-t-title p-t-3 p-b-3">
                                    <p className="">UPS-E</p>
                                    <p className="font-c-btorage">{calculateTotalUPSECost()}</p>
                                </div>
                                <div className="display-flex flex-row just-cont-sb wd-100pc font-t-title p-t-3 p-b-3">
                                    <p className="">EMS</p>
                                    <p className="font-c-btorage">{calculateTotalEMSCost()}</p>
                                </div>
                                <div className="display-flex flex-row just-cont-sb wd-100pc font-t-title p-t-3 p-b-3">
                                    <p className="">EMSP</p>
                                    <p className="font-c-btorage">{calculateTotalEMSPCost()}</p>
                                </div>
                                <div className="display-flex flex-row just-cont-sb wd-100pc font-t-title p-t-3 p-b-3">
                                    <p className="">SEA</p>
                                    <p className="font-c-btorage">{calculateTotalSHIPCost()}</p>
                                </div>
                                <div className="display-flex flex-row just-cont-sb wd-100pc font-t-title p-t-3 p-b-3">
                                    <p className="">Small-Packet</p>
                                    <p className="font-c-btorage">{calculateTotalAIRSCost()}</p>
                                </div>
                                <div className="display-flex flex-row just-cont-sb wd-100pc font-t-title p-t-3 p-b-3">
                                    <p className="">K-Packet</p>
                                    <p className="font-c-btorage">{calculateTotalKPACKCost()}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                        :
                        null
                }
            </div>

            <div className="an-footer-frame display-flex flex-row just-cont-center align-center">
                {orderData.type === 'orderdt' && (
                    <div>
                        <button className="admin-btn-A wd-100 ht-35 font-s-13 btn-click-event m-r-8" onClick={regExit}>닫기</button>
                        <button className="admin-btn-C wd-100 ht-35 font-s-13 btn-click-event" id="expRegComplete" disabled={isLoading} onClick={handleAlert}>등록완료</button>
                    </div>
                )}
                {orderData.type === 'payinfo' && (
                    <div>
                        <button className="admin-btn-A wd-100 ht-35 font-s-13 btn-click-event m-r-8" onClick={regExit}>닫기</button>
                        <button className="admin-btn-C wd-100 ht-35 font-s-13 btn-click-event" disabled={isLoading} onClick={alert3}>저장</button>
                    </div>
                )}
            </div>
            {isLoading && <CommonLoading/>}
            {alertShow ?
                <MsgSelectModal alertShow={alertShow} eventHandle1={modalCancel1} eventHandle2={expRegComplete}
                                msgData1={msgConfirmData1} msgData2={msgConfirmData2}/> : null}
            {alertShow3  ?
                <MsgSelectModal alertShow={alertShow3} eventHandle1={modalCancel3} eventHandle2={expRegComplete}
                                msgData1={msgConfirmData5} msgData2={msgConfirmData6}/> : null}
            {cusDataInputError ?
            <MsgCheckModal cusDataInputError={cusDataInputError} closeCusDataInputError={closeCusDataInputError}/> : null}
            {/* [개선5] 30kg 초과 시 4개 특송사 직접입력 배송료 누락 경고 */}
            {expressFeeInputError ?
                <MsgCheckModal expressFeeInputError={expressFeeInputError}
                               closeExpressFeeInputError={closeExpressFeeInputError}/> : null}
            {/* [개선6] 관세선납 입력폼 금액 누락 경고 (US 전용) */}
            {cusPrepayInputError ?
                <MsgCheckModal cusPrepayInputError={cusPrepayInputError}
                               cusPrepayInputErrorMsg={cusPrepayInputErrorMsg}
                               closeCusPrepayInputError={closeCusPrepayInputError}/> : null}
        </div>
    );
}

export default AdminRegModal
